/*
 * Copyright (c) 2017 Avaya Inc. All rights reserved.
 */
var CryptoJS =
  CryptoJS ||
  (function (z, d) {
    var f = {},
      h = (f.lib = {}),
      e = function () {},
      b = (h.Base = {
        extend: function (a) {
          e.prototype = this;
          var g = new e();
          a && g.mixIn(a);
          g.hasOwnProperty("init") ||
            (g.init = function () {
              g.$super.init.apply(this, arguments);
            });
          g.init.prototype = g;
          g.$super = this;
          return g;
        },
        create: function () {
          var a = this.extend();
          a.init.apply(a, arguments);
          return a;
        },
        init: function () {},
        mixIn: function (a) {
          for (var g in a) {
            a.hasOwnProperty(g) && (this[g] = a[g]);
          }
          a.hasOwnProperty("toString") && (this.toString = a.toString);
        },
        clone: function () {
          return this.init.prototype.extend(this);
        },
      }),
      c = (h.WordArray = b.extend({
        init: function (a, g) {
          a = this.words = a || [];
          this.sigBytes = g != d ? g : 4 * a.length;
        },
        toString: function (a) {
          return (a || y).stringify(this);
        },
        concat: function (k) {
          var n = this.words,
            l = k.words,
            m = this.sigBytes;
          k = k.sigBytes;
          this.clamp();
          if (m % 4) {
            for (var p = 0; p < k; p++) {
              n[(m + p) >>> 2] |=
                ((l[p >>> 2] >>> (24 - 8 * (p % 4))) & 255) <<
                (24 - 8 * ((m + p) % 4));
            }
          } else {
            if (65535 < l.length) {
              for (p = 0; p < k; p += 4) {
                n[(m + p) >>> 2] = l[p >>> 2];
              }
            } else {
              n.push.apply(n, l);
            }
          }
          this.sigBytes += k;
          return this;
        },
        clamp: function () {
          var a = this.words,
            g = this.sigBytes;
          a[g >>> 2] &= 4294967295 << (32 - 8 * (g % 4));
          a.length = z.ceil(g / 4);
        },
        clone: function () {
          var a = b.clone.call(this);
          a.words = this.words.slice(0);
          return a;
        },
        random: function (g) {
          for (var l = [], k = 0; k < g; k += 4) {
            l.push((4294967296 * z.random()) | 0);
          }
          return new c.init(l, g);
        },
      })),
      w = (f.enc = {}),
      y = (w.Hex = {
        stringify: function (l) {
          var m = l.words;
          l = l.sigBytes;
          for (var q = [], p = 0; p < l; p++) {
            var n = (m[p >>> 2] >>> (24 - 8 * (p % 4))) & 255;
            q.push((n >>> 4).toString(16));
            q.push((n & 15).toString(16));
          }
          return q.join("");
        },
        parse: function (k) {
          for (var l = k.length, n = [], m = 0; m < l; m += 2) {
            n[m >>> 3] |= parseInt(k.substr(m, 2), 16) << (24 - 4 * (m % 8));
          }
          return new c.init(n, l / 2);
        },
      }),
      o = (w.Latin1 = {
        stringify: function (k) {
          var l = k.words;
          k = k.sigBytes;
          for (var n = [], m = 0; m < k; m++) {
            n.push(
              String.fromCharCode((l[m >>> 2] >>> (24 - 8 * (m % 4))) & 255)
            );
          }
          return n.join("");
        },
        parse: function (k) {
          for (var l = k.length, n = [], m = 0; m < l; m++) {
            n[m >>> 2] |= (k.charCodeAt(m) & 255) << (24 - 8 * (m % 4));
          }
          return new c.init(n, l);
        },
      }),
      x = (w.Utf8 = {
        stringify: function (a) {
          try {
            return decodeURIComponent(escape(o.stringify(a)));
          } catch (k) {
            throw Error("Malformed UTF-8 data");
          }
        },
        parse: function (a) {
          return o.parse(unescape(encodeURIComponent(a)));
        },
      }),
      j = (h.BufferedBlockAlgorithm = b.extend({
        reset: function () {
          this._data = new c.init();
          this._nDataBytes = 0;
        },
        _append: function (a) {
          "string" == typeof a && (a = x.parse(a));
          this._data.concat(a);
          this._nDataBytes += a.sigBytes;
        },
        _process: function (p) {
          var r = this._data,
            u = r.words,
            t = r.sigBytes,
            s = this.blockSize,
            n = t / (4 * s),
            n = p ? z.ceil(n) : z.max((n | 0) - this._minBufferSize, 0);
          p = n * s;
          t = z.min(4 * p, t);
          if (p) {
            for (var q = 0; q < p; q += s) {
              this._doProcessBlock(u, q);
            }
            q = u.splice(0, p);
            r.sigBytes -= t;
          }
          return new c.init(q, t);
        },
        clone: function () {
          var a = b.clone.call(this);
          a._data = this._data.clone();
          return a;
        },
        _minBufferSize: 0,
      }));
    h.Hasher = j.extend({
      cfg: b.extend(),
      init: function (a) {
        this.cfg = this.cfg.extend(a);
        this.reset();
      },
      reset: function () {
        j.reset.call(this);
        this._doReset();
      },
      update: function (a) {
        this._append(a);
        this._process();
        return this;
      },
      finalize: function (a) {
        a && this._append(a);
        return this._doFinalize();
      },
      blockSize: 16,
      _createHelper: function (a) {
        return function (k, l) {
          return new a.init(l).finalize(k);
        };
      },
      _createHmacHelper: function (a) {
        return function (k, l) {
          return new i.HMAC.init(a, l).finalize(k);
        };
      },
    });
    var i = (f.algo = {});
    return f;
  })(Math);
(function (o) {
  function d(r, s, p, u, q, t, n) {
    r = r + ((s & p) | (~s & u)) + q + n;
    return ((r << t) | (r >>> (32 - t))) + s;
  }
  function f(r, s, p, u, q, t, n) {
    r = r + ((s & u) | (p & ~u)) + q + n;
    return ((r << t) | (r >>> (32 - t))) + s;
  }
  function g(r, s, p, u, q, t, n) {
    r = r + (s ^ p ^ u) + q + n;
    return ((r << t) | (r >>> (32 - t))) + s;
  }
  function e(r, s, p, u, q, t, n) {
    r = r + (p ^ (s | ~u)) + q + n;
    return ((r << t) | (r >>> (32 - t))) + s;
  }
  for (
    var b = CryptoJS,
      c = b.lib,
      i = c.WordArray,
      k = c.Hasher,
      c = b.algo,
      h = [],
      j = 0;
    64 > j;
    j++
  ) {
    h[j] = (4294967296 * o.abs(o.sin(j + 1))) | 0;
  }
  c = c.MD5 = k.extend({
    _doReset: function () {
      this._hash = new i.init([1732584193, 4023233417, 2562383102, 271733878]);
    },
    _doProcessBlock: function (Q, N) {
      for (var V = 0; 16 > V; V++) {
        var P = N + V,
          n = Q[P];
        Q[P] =
          (((n << 8) | (n >>> 24)) & 16711935) |
          (((n << 24) | (n >>> 8)) & 4278255360);
      }
      var V = this._hash.words,
        P = Q[N + 0],
        n = Q[N + 1],
        O = Q[N + 2],
        L = Q[N + 3],
        J = Q[N + 4],
        H = Q[N + 5],
        F = Q[N + 6],
        E = Q[N + 7],
        p = Q[N + 8],
        m = Q[N + 9],
        l = Q[N + 10],
        a = Q[N + 11],
        M = Q[N + 12],
        K = Q[N + 13],
        I = Q[N + 14],
        G = Q[N + 15],
        U = V[0],
        T = V[1],
        S = V[2],
        R = V[3],
        U = d(U, T, S, R, P, 7, h[0]),
        R = d(R, U, T, S, n, 12, h[1]),
        S = d(S, R, U, T, O, 17, h[2]),
        T = d(T, S, R, U, L, 22, h[3]),
        U = d(U, T, S, R, J, 7, h[4]),
        R = d(R, U, T, S, H, 12, h[5]),
        S = d(S, R, U, T, F, 17, h[6]),
        T = d(T, S, R, U, E, 22, h[7]),
        U = d(U, T, S, R, p, 7, h[8]),
        R = d(R, U, T, S, m, 12, h[9]),
        S = d(S, R, U, T, l, 17, h[10]),
        T = d(T, S, R, U, a, 22, h[11]),
        U = d(U, T, S, R, M, 7, h[12]),
        R = d(R, U, T, S, K, 12, h[13]),
        S = d(S, R, U, T, I, 17, h[14]),
        T = d(T, S, R, U, G, 22, h[15]),
        U = f(U, T, S, R, n, 5, h[16]),
        R = f(R, U, T, S, F, 9, h[17]),
        S = f(S, R, U, T, a, 14, h[18]),
        T = f(T, S, R, U, P, 20, h[19]),
        U = f(U, T, S, R, H, 5, h[20]),
        R = f(R, U, T, S, l, 9, h[21]),
        S = f(S, R, U, T, G, 14, h[22]),
        T = f(T, S, R, U, J, 20, h[23]),
        U = f(U, T, S, R, m, 5, h[24]),
        R = f(R, U, T, S, I, 9, h[25]),
        S = f(S, R, U, T, L, 14, h[26]),
        T = f(T, S, R, U, p, 20, h[27]),
        U = f(U, T, S, R, K, 5, h[28]),
        R = f(R, U, T, S, O, 9, h[29]),
        S = f(S, R, U, T, E, 14, h[30]),
        T = f(T, S, R, U, M, 20, h[31]),
        U = g(U, T, S, R, H, 4, h[32]),
        R = g(R, U, T, S, p, 11, h[33]),
        S = g(S, R, U, T, a, 16, h[34]),
        T = g(T, S, R, U, I, 23, h[35]),
        U = g(U, T, S, R, n, 4, h[36]),
        R = g(R, U, T, S, J, 11, h[37]),
        S = g(S, R, U, T, E, 16, h[38]),
        T = g(T, S, R, U, l, 23, h[39]),
        U = g(U, T, S, R, K, 4, h[40]),
        R = g(R, U, T, S, P, 11, h[41]),
        S = g(S, R, U, T, L, 16, h[42]),
        T = g(T, S, R, U, F, 23, h[43]),
        U = g(U, T, S, R, m, 4, h[44]),
        R = g(R, U, T, S, M, 11, h[45]),
        S = g(S, R, U, T, G, 16, h[46]),
        T = g(T, S, R, U, O, 23, h[47]),
        U = e(U, T, S, R, P, 6, h[48]),
        R = e(R, U, T, S, E, 10, h[49]),
        S = e(S, R, U, T, I, 15, h[50]),
        T = e(T, S, R, U, H, 21, h[51]),
        U = e(U, T, S, R, M, 6, h[52]),
        R = e(R, U, T, S, L, 10, h[53]),
        S = e(S, R, U, T, l, 15, h[54]),
        T = e(T, S, R, U, n, 21, h[55]),
        U = e(U, T, S, R, p, 6, h[56]),
        R = e(R, U, T, S, G, 10, h[57]),
        S = e(S, R, U, T, F, 15, h[58]),
        T = e(T, S, R, U, K, 21, h[59]),
        U = e(U, T, S, R, J, 6, h[60]),
        R = e(R, U, T, S, a, 10, h[61]),
        S = e(S, R, U, T, O, 15, h[62]),
        T = e(T, S, R, U, m, 21, h[63]);
      V[0] = (V[0] + U) | 0;
      V[1] = (V[1] + T) | 0;
      V[2] = (V[2] + S) | 0;
      V[3] = (V[3] + R) | 0;
    },
    _doFinalize: function () {
      var p = this._data,
        q = p.words,
        m = 8 * this._nDataBytes,
        r = 8 * p.sigBytes;
      q[r >>> 5] |= 128 << (24 - (r % 32));
      var n = o.floor(m / 4294967296);
      q[(((r + 64) >>> 9) << 4) + 15] =
        (((n << 8) | (n >>> 24)) & 16711935) |
        (((n << 24) | (n >>> 8)) & 4278255360);
      q[(((r + 64) >>> 9) << 4) + 14] =
        (((m << 8) | (m >>> 24)) & 16711935) |
        (((m << 24) | (m >>> 8)) & 4278255360);
      p.sigBytes = 4 * (q.length + 1);
      this._process();
      p = this._hash;
      q = p.words;
      for (m = 0; 4 > m; m++) {
        (r = q[m]),
          (q[m] =
            (((r << 8) | (r >>> 24)) & 16711935) |
            (((r << 24) | (r >>> 8)) & 4278255360));
      }
      return p;
    },
    clone: function () {
      var l = k.clone.call(this);
      l._hash = this._hash.clone();
      return l;
    },
  });
  b.MD5 = k._createHelper(c);
  b.HmacMD5 = k._createHmacHelper(c);
})(Math);
(function () {
  var b = b || {};
  window.AWL = b;
  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (e) {
      if (this == null) {
        throw new TypeError();
      }
      var f = Object(this);
      var c = f.length >>> 0;
      if (c === 0) {
        return -1;
      }
      var g = 0;
      if (arguments.length > 1) {
        g = Number(arguments[1]);
        if (g != g) {
          g = 0;
        } else {
          if (g != 0 && g != Infinity && g != -Infinity) {
            g = (g > 0 || -1) * Math.floor(Math.abs(g));
          }
        }
      }
      if (g >= c) {
        return -1;
      }
      var d = g >= 0 ? g : Math.max(c - Math.abs(g), 0);
      for (; d < c; d++) {
        if (d in f && f[d] === e) {
          return d;
        }
      }
      return -1;
    };
  }
  b.namespace = function (f) {
    var e = f.split("."),
      d = b,
      c;
    if (e[0] === "AWL") {
      e = e.slice(1);
    }
    for (c = 0; c < e.length; c += 1) {
      if (typeof d[e[c]] === "undefined") {
        d[e[c]] = {};
      }
      d = d[e[c]];
    }
    return d;
  };
  b.newPackage = function (j, g) {
    if (j === "undefined" || g === "undefined") {
      throw "invalid inputs !!!";
    }
    var h = j.split(".");
    var f = window.AWL;
    var d;
    if (a(h) == false) {
      throw "invalid package name: Base package is missing !!!";
    }
    h = h.slice(3);
    var e = h[h.length - 1];
    for (d = 0; d < h.length; d += 1) {
      if (typeof f[h[d]] === "undefined") {
        if (d == h.length - 1) {
          f[h[d]] = g;
        } else {
          f[h[d]] = { dummy: "true" };
        }
      } else {
        if (d == h.length - 1) {
          if (f[h[d]] !== null && f[h[d]].hasOwnProperty("dummy")) {
            for (var c in f[h[d]]) {
              if (c !== "dummy") {
                g[c] = f[h[d]][c];
              }
            }
            f[h[d]] = g;
          } else {
            if (f[h[d]] === null) {
              f[h[d]] = g;
            } else {
              console.log(
                "non-null node already present .. some thing wrong with usage of this fucntion"
              );
            }
          }
        } else {
          if (f[h[d]].hasOwnProperty("dummy")) {
          } else {
          }
        }
      }
      f = f[h[d]];
    }
    return f;
  };
  function a(c) {
    if (c.length < 3) {
      console.log("oops !! base package name missing");
      return false;
    }
    if (c[0] === "com" && c[1] === "avaya" && c[2] == "awl") {
      return true;
    } else {
      return false;
    }
  }
  b.newPackage(
    "com.avaya.awl.utilities.env",
    (function () {
      var d = (function () {
        if (window.WebSocket) {
          return window.WebSocket;
        } else {
          if (window.MozWebSocket) {
            return window.MozWebSocket;
          } else {
            return null;
          }
        }
      })();
      var e = (function () {
        return !!document.createElement("canvas").getContext;
      })();
      var c = window.URL || window.webkitURL;
      return { WebSocket: d, canvasExists: e, URL: c };
    })()
  );
  b.newPackage(
    "com.avaya.awl.utilities.url",
    (function () {
      return {
        getURLParameter: function c(e) {
          return (
            decodeURIComponent(
              (new RegExp("[?|&]" + e + "=([^&;]+?)(&|#|;|$)").exec(
                location.search
              ) || [, ""])[1].replace(/\+/g, "%20")
            ) || null
          );
        },
        removeUrlParamter: function d(h, g) {
          var f = h.indexOf(g);
          var e = h.indexOf("&", f);
          if (e == -1) {
            e = h.length;
          }
          var i = h.substring(0, f) + h.substring(e, h.length);
          if (i.charAt(i.length - 1) === "?") {
            i = i.substring(0, i.length - 1);
          }
          return i;
        },
      };
    })()
  );
  b.newPackage(
    "com.avaya.awl.utilities.cookie",
    (function () {
      function e(h, i, j) {
        if (j) {
          var g = new Date();
          g.setTime(g.getTime() + j * 24 * 60 * 60 * 1000);
          var f = "; expires=" + g.toGMTString();
        } else {
          var f = "";
        }
        document.cookie = h + "=" + i + f + "; path=/";
      }
      function c(g) {
        var j = g + "=";
        var f = document.cookie.split(";");
        for (var h = 0; h < f.length; h++) {
          var k = f[h];
          while (k.charAt(0) == " ") {
            k = k.substring(1, k.length);
          }
          if (k.indexOf(j) == 0) {
            return k.substring(j.length, k.length);
          }
        }
        return null;
      }
      function d(f) {
        e(f, "", -1);
      }
      return { set: e, get: c, erase: d };
    })()
  );
  b.newPackage(
    "com.avaya.awl.utilities.date",
    (function () {
      var d = function (i, h) {
        var f = null;
        var e = false;
        if (!h) {
          h = new Date();
        }
        if (i === "12") {
          f = h.getHours();
          if (f >= 12) {
            f = f - 12;
            e = true;
          } else {
            if (f === 0) {
              f = 12;
            }
          }
        } else {
          f = h.getHours();
        }
        var g = "" + f + ":" + h.getMinutes();
        if (i === "12") {
          if (e) {
            g = g + " pm";
          } else {
            g = g + " am";
          }
        }
        return g;
      };
      var c = function (g) {
        var f = true;
        if (!g) {
          g = new Date();
        } else {
          var e = new Date().toDateString();
          if (e !== g.toDateString()) {
            f = false;
          }
        }
        if (f) {
          return "Today";
        } else {
          return g.toLocaleDateString();
        }
      };
      return { getFormatedTime: d, getFormatedDate: c };
    })()
  );
  b.newPackage(
    "com.avaya.awl.notification",
    (function () {
      var e = function (i) {
        var g = document.title;
        var h = setInterval(function () {
          document.title = document.title == i ? g : i;
        }, 1000);
        window.onmousemove = function () {
          clearInterval(h);
          document.title = g;
          window.onmousemove = null;
        };
      };
      var f = (function () {
        if (window.webkitNotifications) {
          return function (i, j, g) {
            if (window.webkitNotifications.checkPermission() == 0) {
              var h = window.webkitNotifications.createNotification(i, j, g);
              h.show();
              return h;
            } else {
              return null;
            }
          };
        } else {
          return function () {
            return null;
          };
        }
      })();
      var d = (function () {
        if (window.webkitNotifications) {
          return function (g) {
            if (window.webkitNotifications.checkPermission() == 0) {
              var h = window.webkitNotifications.createHTMLNotification(g);
              h.show();
              return h;
            } else {
              return null;
            }
          };
        } else {
          return function () {
            return null;
          };
        }
      })();
      var c = function () {
        if (window.webkitNotifications) {
          window.webkitNotifications.requestPermission();
        }
      };
      return { titleAlert: e, notify: f, notifyHtml: d, requestPermission: c };
    })()
  );
  b.newPackage("com.avaya.awl.console", null);
  b.newPackage(
    "com.avaya.awl.sdkLog",
    (function () {
      var f = {};
      var c = {
        debug: function () {},
        info: function () {},
        warn: function () {},
        error: function () {},
        dir: function () {},
      };
      f.enableLogging = function e() {
        b.console = console;
      };
      f.disableLogging = function d() {
        b.console = c;
      };
      return f;
    })()
  );
  b.newPackage("com.avaya.awl.clientAPIConsole", null);
  b.newPackage(
    "com.avaya.awl.clientLog",
    (function () {
      var f = {};
      var c = {
        debug: function () {},
        info: function () {},
        warn: function () {},
        error: function () {},
        dir: function () {},
      };
      f.enableLogging = function e() {
        b.clientAPIConsole = console;
      };
      f.disableLogging = function d() {
        b.clientAPIConsole = c;
      };
      return f;
    })()
  );
  b.newPackage(
    "com.avaya.awl.Event",
    (function () {
      var c = function (d) {
        this._source = d;
        this._listeners = [];
      };
      c.prototype.attach = function (d) {
        this._listeners.push(d);
      };
      c.prototype.detachAll = function () {
        this._listeners = [];
      };
      c.prototype.detach = function (e) {
        var d = this._listeners.indexOf(e);
        if (d != -1) {
          this._listeners.splice(d, 1);
        }
      };
      c.prototype.notify = function (e) {
        var g = null;
        for (var f = 0, d = this._listeners.length; f < d; f += 1) {
          g = this._listeners[f];
          if (typeof g === "function") {
            g(this._source, e);
          }
        }
      };
      return c;
    })()
  );
  b.newPackage(
    "com.avaya.awl.callBack",
    (function () {
      var c = function () {
        this._listeners = [];
      };
      c.prototype.attach = function (d) {
        this._listeners.push(d);
      };
      c.prototype.detachAll = function () {
        this._listeners = [];
      };
      c.prototype.detach = function (e) {
        var d = this._listeners.indexOf(e);
        if (d != -1) {
          this._listeners.splice(d, 1);
        }
      };
      c.prototype.notify = function (g, e, d) {
        var k = null;
        for (var h = 0, f = this._listeners.length; h < f; h += 1) {
          k = this._listeners[h];
          if (typeof k === "function") {
            if (typeof e === "undefined" && typeof d === "undefined") {
              k(g);
            } else {
              if (typeof d === "undefined") {
                k(g, e);
              } else {
                k(g, e, d);
              }
            }
          }
        }
      };
      return c;
    })()
  );
  (function () {
    if (typeof window === "object") {
      if (
        window.HTMLMediaElement &&
        !("srcObject" in window.HTMLMediaElement.prototype)
      ) {
        Object.defineProperty(window.HTMLMediaElement.prototype, "srcObject", {
          get: function () {
            return "mozSrcObject" in this ? this.mozSrcObject : this._srcObject;
          },
          set: function (c) {
            if ("mozSrcObject" in this) {
              this.mozSrcObject = c;
            } else {
              this._srcObject = c;
              if (webkitURLSupported()) {
                this.src = webkitURL.createObjectURL(c);
              } else {
                this.src = URL.createObjectURL(c);
              }
            }
          },
        });
      }
    }
  })();
  b.newPackage("com.avaya.awl.jsonRpc", null);
  b.newPackage("com.avaya.awl.wsConnection", null);
  b.newPackage("com.avaya.awl.localStream", null);
  b.newPackage("com.avaya.awl.remoteStream", null);
  b.newPackage("com.avaya.awl.videoTracks", null);
  b.newPackage("com.avaya.awl.serviceType", null);
  b.newPackage("com.avaya.awl.callMap", null);
  b.callMap = {};
  b.newPackage("com.avaya.awl.remVideo", null);
  b.newPackage("com.avaya.awl.onConfigChange", null);
  b.newPackage("com.avaya.awl.onRegistrationStateChange", null);
  b.newPackage("com.avaya.awl.onCallStateChange", null);
  b.newPackage("com.avaya.awl.onNewIncomingCall", null);
  b.newPackage("com.avaya.awl.onCallTerminate", null);
  b.newPackage("com.avaya.awl.onMakeCallObj", null);
  b.newPackage("com.avaya.awl.totalCalls", null);
  b.newPackage("com.avaya.awl.muteAllStreams", null);
  b.newPackage("com.avaya.awl.videoPaused", null);
  b.newPackage("com.avaya.awl.inUse_Version", null);
  b.newPackage("com.avaya.awl.dtmfPayLoadType", null);
  b.dtmfPayLoadType = "101";
  b.newPackage("com.avaya.awl.onAuthTokenRenewed", null);
  b.newPackage("com.avaya.awl.SDK_VERSION", null);
  b.SDK_VERSION = { v9_1: "9.1", v10_0: "10.0", v11_0: "11.0" };
  b.CLIENT_STATUS = {
    NORMAL: "NORMAL",
    FAILING_OVER: "FAILING OVER",
    FAILED_OVER: "FAILED OVER",
    FAILING_BACK: "FAILING BACK",
    FAILED_BACK: "FAILED BACK",
    LOGGED_OUT: "LOGGED_OUT",
    RECONNECTING: "RECONNECTING",
  };
})();
function onconfigStateChange(a) {}
function onRegistrationStateChange(a) {}
function onCallListener() {}
function onDeviceListRequested(a) {}
function onAuthTokenRenewed(a) {}
function webkitURLSupported() {
  var c = navigator.userAgent.indexOf("Chrome/");
  var b = navigator.userAgent.indexOf(".", c);
  var a = parseInt(navigator.userAgent.substring(c + 7, b));
  AWL.sdkLog.enableLogging();
  AWL.console.debug("Chrome version: " + a);
  AWL.sdkLog.disableLogging();
  if (a < 47) {
    return true;
  }
  return false;
}
AWL.newPackage(
  "com.avaya.awl.io.jsonRpc.utils",
  (function () {
    var a = function () {
      var c = this;
      var b = {
        MSGTYPE: {
          CLIENTREQ: {
            DEFAULT: "GeneralResponse",
            LOGIN: "loginResponse",
            LOGOUT: "logoutResponse",
            MAKECALL: "makeCallResponse",
            TRANSFERCALL: "transferCallResponse",
            ANSWERCALL: "answerCallResponse",
            REJECTCALL: "rejectCallResponse",
            ABORTCALL: "abortCallResponse",
            ENDCALL: "endCallResponse",
            HOLDCALL: "holdCallResponse",
            UNHOLDCALL: "unholdCallResponse",
            UPDATEMEDIA: "updateMediaResponse",
            ACCEPTMEDIAUPDATEREQUEST: "acceptMediaUpdateResponse",
            REJECTMEDIAUPDATEREQUEST: "rejectMediaUpdateResponse",
            ANSWEREARLYMEDIA: "answerEarlyMediaResponse",
            GETGATEWAYSETTINGS: "gatewaySettingsResponse",
            RENEWTOKEN: "renewTokenResponse",
          },
        },
        EVENT: {
          INCOMINGCALL: "IncomingCall",
          CALLPROGRESS: "CallProgressing",
          CALLCONNECTED: "CallConnected",
          CALLFAILED: "CallFailed",
          CALLDISCONNECTED: "CallDisconnected",
          CALLHELD: "CallHeld",
          CALLUNHELD: "CallUnheld",
          CALLCONTROLCTI: "CallCtiEventReceived",
          LOGINSTATUSCHANGED: "LoginStatusChanged",
          TRANSFERCOMPLETE: "CallTransferSuccessful",
          TRANSFERFAILURE: "CallTransferFailed",
          FARENDCHANGED: "FarEndChanged",
          MEDIAUPDATEREQUEST: "MediaUpdateRequest",
          GATEWAYSETTINGSCHANGED: "GatewaySettingsChanged",
          GATEWAYHAMODECHANGED: "GatewayHAModeChanged",
          UPDATE: "Update",
        },
        JSON_DEFAULT_FIELDVALUE: {
          PROTOCOL: "jsonrpc-3.0.0",
          SERVICE: "phoneservice",
        },
      };
      this.getMessageId = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (f) {
            var e = (Math.random() * 16) | 0,
              d = f == "x" ? e : (e & 3) | 8;
            return d.toString(16);
          }
        );
      };
      this.isValidMsgStruct = function (d) {
        if (
          typeof d.protocol === "undefined" ||
          typeof d.id === "undefined" ||
          typeof d.service === "undefined" ||
          typeof d.msgname === "undefined" ||
          typeof d.params === "undefined"
        ) {
          AWL.console.error("Missing mandate Json Rpc message structure");
          return false;
        }
        if (
          d.protocol !== b.JSON_DEFAULT_FIELDVALUE.PROTOCOL ||
          d.id === null ||
          d.service === "" ||
          d.msgname === "" ||
          d.params === ""
        ) {
          AWL.console.error("Incorrect Json Rpc message field value");
          return false;
        }
        return true;
      };
      this.findMatchingResp = function (d) {
        switch (d) {
          case "login":
            return b.MSGTYPE.CLIENTREQ.LOGIN;
          case "logout":
            return b.MSGTYPE.CLIENTREQ.LOGOUT;
          case "makeCall":
            return b.MSGTYPE.CLIENTREQ.MAKECALL;
          case "transferCall":
            return b.MSGTYPE.CLIENTREQ.TRANSFERCALL;
          case "answerCall":
            return b.MSGTYPE.CLIENTREQ.ANSWERCALL;
          case "rejectCall":
            return b.MSGTYPE.CLIENTREQ.REJECTCALL;
          case "abortCall":
            return b.MSGTYPE.CLIENTREQ.ABORTCALL;
          case "endCall":
            return b.MSGTYPE.CLIENTREQ.ENDCALL;
          case "holdCall":
            return b.MSGTYPE.CLIENTREQ.HOLDCALL;
          case "unholdCall":
            return b.MSGTYPE.CLIENTREQ.UNHOLDCALL;
          case "updateMedia":
            return b.MSGTYPE.CLIENTREQ.UPDATEMEDIA;
          case "acceptMediaUpdateRequest":
            return b.MSGTYPE.CLIENTREQ.ACCEPTMEDIAUPDATEREQUEST;
          case "rejectMediaUpdateRequest":
            return b.MSGTYPE.CLIENTREQ.REJECTMEDIAUPDATEREQUEST;
          case "answerEarlyMedia":
            return b.MSGTYPE.CLIENTREQ.ANSWEREARLYMEDIA;
          case "getGatewaySettings":
            return b.MSGTYPE.CLIENTREQ.GETGATEWAYSETTINGS;
          case "renewToken":
            return b.MSGTYPE.CLIENTREQ.RENEWTOKEN;
          case "gatewayHAModeChanged":
            return b.MSGTYPE.CLIENTREQ.GATEWAYHAMODECHANGED;
          default:
            return null;
        }
      };
      this.isEvent = function (d) {
        switch (d) {
          case b.EVENT.INCOMINGCALL:
          case b.EVENT.CALLPROGRESS:
          case b.EVENT.CALLCONNECTED:
          case b.EVENT.CALLHELD:
          case b.EVENT.CALLUNHELD:
          case b.EVENT.CALLFAILED:
          case b.EVENT.CALLDISPLAYNAMEUPDATED:
          case b.EVENT.CALLDISCONNECTED:
          case b.EVENT.CALLCONTROLCTI:
          case b.EVENT.LOGINSTATUSCHANGED:
          case b.EVENT.TRANSFERCOMPLETE:
          case b.EVENT.TRANSFERFAILURE:
          case b.EVENT.FARENDCHANGED:
          case b.EVENT.MEDIAUPDATEREQUEST:
          case b.EVENT.GATEWAYSETTINGSCHANGED:
          case b.EVENT.GATEWAYHAMODECHANGED:
          case b.EVENT.UPDATE:
            return true;
          default:
            AWL.console.error("Unknown Event received from GW");
            return false;
        }
      };
      this.getJSON = function () {
        return b;
      };
      this.setJsonProtocolVal = function () {
        if (
          AWL.inUse_Version === AWL.SDK_VERSION.v10_0 ||
          AWL.inUse_Version === AWL.SDK_VERSION.v9_1
        ) {
          b.JSON_DEFAULT_FIELDVALUE.PROTOCOL = "jsonrpc-2.0.0";
        } else {
          b.JSON_DEFAULT_FIELDVALUE.PROTOCOL = "jsonrpc-3.0.0";
        }
      };
      this.fillParams = function (d) {
        var e;
        switch (d[0]) {
          case "login":
            if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
              e = {
                applicationID: d[1],
                applicationUA: d[2],
                applicationInstanceID: d[3],
                userID: d[4],
                authType: d[5],
                password: d[6],
                authToken: d[7],
                bumpConnection: d[8],
              };
            } else {
              e = {
                extn: d[1],
                password: d[2],
                bumpConnection: d[3],
                tokAuth: d[4],
              };
            }
            break;
          case "logout":
            e = "NULL";
            break;
          case "makeCall":
            e = { target: d[1], callId: d[2], sdp: d[3] };
            break;
          case "transferCall":
            e = { target: d[1], callId: d[2], type: d[3] };
            break;
          case "answerCall":
          case "updateMedia":
          case "acceptMediaUpdateRequest":
          case "answerEarlyMedia":
            e = { callId: d[1], sdp: d[2] };
            break;
          case "rejectCall":
          case "abortCall":
          case "endCall":
          case "holdCall":
          case "unholdCall":
          case "rejectMediaUpdateRequest":
            e = { callId: d[1] };
            break;
          case "getGatewaySettings":
            e = { type: d[1] };
            break;
          case "renewToken":
            e = { userID: d[1], token: d[2], applicationInstanceID: d[3] };
            break;
          default:
            AWL.console.error("UNKNOWN msgname : " + d[0]);
            return null;
        }
        return e;
      };
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.io.JsonRpc_9_1version",
  (function () {
    var a = function (e) {
      var g = this;
      var c = 1;
      var d = [];
      var b = [];
      e.evtOnMessage.attach(f);
      this.attach = function (j, h, k) {
        var i = j + "." + h;
        if (b[i]) {
          AWL.console.warn("multiple listeners for event: " + i);
          delete b[i];
        }
        AWL.console.debug("listener registered for event: " + i);
        b[i] = k;
      };
      this.detach = function (j, h) {
        var i = j + "." + h;
        delete b[i];
      };
      this.call = function () {
        var k = Array.prototype.slice.call(arguments);
        if (k.length < 2) {
          AWL.console.error("not enough arguments");
          return;
        }
        var l = k[0];
        var j = k[1];
        var i = null;
        var o = null;
        if (k.length > 2) {
          if (typeof k[k.length - 1] == "function") {
            i = k.pop();
            if (k.length > 2) {
              if (typeof k[k.length - 1] == "function") {
                o = i;
                i = k.pop();
              }
            }
          }
        }
        var n = null;
        if (k.length > 2) {
          n = k.slice(2);
        }
        var m = { jsonrpc: "2.0", service: l, method: j, params: n };
        if (i) {
          m.id = c++;
          d[m.id] = { success: i, failure: o };
        }
        if (j === "login") {
          if (n != null) {
            var h = { jsonrpc: "2.0", service: l, method: j, params: n[0] };
            h = JSON.stringify(h);
            AWL.console.info("sending message: " + h);
            e.send(JSON.stringify(m), true);
          }
        } else {
          e.send(JSON.stringify(m));
        }
        return m.id;
      };
      function f(l, h) {
        AWL.console.info("evtOnMessageHandler: " + h);
        var i = JSON.parse(h);
        if (i.jsonrpc != "2.0") {
          return;
        }
        if (i.result != null) {
          if (!i.id) {
            AWL.console.error("no id for message");
            return;
          }
          var k = d[i.id];
          if (!k) {
            AWL.console.error("invalid id");
            return;
          }
          delete d[i.id];
          k.success(i.result);
          return;
        }
        if (i.error) {
          if (!i.id) {
            AWL.console.debug("ignore. no id for message");
            return;
          }
          var k = d[i.id];
          if (!k) {
            AWL.console.error("invalid id");
            return;
          }
          delete d[i.id];
          if (!k.failure) {
            AWL.console.debug("ignore. no error callback for message");
            return;
          }
          k.failure(i.error);
          return;
        }
        if (i.method) {
          var m = b[i.method];
          var j = 0;
          if (!m) {
            j = -32601;
          } else {
            m(i.params);
          }
          if (i.id) {
            var k = { jsonrpc: "2.0" };
            if (j != 0) {
              k.error = { code: j, message: "Method not found" };
            } else {
              k.result = "";
            }
            k.id = i.id;
            e.send(JSON.stringify(k));
          }
        }
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.io.JsonRpc",
  (function () {
    var a = function (d) {
      var f = [];
      var h = new AWL.io.jsonRpc.utils();
      var c = [];
      var b = false;
      var g = h.getJSON().JSON_DEFAULT_FIELDVALUE.SERVICE;
      d.evtOnMessage.attach(e);
      this.attach = function (l, k) {
        if (!b) {
          c = [];
          b = true;
        }
        var j = h.findMatchingResp(l);
        if (j === null) {
          if (h.isEvent(l)) {
            j = l;
          } else {
            AWL.console.error("Listener not attached for unknown Event : " + l);
            return;
          }
        }
        var i = g + "." + j;
        if (f[i]) {
          AWL.console.warn("multiple listeners for event: " + i);
          delete f[i];
        }
        AWL.console.debug("listener registered for event: " + i);
        f[i] = k;
      };
      this.detach = function (k) {
        if (b) {
          b = false;
        }
        var j = h.findMatchingResp(k);
        if (j === null) {
          if (h.isEvent(k)) {
            j = k;
          } else {
            AWL.console.error("Listener not attached for unknown Event : " + k);
            return;
          }
        }
        var i = g + "." + j;
        if (f[i]) {
          AWL.console.debug("Delete listeners for event: " + i);
          delete f[i];
        } else {
          AWL.console.error(
            "Listener not attached present in notification map"
          );
        }
      };
      this.setServiceType = function (i) {
        if (
          i !== "phoneservice" &&
          i !== "agentservice" &&
          i !== "relayservice"
        ) {
          AWL.console.error("Invalid service type : " + i);
          return false;
        }
        g = i;
      };
      this.setJsonProtocolVal = function () {
        h.setJsonProtocolVal();
      };
      this.sendRequest = function () {
        var k = Array.prototype.slice.call(arguments);
        if (k.length < 1) {
          AWL.console.error("Mandate Json Rpc fields missing");
          return;
        }
        var o = k[0];
        var l = h.getMessageId();
        var n = null;
        if (k.length > 1) {
          n = h.fillParams(k);
        }
        var j = {
          protocol: h.getJSON().JSON_DEFAULT_FIELDVALUE.PROTOCOL,
          id: l,
          service: g,
          msgname: o,
          params: n,
        };
        if (o === "login" || o === "renewToken") {
          var m = JSON.parse(JSON.stringify(n));
          if (o === "login") {
            delete m.password;
            if (typeof m.authToken !== "undefined" && m.authToken !== null) {
              delete m.authToken;
            }
          } else {
            if (typeof m.token !== "undefined" && m.token !== null) {
              delete m.token;
            }
          }
          var i = {
            protocol: h.getJSON().JSON_DEFAULT_FIELDVALUE.PROTOCOL,
            id: l,
            service: g,
            msgname: o,
            params: m,
          };
          i = JSON.stringify(i);
          AWL.console.info("sending message: " + i);
          d.send(JSON.stringify(j), true);
        } else {
          d.send(JSON.stringify(j));
        }
      };
      function e(m, i) {
        var l = "";
        try {
          l = JSON.parse(i);
          var j = null;
          if (
            l.msgname === "loginResponse" &&
            typeof l.params !== "undefined" &&
            typeof l.params.loginSessionData !== "undefined" &&
            l.params.loginSessionData !== null
          ) {
            j = JSON.parse(i);
            delete j.params.loginSessionData.authToken;
            AWL.console.info("handleIncomingMsg: " + JSON.stringify(j));
          } else {
            if (
              l.msgname === "renewTokenResponse" &&
              typeof l.params !== "undefined" &&
              typeof l.params.authToken !== "undefined" &&
              l.params.authToken !== null
            ) {
              j = JSON.parse(i);
              delete j.params.authToken;
              AWL.console.info("handleIncomingMsg: " + JSON.stringify(j));
            } else {
              AWL.console.info("handleIncomingMsg: " + i);
            }
          }
        } catch (k) {
          AWL.console.info("handleIncomingMsg: " + i);
          AWL.console.error(
            "Syntax error while parsing the incoming Json Rpc message"
          );
          return;
        }
        if (!h.isValidMsgStruct(l)) {
          AWL.console.error("Incoming Json Rpc Message structure invalid");
          return;
        }
        if (l.msgname) {
          var n = f[g + "." + l.msgname];
          if (typeof n !== "undefined") {
            n(l.msgname, l.params);
          } else {
            AWL.console.error("No Listeners for : " + l.msgname + " message!");
          }
        }
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.io.WebSocketConnection",
  (function () {
    var a = function (l) {
      var g = this;
      var i = null;
      var b = null;
      var c = 180000;
      var k = 10000;
      this.evtConnectionOpen = new AWL.Event(this);
      this.evtConnectionClose = new AWL.Event(this);
      this.evtConnectionError = new AWL.Event(this);
      this.evtOnMessage = new AWL.Event(this);
      this.evtOnBinaryMessage = new AWL.Event(this);
      this.type = "ws";
      this.open = function (m) {
        AWL.console.debug("connecting websocket to ", m, " protocol ", l);
        b = new AWL.utilities.env.WebSocket(m, l);
        b.binaryType = "arraybuffer";
        b.onopen = d;
        b.onmessage = f;
        b.onclose = h;
        b.onerror = e;
        window.onbeforeunload = function (n) {
          b.onclose = null;
        };
      };
      this.close = function (m, n) {
        if (b) {
          AWL.console.debug("closing websocket");
          g.evtConnectionClose.detachAll();
          if (m && n) {
            b.close(m, n);
          } else {
            b.close();
          }
        } else {
          AWL.console.error("Cannot close websocket. Invalid state.");
        }
      };
      this.send = function (n, m) {
        if (b.readyState == 1) {
          if (!m) {
            AWL.console.info("sending message: " + n);
          }
          b.send(n);
        } else {
          AWL.console.error("cannot send msg as connection is closed");
        }
      };
      this.isReady = function () {
        if (b.readyState == 1) {
          return true;
        } else {
          return false;
        }
      };
      function d() {
        AWL.console.debug("_ws_onopen");
        if (i !== null) {
          clearTimeout(i);
        }
        i = setTimeout(j, c + k);
        g.evtConnectionOpen.notify(b.protocol);
      }
      function e(m) {
        if (i !== null) {
          clearTimeout(i);
          i = null;
        }
        AWL.console.warn("_ws_onerror");
        g.evtConnectionError.notify();
      }
      function h(m) {
        if (i !== null) {
          clearTimeout(i);
          i = null;
        }
        AWL.console.debug(
          "_ws_onclose. wasClean: " +
            m.wasClean +
            " code: " +
            m.code +
            " reason: " +
            m.reason
        );
        g.evtConnectionClose.notify({
          wasClean: m.wasClean,
          code: m.code,
          reason: m.reason,
        });
      }
      function f(m) {
        if (typeof m.data === "string") {
          if (m.data === "keepalive") {
            if (i !== null) {
              clearTimeout(i);
            }
            i = setTimeout(j, c + k);
            return;
          }
          g.evtOnMessage.notify(m.data);
        } else {
          g.evtOnBinaryMessage.notify(m.data);
        }
      }
      function j() {
        AWL.console.warn("TOKAM from Gateway");
        if (i !== null) {
          clearTimeout(i);
          i = null;
          if (
            AWL.inUse_Version === AWL.SDK_VERSION.v11_0 &&
            typeof AWL.resiliencymanager !== "undefined" &&
            AWL.resiliencymanager !== null &&
            AWL.resiliencymanager.getInstance() !== null &&
            AWL.resiliencymanager.getInstance().isResiliencySupported() &&
            navigator.onLine
          ) {
            AWL.console.warn(
              "Link issue observed. Resiliency Enabled. start checking Server Connectivity operation"
            );
            var m = "Link Failure";
            AWL.registration_11_0version.getInstance().isServerActive();
          } else {
            AWL.console.warn(
              "Link issue observed. No Resiliency. notify applications.."
            );
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_LINK_ISSUE_DETECTED,
              reason: "link issue detected",
            });
          }
        }
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.webrtc.MozPC",
  (function () {
    var a = function () {
      var i = this;
      var j = null;
      var c = false;
      var e = {};
      var g = false;
      var f = false;
      this.evtRemoteStream = new AWL.Event(this);
      this.evtLocalDescription = new AWL.Event(this);
      this.evtLocalCandidates = new AWL.Event(this);
      this.evtICEConnectivity = new AWL.Event(this);
      this.init = function (p) {
        if (p) {
          e = p;
        }
        g = false;
        f = false;
        j = new window.RTCPeerConnection(e.rtcConfiguration, e.constraints);
        j.onicecandidate = h;
        j.oniceconnectionstatechange = o;
        j.onsignalingstatechange = d;
        j.ontrack = m;
        j.onremovestream = l;
      };
      this.close = function () {
        if (j) {
          AWL.console.debug(
            "Peer connection signaling state: " + j.signalingState
          );
          if (j.signalingState !== null && j.signalingState !== "closed") {
            AWL.console.debug("closing peer connection");
            j.close();
          }
          j = null;
        }
      };
      this.addStream = function (p) {
        AWL.console.debug("adding stream: " + p.label);
        j.addStream(p);
      };
      this.addTrack = function (p, q) {
        AWL.console.debug("adding track " + p.id + "to RTCPeerConnection");
        return j.addTrack(p, q);
      };
      this.removeTrack = function (p) {
        AWL.console.debug("removing track");
        j.removeTrack(p);
      };
      this.getStats = function (q, r, p) {
        if (j.getStats) {
          j.getStats(q, r, p);
        }
      };
      this.createOffer = function (q, r, p) {
        if (!j) {
          q("No active connection.");
          return;
        }
        j.createOffer(r)
          .then(function (s) {
            AWL.console.debug("createOffer success.");
            AWL.console.debug(s);
            if (p) {
              p(s);
              return;
            }
            j.setLocalDescription(s)
              .then(function () {
                AWL.console.debug("setLocalDescription success.");
                if (n()) {
                  c = false;
                  if (b(s.sdp)) {
                    c = true;
                    i.evtLocalDescription.notify({ type: s.type, sdp: s.sdp });
                  }
                } else {
                  AWL.console.debug("Trickle ICE not supported");
                  i.evtLocalDescription.notify({ type: s.type, sdp: s.sdp });
                }
              })
              ["catch"](function (t) {
                AWL.console.error("setLocalDescription failed.Error: " + t);
                q("Failed to set local description.");
                return;
              });
          })
          ["catch"](function (s) {
            AWL.console.error("createOffer failed.Error: " + s);
            q("Failed to create offer.");
            return;
          });
      };
      this.setRemoteDescription = function (q, p, r) {
        var s = new RTCSessionDescription(q);
        j.setRemoteDescription(s)
          .then(function () {
            AWL.console.debug("setRemoteDescription success.");
            if (q.type === "offer") {
              j.createAnswer(r)
                .then(function (t) {
                  AWL.console.debug("createAnswer success.");
                  AWL.console.debug(t);
                  j.setLocalDescription(t)
                    .then(function () {
                      AWL.console.debug("setLocalDescription success.");
                      if (n()) {
                        c = false;
                        if (b(t.sdp)) {
                          c = true;
                          i.evtLocalDescription.notify({
                            type: t.type,
                            sdp: t.sdp,
                          });
                        }
                      } else {
                        AWL.console.debug("Trickle ICE not supported");
                        i.evtLocalDescription.notify({
                          type: t.type,
                          sdp: t.sdp,
                        });
                      }
                    })
                    ["catch"](function (u) {
                      AWL.console.error(
                        "setLocalDescription failed.Error: " + u
                      );
                      p("Failed to set local description.");
                    });
                })
                ["catch"](function (t) {
                  AWL.console.error("createAnswer failed.Error: " + t);
                  p("Failed to create answer");
                });
            }
          })
          ["catch"](function (t) {
            AWL.console.error("setRemoteDescription failed.Error: " + t);
            p("Failed to set remote description");
          });
      };
      this.setCustomLocalDescription = function (t, z, r) {
        AWL.console.debug("setLocalDescription: recvd cmdType = " + t);
        var u = j.localDescription;
        if (typeof r !== "undefined") {
          u.sdp = r;
        }
        u.type = "offer";
        AWL.console.debug("SDP type \n " + u.type);
        if (t === "hold") {
          u.sdp = u.sdp.replace(/^.*a=crypto:.*$/gm, "");
          var q = u.sdp.indexOf("m=video");
          if (q !== -1) {
            var v = u.sdp.slice(q + 8);
            if (v.indexOf("inactive") !== -1) {
              g = true;
            }
            v = v.substring(" ", 1);
            AWL.console.debug("Video Port = " + v);
            if (v !== "0") {
              u.sdp = u.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
            } else {
              var p = u.sdp.slice(0, q);
              var s = u.sdp.slice(q);
              p = p.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              u.sdp = p.concat(s);
            }
          } else {
            u.sdp = u.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
          }
          if (z === "passive" || z === "active") {
            u.sdp = u.sdp.replace(
              /a=setup:passive\r\n/g,
              "a=setup:actpass\r\n"
            );
            u.sdp = u.sdp.replace(/a=setup:active\r\n/g, "a=setup:actpass\r\n");
            if (u.sdp.indexOf("a=setup:actpass") === -1) {
              AWL.console.debug("Adding actpass");
              var y = u.sdp.indexOf("c=IN");
              if (y !== -1) {
                var x = u.sdp.slice(0, y);
                var w = u.sdp.slice(y);
                x = x.concat("a=setup:actpass\r\n");
                u.sdp = x.concat(w);
              }
              y = u.sdp.lastIndexOf("c=IN");
              if (y !== -1) {
                var x = u.sdp.slice(0, y);
                var w = u.sdp.slice(y);
                x = x.concat("a=setup:actpass\r\n");
                u.sdp = x.concat(w);
              }
            }
          } else {
            AWL.console.warn("setLocalDescription: unknown dtlsRole " + z);
          }
        } else {
          if (t === "unhold") {
            u.sdp = u.sdp.replace(/^.*a=crypto:.*$/gm, "");
            var q = u.sdp.indexOf("m=video");
            if (q !== -1) {
              var v = u.sdp.slice(q + 8);
              v = v.substring(" ", 1);
              AWL.console.debug("Video Port = " + v);
              if (v !== "0") {
                if (g) {
                  var p = u.sdp.slice(0, q);
                  var s = u.sdp.slice(q);
                  p = p.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  u.sdp = p.concat(s);
                } else {
                  u.sdp = u.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
                }
              } else {
                var p = u.sdp.slice(0, q);
                var s = u.sdp.slice(q);
                p = p.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                u.sdp = p.concat(s);
              }
              g = false;
            } else {
              u.sdp = u.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
            }
            if (z === "passive" || z === "active") {
              u.sdp = u.sdp.replace(
                /a=setup:passive\r\n/g,
                "a=setup:actpass\r\n"
              );
              u.sdp = u.sdp.replace(
                /a=setup:active\r\n/g,
                "a=setup:actpass\r\n"
              );
              if (u.sdp.indexOf("a=setup:actpass") === -1) {
                AWL.console.debug("Adding actpass");
                var y = u.sdp.indexOf("c=IN");
                if (y !== -1) {
                  var x = u.sdp.slice(0, y);
                  var w = u.sdp.slice(y);
                  x = x.concat("a=setup:actpass\r\n");
                  u.sdp = x.concat(w);
                }
                y = u.sdp.lastIndexOf("c=IN");
                if (y !== -1) {
                  var x = u.sdp.slice(0, y);
                  var w = u.sdp.slice(y);
                  x = x.concat("a=setup:actpass\r\n");
                  u.sdp = x.concat(w);
                }
              }
            } else {
              AWL.console.warn("setLocalDescription: unknown dtlsRole " + z);
            }
          } else {
            if (t === "prevNegotiatedSDP") {
              u.sdp = r;
            } else {
              if (t === "removeVideo") {
                var q = u.sdp.indexOf("m=video");
                var p = u.sdp.slice(0, q);
                var s = u.sdp.slice(q);
                s = s.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                u.sdp = p.concat(s);
                if (z === "passive" || z === "active") {
                  u.sdp = u.sdp.replace(
                    /a=setup:passive\r\n/g,
                    "a=setup:actpass\r\n"
                  );
                  u.sdp = u.sdp.replace(
                    /a=setup:active\r\n/g,
                    "a=setup:actpass\r\n"
                  );
                  if (u.sdp.indexOf("a=setup:actpass") === -1) {
                    AWL.console.debug("Adding actpass");
                    var y = u.sdp.indexOf("c=IN");
                    if (y !== -1) {
                      var x = u.sdp.slice(0, y);
                      var w = u.sdp.slice(y);
                      x = x.concat("a=setup:actpass\r\n");
                      u.sdp = x.concat(w);
                    }
                    y = u.sdp.lastIndexOf("c=IN");
                    if (y !== -1) {
                      var x = u.sdp.slice(0, y);
                      var w = u.sdp.slice(y);
                      x = x.concat("a=setup:actpass\r\n");
                      u.sdp = x.concat(w);
                    }
                  }
                } else {
                  AWL.console.warn(
                    "setLocalDescription: unknown dtlsRole " + z
                  );
                }
              } else {
                if (t === "addVideo") {
                  var q = u.sdp.indexOf("m=video");
                  var p = u.sdp.slice(0, q);
                  var s = u.sdp.slice(q);
                  s = s.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  u.sdp = p.concat(s);
                  if (z === "passive" || z === "active") {
                    u.sdp = u.sdp.replace(
                      /a=setup:passive\r\n/g,
                      "a=setup:actpass\r\n"
                    );
                    u.sdp = u.sdp.replace(
                      /a=setup:active\r\n/g,
                      "a=setup:actpass\r\n"
                    );
                    if (u.sdp.indexOf("a=setup:actpass") === -1) {
                      AWL.console.debug("Adding actpass");
                      var y = u.sdp.indexOf("c=IN");
                      if (y !== -1) {
                        var x = u.sdp.slice(0, y);
                        var w = u.sdp.slice(y);
                        x = x.concat("a=setup:actpass\r\n");
                        u.sdp = x.concat(w);
                      }
                      y = u.sdp.lastIndexOf("c=IN");
                      if (y !== -1) {
                        var x = u.sdp.slice(0, y);
                        var w = u.sdp.slice(y);
                        x = x.concat("a=setup:actpass\r\n");
                        u.sdp = x.concat(w);
                      }
                    }
                  }
                } else {
                  AWL.console.error("Unsupported cmdType = " + t);
                  return;
                }
              }
            }
          }
        }
        AWL.console.debug("Modified local " + t + " SDP:\n " + u.sdp);
        j.setLocalDescription(u)
          .then(function () {
            AWL.console.debug("unHold SDP set successfully.");
          })
          ["catch"](function (A) {
            AWL.console.error("Failed to set unhold SDP.Error: " + A);
          });
      };
      this.getCustomLocalDescription = function (s) {
        AWL.console.debug("getLocalDescription: recvd cmdType = " + s);
        var v = j.localDescription;
        AWL.console.debug("SDP type \n " + v.type);
        if (s === "remVideo") {
          var w = v.sdp.indexOf("m=audio");
          var q = v.sdp.indexOf("m=video");
          var u = v.sdp.indexOf("a=sendrecv");
          var t = v.sdp.lastIndexOf("a=sendrecv");
          AWL.console.debug(
            "\n idxAud = " +
              w +
              "\nidxVid = " +
              q +
              "\nidxFirst = " +
              u +
              "\nidxLast = " +
              t
          );
          if (q === -1) {
          } else {
            if (w > q) {
              if (u != t && u > q && u < w) {
                v.sdp = v.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                if (u === t && u > q && u < w) {
                  v.sdp = v.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                } else {
                  var p = v.sdp.slice(0, w);
                  var r = v.sdp.slice(w);
                  p = p.concat("a=inactive\r\n");
                  v.sdp = p.concat(r);
                }
              }
            } else {
              if (u != t && u > w && u < q) {
                var r = v.sdp.slice(0, q);
                var p = v.sdp.slice(q);
                p = p.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                v.sdp = r.concat(p);
              } else {
                if (u === t && u > w && u > q) {
                  v.sdp = v.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                } else {
                  var r = v.sdp.slice(0, q);
                  var p = v.sdp.slice(q);
                  p = p.concat("a=inactive\r\n");
                  v.sdp = r.concat(p);
                }
              }
            }
          }
          AWL.console.debug("Modified Audio Only SDP \n " + v.sdp);
        } else {
          AWL.console.error("Unsupported cmdType = " + s);
        }
        return v;
      };
      this.setCustomRemoteDescription = function (v, y, s, q) {
        AWL.console.debug("setCustomRemoteDescription: recvd cmdType = " + v);
        var t = { sdp: s, type: "answer" };
        var w = new RTCSessionDescription(t);
        AWL.console.debug("SDP type \n " + w.type);
        if (v === "hold") {
          var r = w.sdp.indexOf("m=video");
          if (r !== -1) {
            var x = w.sdp.slice(r + 8);
            if (x.indexOf("inactive") !== -1) {
              f = true;
            }
            x = x.substring(" ", 1);
            AWL.console.debug("Video Port = " + x);
            if (x !== "0") {
              w.sdp = w.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
            } else {
              var p = w.sdp.slice(0, r);
              var u = w.sdp.slice(r);
              p = p.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              w.sdp = p.concat(u);
            }
          } else {
            w.sdp = w.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
          }
          w.sdp = k(y, w.sdp);
        } else {
          if (v === "unhold") {
            var r = w.sdp.indexOf("m=video");
            if (r !== -1) {
              var x = w.sdp.slice(r + 8);
              x = x.substring(" ", 1);
              AWL.console.debug("Video Port = " + x);
              if (x !== "0") {
                if (f) {
                  var p = w.sdp.slice(0, r);
                  var u = w.sdp.slice(r);
                  p = p.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  w.sdp = p.concat(u);
                } else {
                  w.sdp = w.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
                }
              } else {
                var p = w.sdp.slice(0, r);
                var u = w.sdp.slice(r);
                p = p.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                w.sdp = p.concat(u);
              }
              f = false;
            } else {
              w.sdp = w.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
            }
            w.sdp = k(y, w.sdp);
          } else {
            if (v === "update") {
              w.sdp = k(y, w.sdp);
            } else {
              if (v === "prevNegotiatedSDP") {
              } else {
                AWL.console.error("Unsupported cmdType = " + v);
                return;
              }
            }
          }
        }
        AWL.console.debug("Modified remote " + v + " SDP:\n " + w.sdp);
        j.setRemoteDescription(w)
          .then(function () {
            AWL.console.debug("Remote SDP for " + v + " set successfully");
          })
          ["catch"](function (z) {
            AWL.console.error(
              "Failed to set remote SDP for " + v + " Error: " + z
            );
          });
      };
      this.addIceCandidate = function (p) {
        var q = new RTCIceCandidate(p);
        j.addIceCandidate(q);
      };
      this.addSetUpAttribute = function (r) {
        var v = new RTCSessionDescription(r);
        if (v.sdp.indexOf("a=setup:") === -1) {
          AWL.console.debug("Adding actpass");
          var p = v.sdp.indexOf("c=IN");
          if (p !== -1) {
            var u = v.sdp.slice(0, p);
            var t = v.sdp.slice(p);
            u = u.concat("a=setup:actpass\r\n");
            v.sdp = u.concat(t);
          }
          var q = v.sdp.indexOf("m=video");
          if (q !== -1) {
            var s = v.sdp.lastIndexOf("c=IN");
            if (s !== -1 && s !== p) {
              var u = v.sdp.slice(0, s);
              var t = v.sdp.slice(s);
              u = u.concat("a=setup:actpass\r\n");
              v.sdp = u.concat(t);
            }
          }
        }
        AWL.console.debug(
          "Adding SetUp Attribute::Modified Offer sdp:\n" + v.sdp
        );
        return v;
      };
      function d(p) {
        AWL.console.debug(
          "pc_onsignalingstatechange: ",
          p.target.signalingState
        );
      }
      function o(p) {
        AWL.console.info(
          "pc_oniceconnectionstatechange: ",
          p.target.iceConnectionState
        );
        i.evtICEConnectivity.notify({ iceStatus: p.target.iceConnectionState });
      }
      function m(p) {
        AWL.console.debug("pc_ontrack");
        var q = p.streams[0];
        setTimeout(function () {
          if (typeof q != "undefined" && q != null) {
            var s = "";
            var r = q.getVideoTracks();
            var t = q.getAudioTracks();
            if (t && t.length > 0) {
              s = "audio";
            }
            if (r && r.length > 0) {
              s = s + "video";
            }
            i.evtRemoteStream.notify({ stream: p.streams[0], type: s });
          } else {
            i.evtRemoteStream.notify({ track: p.track, type: p.track.kind });
          }
        }, 500);
      }
      function l(p) {
        AWL.console.debug("pc_onremovestream");
      }
      function h(q) {
        AWL.console.debug("pc_onicecandidate: " + q.candidate);
        if (n()) {
          if (!c && q.candidate === null) {
            c = true;
            AWL.console.info("ICE candidates received. Sending SDP");
            var p = "offer";
            if (j.remoteDescription) {
              p = "answer";
            }
            i.evtLocalDescription.notify({
              type: p,
              sdp: j.localDescription.sdp,
            });
          }
        }
      }
      function b(q) {
        var v = q.indexOf("m=audio");
        var p = q.indexOf("m=video");
        var u = q.indexOf("a=candidate");
        var s = q.lastIndexOf("a=candidate");
        var r = false;
        if (v !== -1 && u !== -1) {
          if (p !== -1) {
            var t = q.slice(p + 8);
            t = t.substring(" ", 1);
            AWL.console.debug("Video Port = " + t);
            if (t !== "0") {
              if (s > p) {
                r = true;
              } else {
                c = false;
                AWL.console.debug("Video SDP without candidates");
              }
            } else {
              AWL.console.debug(
                "No candidate gathering required when video port is zero, but allow sending SDP"
              );
              r = true;
            }
          } else {
            if (p === -1) {
              r = true;
            } else {
              c = false;
              AWL.console.debug("Video SDP without candidates");
            }
          }
        } else {
          c = false;
          AWL.console.debug("Audio SDP without candidates");
        }
        return r;
      }
      function n() {
        var p = navigator.userAgent.match(/Firefox\/(.*)$/);
        if (p && p.length > 1) {
          if (p[1] >= 34) {
            return true;
          }
        }
        return false;
      }
      function k(s, r) {
        AWL.console.debug("modifySDP DTLS Role: " + s);
        var q = r;
        if (s === "active") {
          if (q.indexOf("a=setup:") === -1) {
            AWL.console.debug("Adding active");
            var p = q.indexOf("c=IN");
            if (p !== -1) {
              var u = q.slice(0, p);
              var t = q.slice(p);
              u = u.concat("a=setup:active\r\n");
              q = u.concat(t);
            }
            p = q.lastIndexOf("c=IN");
            if (p !== -1) {
              var u = q.slice(0, p);
              var t = q.slice(p);
              u = u.concat("a=setup:active\r\n");
              q = u.concat(t);
            }
          }
        } else {
          if (s === "passive") {
            if (q.indexOf("a=setup:") === -1) {
              AWL.console.debug("Adding passive");
              var p = q.indexOf("c=IN");
              if (p !== -1) {
                var u = q.slice(0, p);
                var t = q.slice(p);
                u = u.concat("a=setup:passive\r\n");
                q = u.concat(t);
              }
              p = q.lastIndexOf("c=IN");
              if (p !== -1) {
                var u = q.slice(0, p);
                var t = q.slice(p);
                u = u.concat("a=setup:passive\r\n");
                q = u.concat(t);
              }
            }
          } else {
            if (s === "active-passive") {
              if (q.indexOf("a=setup:") === -1) {
                AWL.console.debug(
                  "Adding active to audio and passive to video"
                );
                var p = q.indexOf("c=IN");
                if (p !== -1) {
                  var u = q.slice(0, p);
                  var t = q.slice(p);
                  u = u.concat("a=setup:active\r\n");
                  q = u.concat(t);
                }
                p = q.lastIndexOf("c=IN");
                if (p !== -1) {
                  var u = q.slice(0, p);
                  var t = q.slice(p);
                  u = u.concat("a=setup:passive\r\n");
                  q = u.concat(t);
                }
              }
            } else {
              if (s === "passive-active") {
                if (q.indexOf("a=setup:") === -1) {
                  AWL.console.debug(
                    "Adding passive to audio and active to video"
                  );
                  var p = q.indexOf("c=IN");
                  if (p !== -1) {
                    var u = q.slice(0, p);
                    var t = q.slice(p);
                    u = u.concat("a=setup:passive\r\n");
                    q = u.concat(t);
                  }
                  p = q.lastIndexOf("c=IN");
                  if (p !== -1) {
                    var u = q.slice(0, p);
                    var t = q.slice(p);
                    u = u.concat("a=setup:active\r\n");
                    q = u.concat(t);
                  }
                }
              }
            }
          }
        }
        return q;
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.webrtc.WebKitPC",
  (function () {
    var a = function () {
      var k = this;
      var b = null;
      var s = {};
      var n = false;
      var f = false;
      var d = false;
      var q = null;
      this.evtRemoteStream = new AWL.Event(this);
      this.evtLocalDescription = new AWL.Event(this);
      this.evtLocalCandidates = new AWL.Event(this);
      this.evtICEConnectivity = new AWL.Event(this);
      this.evtReattachingStream = new AWL.Event(this);
      this.init = function (u) {
        if (u) {
          t = u;
        }
        var v = t.constraints.optional.length;
        t.constraints.optional[v] = { googIPv6: false };
        t.constraints.optional[v + 1] = { googDscp: true };
        f = false;
        d = false;
        if (typeof RTCPeerConnection !== "undefined") {
          b = new window.RTCPeerConnection(t.rtcConfiguration, t.constraints);
        } else {
          b = new window.webkitRTCPeerConnection(
            t.rtcConfiguration,
            t.constraints
          );
        }
        try {
          const t = b.getConfiguration();
          AWL.console.debug("pc has " + t.sdpSemantics);
        } catch (w) {
          AWL.console.debug(
            "getConfiguration() is not available in this browser version."
          );
        }
        b.onnegotiationneeded = e;
        b.onicecandidate = l;
        b.onsignalingstatechange = o;
        b.oniceconnectionstatechange = g;
        b.onaddstream = i;
        b.onremovestream = p;
      };
      this.close = function () {
        if (b) {
          AWL.console.debug(
            "Peer connection signaling state: " + b.signalingState
          );
          if (b.signalingState !== null && b.signalingState !== "closed") {
            AWL.console.debug("closing peer connection");
            b.close();
          }
          b = null;
        }
      };
      this.createDTMFSender = function (t) {
        return b.createDTMFSender(t);
      };
      this.addStream = function (t) {
        b.addStream(t);
      };
      this.getStats = function (t) {
        if (b.getStats) {
          b.getStats(t);
        }
      };
      this.createOffer = function (u, v, t) {
        if (!b) {
          u("No active connection.");
          return;
        }
        b.createOffer(v)
          .then(function (x) {
            AWL.console.debug("createOffer success.");
            AWL.console.debug("Offer before DTMF payload being set: ");
            AWL.console.debug(x.sdp);
            var B = JSON.stringify(x.sdp);
            var z = B.split("\\n");
            var w = "";
            for (var A = 0; A < z.length; A++) {
              if (z[A].indexOf("telephone-event/8000") !== -1) {
                var y = z[A].indexOf("a=rtpmap:");
                if (y !== -1) {
                  w = z[A].slice(y + 9, y + 12);
                  z[A] = z[A].replace(w, AWL.dtmfPayLoadType);
                }
              }
            }
            if (w) {
              for (var A = 0; A < z.length; A++) {
                if (
                  (z[A].indexOf("m=audio") !== -1 ||
                    z[A].indexOf("a=fmtp:" + w) !== -1) &&
                  z[A].indexOf(w) !== -1
                ) {
                  z[A] = z[A].replace(w, AWL.dtmfPayLoadType);
                }
              }
            }
            B = z.join("\\n");
            x.sdp = JSON.parse(B);
            AWL.console.debug("SDP after DTMF payload is set: ");
            AWL.console.debug(x.sdp);
            if (t) {
              t(x);
              return;
            }
            b.setLocalDescription(x)
              .then(function () {
                AWL.console.debug("setLocalDescription success.");
                if (r(x.sdp)) {
                  k.evtLocalDescription.notify({ type: x.type, sdp: x.sdp });
                }
              })
              ["catch"](function (C) {
                AWL.console.error("setLocalDescription failed.Error: " + C);
                u("Failed to set local description.");
              });
          })
          ["catch"](function (w) {
            AWL.console.error("createOffer failed.Error: " + w);
            u("Failed to create offer.");
            return;
          });
      };
      this.setRemoteDescription = function (u, t, v) {
        var w = new RTCSessionDescription(u);
        b.setRemoteDescription(w)
          .then(function () {
            AWL.console.debug("setRemoteDescription success.");
            if (u.type === "offer") {
              b.createAnswer(v)
                .then(function (x) {
                  AWL.console.debug("createAnswer success.");
                  AWL.console.debug(x);
                  b.setLocalDescription(x)
                    .then(function () {
                      AWL.console.debug("setLocalDescription success.");
                      if (r(x.sdp)) {
                        k.evtLocalDescription.notify({
                          type: x.type,
                          sdp: x.sdp,
                        });
                      }
                    })
                    ["catch"](function (y) {
                      AWL.console.error(
                        "setLocalDescription failed.Error: " + y
                      );
                      t("Failed to set local description.");
                    });
                })
                ["catch"](function (x) {
                  AWL.console.error("createAnswer failed.Error: " + x);
                  t("Failed to create answer");
                });
            }
          })
          ["catch"](function (x) {
            AWL.console.error("setRemoteDescription failed.Error: " + x);
            t("Failed to set remote description");
          });
      };
      this.setCustomLocalDescription = function (C, J, y) {
        AWL.console.debug("setLocalDescription: recvd cmdType = " + C);
        var D = b.localDescription;
        D.type = "offer";
        AWL.console.debug("SDP type \n " + D.type);
        if (C === "hold") {
          D.sdp = D.sdp.replace(/^.*a=crypto:.*$/gm, "");
          var u = D.sdp.indexOf("m=video");
          if (u !== -1) {
            var E = D.sdp.slice(u + 8);
            if (E.indexOf("inactive") !== -1) {
              f = true;
            }
            E = E.substring(" ", 1);
            AWL.console.debug("Video Port = " + E);
            if (E !== "0") {
              D.sdp = D.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
              var v = b.remoteDescription;
              var G = v.sdp.indexOf("m=video");
              var x;
              if (G !== -1) {
                x = v.sdp.slice(G + 8);
                x = x.substring(" ", 1);
              }
              if (x == "0") {
                var t = D.sdp.slice(0, u);
                var B = D.sdp.slice(u);
                var A = B.indexOf("UDP/");
                var z = B.slice(A);
                var w = "0 ";
                B = w.concat(z);
                D.sdp = t.concat(B);
              }
            } else {
              var t = D.sdp.slice(0, u);
              var B = D.sdp.slice(u);
              t = t.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              D.sdp = t.concat(B);
            }
          } else {
            D.sdp = D.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
          }
          if (J === "passive" || J === "active") {
            D.sdp = D.sdp.replace(
              /a=setup:passive\r\n/g,
              "a=setup:actpass\r\n"
            );
            D.sdp = D.sdp.replace(/a=setup:active\r\n/g, "a=setup:actpass\r\n");
            if (D.sdp.indexOf("a=setup:actpass") === -1) {
              AWL.console.debug("Adding actpass");
              var I = D.sdp.indexOf("c=IN");
              if (I !== -1) {
                var H = D.sdp.slice(0, I);
                var F = D.sdp.slice(I);
                H = H.concat("a=setup:actpass\r\n");
                D.sdp = H.concat(F);
              }
              I = D.sdp.lastIndexOf("c=IN");
              if (I !== -1) {
                var H = D.sdp.slice(0, I);
                var F = D.sdp.slice(I);
                H = H.concat("a=setup:actpass\r\n");
                D.sdp = H.concat(F);
              }
            }
          } else {
            AWL.console.warn("setLocalDescription: unknown dtlsRole " + J);
          }
        } else {
          if (C === "unhold") {
            D.sdp = D.sdp.replace(/^.*a=crypto:.*$/gm, "");
            var u = D.sdp.indexOf("m=video");
            if (u !== -1) {
              var E = D.sdp.slice(u + 8);
              E = E.substring(" ", 1);
              AWL.console.debug("Video Port = " + E);
              if (E !== "0") {
                if (f) {
                  var t = D.sdp.slice(0, u);
                  var B = D.sdp.slice(u);
                  t = t.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  D.sdp = t.concat(B);
                } else {
                  D.sdp = D.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
                }
              } else {
                var t = D.sdp.slice(0, u);
                var B = D.sdp.slice(u);
                t = t.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                D.sdp = t.concat(B);
              }
              f = false;
            } else {
              D.sdp = D.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
            }
            if (J === "passive" || J === "active") {
              D.sdp = D.sdp.replace(
                /a=setup:passive\r\n/g,
                "a=setup:actpass\r\n"
              );
              D.sdp = D.sdp.replace(
                /a=setup:active\r\n/g,
                "a=setup:actpass\r\n"
              );
              if (D.sdp.indexOf("a=setup:actpass") === -1) {
                AWL.console.debug("Adding actpass");
                var I = D.sdp.indexOf("c=IN");
                if (I !== -1) {
                  var H = D.sdp.slice(0, I);
                  var F = D.sdp.slice(I);
                  H = H.concat("a=setup:actpass\r\n");
                  D.sdp = H.concat(F);
                }
                I = D.sdp.lastIndexOf("c=IN");
                if (I !== -1) {
                  var H = D.sdp.slice(0, I);
                  var F = D.sdp.slice(I);
                  H = H.concat("a=setup:actpass\r\n");
                  D.sdp = H.concat(F);
                }
              }
            } else {
              AWL.console.warn("setLocalDescription: unknown dtlsRole " + J);
            }
          } else {
            if (C === "prevNegotiatedSDP") {
              D.sdp = y;
            } else {
              if (C === "removeVideo") {
                var u = D.sdp.indexOf("m=video");
                var t = D.sdp.slice(0, u);
                var B = D.sdp.slice(u);
                B = B.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                D.sdp = t.concat(B);
                if (J === "passive" || J === "active") {
                  D.sdp = D.sdp.replace(
                    /a=setup:passive\r\n/g,
                    "a=setup:actpass\r\n"
                  );
                  D.sdp = D.sdp.replace(
                    /a=setup:active\r\n/g,
                    "a=setup:actpass\r\n"
                  );
                  if (D.sdp.indexOf("a=setup:actpass") === -1) {
                    AWL.console.debug("Adding actpass");
                    var I = D.sdp.indexOf("c=IN");
                    if (I !== -1) {
                      var H = D.sdp.slice(0, I);
                      var F = D.sdp.slice(I);
                      H = H.concat("a=setup:actpass\r\n");
                      D.sdp = H.concat(F);
                    }
                    I = D.sdp.lastIndexOf("c=IN");
                    if (I !== -1) {
                      var H = D.sdp.slice(0, I);
                      var F = D.sdp.slice(I);
                      H = H.concat("a=setup:actpass\r\n");
                      D.sdp = H.concat(F);
                    }
                  }
                } else {
                  AWL.console.warn(
                    "setLocalDescription: unknown dtlsRole " + J
                  );
                }
              } else {
                if (C === "addVideo") {
                  var u = D.sdp.indexOf("m=video");
                  var t = D.sdp.slice(0, u);
                  var B = D.sdp.slice(u);
                  B = B.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  D.sdp = t.concat(B);
                  if (J === "passive" || J === "active") {
                    D.sdp = D.sdp.replace(
                      /a=setup:passive\r\n/g,
                      "a=setup:actpass\r\n"
                    );
                    D.sdp = D.sdp.replace(
                      /a=setup:active\r\n/g,
                      "a=setup:actpass\r\n"
                    );
                    if (D.sdp.indexOf("a=setup:actpass") === -1) {
                      AWL.console.debug("Adding actpass");
                      var I = D.sdp.indexOf("c=IN");
                      if (I !== -1) {
                        var H = D.sdp.slice(0, I);
                        var F = D.sdp.slice(I);
                        H = H.concat("a=setup:actpass\r\n");
                        D.sdp = H.concat(F);
                      }
                      I = D.sdp.lastIndexOf("c=IN");
                      if (I !== -1) {
                        var H = D.sdp.slice(0, I);
                        var F = D.sdp.slice(I);
                        H = H.concat("a=setup:actpass\r\n");
                        D.sdp = H.concat(F);
                      }
                    }
                  }
                } else {
                  AWL.console.error("Unsupported cmdType = " + C);
                  return;
                }
              }
            }
          }
        }
        AWL.console.debug("Modified local " + C + " SDP:\n " + D.sdp);
        b.setLocalDescription(D)
          .then(function () {
            AWL.console.debug(C + " SDP set successfully.");
          })
          ["catch"](function (K) {
            AWL.console.error("Failed to set " + C + " SDP.Error: " + K);
          });
      };
      this.setCustomRemoteDescription = function (y, B, v) {
        AWL.console.debug("setCustomRemoteDescription: recvd cmdType = " + y);
        var w = { sdp: v, type: "answer" };
        var z = new RTCSessionDescription(w);
        AWL.console.debug("SDP type \n " + z.type);
        if (y === "hold") {
          var u = z.sdp.indexOf("m=video");
          if (u !== -1) {
            var A = z.sdp.slice(u + 8);
            if (A.indexOf("inactive") !== -1) {
              d = true;
            }
            A = A.substring(" ", 1);
            AWL.console.debug("Video Port = " + A);
            if (A !== "0") {
              z.sdp = z.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
            } else {
              var t = z.sdp.slice(0, u);
              var x = z.sdp.slice(u);
              t = t.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              z.sdp = t.concat(x);
            }
          } else {
            z.sdp = z.sdp.replace(/a=sendrecv\r\n/g, "a=inactive\r\n");
          }
          z.sdp = j(B, z.sdp);
        } else {
          if (y === "unhold") {
            var u = z.sdp.indexOf("m=video");
            if (u !== -1) {
              var A = z.sdp.slice(u + 8);
              A = A.substring(" ", 1);
              AWL.console.debug("Video Port = " + A);
              if (A !== "0") {
                if (d) {
                  var t = z.sdp.slice(0, u);
                  var x = z.sdp.slice(u);
                  t = t.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                  z.sdp = t.concat(x);
                } else {
                  z.sdp = z.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
                }
              } else {
                var t = z.sdp.slice(0, u);
                var x = z.sdp.slice(u);
                t = t.replace(/a=inactive\r\n/, "a=sendrecv\r\n");
                z.sdp = t.concat(x);
              }
              d = false;
            } else {
              z.sdp = z.sdp.replace(/a=inactive\r\n/g, "a=sendrecv\r\n");
            }
            z.sdp = j(B, z.sdp);
          } else {
            if (y === "update") {
              z.sdp = j(B, z.sdp);
            } else {
              if (y === "prevNegotiatedSDP") {
              } else {
                AWL.console.error("Unsupported cmdType = " + y);
                return;
              }
            }
          }
        }
        AWL.console.debug("Modified remote " + y + " SDP:\n " + z.sdp);
        b.setRemoteDescription(z)
          .then(function () {
            AWL.console.debug("Remote SDP for " + y + " set successfully");
          })
          ["catch"](function (C) {
            AWL.console.error(
              "Failed to set remote SDP for " + y + " Error: " + C
            );
          });
      };
      this.getCustomLocalDescription = function (w) {
        AWL.console.debug("getLocalDescription: recvd cmdType = " + w);
        var z = b.localDescription;
        AWL.console.debug("SDP type \n " + z.type);
        if (w === "remVideo") {
          var A = z.sdp.indexOf("m=audio");
          var u = z.sdp.indexOf("m=video");
          var y = z.sdp.indexOf("a=sendrecv");
          var x = z.sdp.lastIndexOf("a=sendrecv");
          AWL.console.debug(
            "\n idxAud = " +
              A +
              "\nidxVid = " +
              u +
              "\nidxFirst = " +
              y +
              "\nidxLast = " +
              x
          );
          if (u === -1) {
          } else {
            if (A > u) {
              if (y != x && y > u && y < A) {
                z.sdp = z.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                if (y === x && y > u && y < A) {
                  z.sdp = z.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                } else {
                  var t = z.sdp.slice(0, A);
                  var v = z.sdp.slice(A);
                  t = t.concat("a=inactive\r\n");
                  z.sdp = t.concat(v);
                }
              }
            } else {
              if (y != x && y > A && y < u) {
                var v = z.sdp.slice(0, u);
                var t = z.sdp.slice(u);
                t = t.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                z.sdp = v.concat(t);
              } else {
                if (y === x && y > A && y > u) {
                  z.sdp = z.sdp.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
                } else {
                  var v = z.sdp.slice(0, u);
                  var t = z.sdp.slice(u);
                  t = t.concat("a=inactive\r\n");
                  z.sdp = v.concat(t);
                }
              }
            }
          }
          AWL.console.debug("Modified Audio Only SDP \n " + z.sdp);
        } else {
          AWL.console.error("Unsupported cmdType = " + w);
        }
        return z;
      };
      this.addIceCandidate = function (t) {
        var u = new RTCIceCandidate(t);
        b.addIceCandidate(u);
      };
      function r(u) {
        var z = u.indexOf("m=audio");
        var t = u.indexOf("m=video");
        var y = u.indexOf("a=candidate");
        var w = u.lastIndexOf("a=candidate");
        var v = false;
        if (z !== -1 && y !== -1) {
          if (t !== -1) {
            var x = u.slice(t + 8);
            x = x.substring(" ", 1);
            AWL.console.debug("Video Port = " + x);
            if (x !== "0") {
              if (w > t) {
                v = true;
              } else {
                n = false;
                AWL.console.debug("Video SDP without candidates");
              }
            } else {
              AWL.console.debug(
                "No candidate gathering required when video port is zero, but allow sending SDP"
              );
              v = true;
            }
          } else {
            if (t === -1) {
              v = true;
            } else {
              n = false;
              AWL.console.debug("Video SDP without candidates");
            }
          }
        } else {
          n = false;
          AWL.console.debug("Audio SDP without candidates");
        }
        return v;
      }
      function e(t) {
        AWL.console.debug("pc_onnegotiationneeded");
      }
      function o(t) {
        AWL.console.debug(
          "pc_onsignalingstatechange: ",
          t.target.signalingState
        );
      }
      function g(t) {
        AWL.console.info(
          "pc_oniceconnectionstatechange: ",
          t.target.iceConnectionState
        );
        k.evtICEConnectivity.notify({ iceStatus: t.target.iceConnectionState });
      }
      function i(v) {
        AWL.console.debug("pc_onaddstream");
        var w = v.stream;
        var u = "";
        var t = null;
        var x = null;
        v.stream.onaddtrack = h;
        v.stream.onremovetrack = c;
        if (!webkitMediaStream.prototype.getVideoTracks) {
          x = w.audioTracks;
          t = w.videoTracks;
        } else {
          t = w.getVideoTracks();
          x = w.getAudioTracks();
        }
        if (x && x.length > 0) {
          u = "audio";
        }
        if (t && t.length > 0) {
          u = u + "video";
        }
        k.evtRemoteStream.notify({ stream: v.stream, type: u });
      }
      function p(t) {
        AWL.console.debug("pc_onremovestream");
      }
      function l(u) {
        AWL.console.debug("pc_onicecandidate: " + u.candidate);
        if (q == null) {
          AWL.console.debug("Setting 10s timeout for iceGathering");
          q = setTimeout(m, 10000);
        }
        if (u.candidate === null && q != null) {
          clearTimeout(q);
          q = null;
        }
        if (!n && u.candidate === null) {
          n = true;
          AWL.console.info("ICE candidates received. Sending SDP");
          var t = "offer";
          if (b.remoteDescription) {
            t = "answer";
          }
          k.evtLocalDescription.notify({
            type: t,
            sdp: b.localDescription.sdp,
          });
        }
      }
      function m() {
        AWL.console.debug("send SDP :");
        if (q != null) {
          clearTimeout(q);
        }
        if (!n) {
          n = true;
          AWL.console.info("Sending SDP with the received ICE candidates");
          var t = "offer";
          if (b.remoteDescription) {
            t = "answer";
          }
          k.evtLocalDescription.notify({
            type: t,
            sdp: b.localDescription.sdp,
          });
        }
      }
      function h(t) {
        AWL.console.debug("Added track; reattaching video media stream.");
        k.evtReattachingStream.notify();
      }
      function c(t) {
        AWL.console.debug("Removed video track");
      }
      function j(w, v) {
        AWL.console.debug("modifySDP DTLS Role: " + w);
        var u = v;
        if (w === "active") {
          if (u.indexOf("a=setup:") === -1) {
            AWL.console.debug("Adding active");
            var t = u.indexOf("c=IN");
            if (t !== -1) {
              var y = u.slice(0, t);
              var x = u.slice(t);
              y = y.concat("a=setup:active\r\n");
              u = y.concat(x);
            }
            t = u.lastIndexOf("c=IN");
            if (t !== -1) {
              var y = u.slice(0, t);
              var x = u.slice(t);
              y = y.concat("a=setup:active\r\n");
              u = y.concat(x);
            }
          }
        } else {
          if (w === "passive") {
            if (u.indexOf("a=setup:") === -1) {
              AWL.console.debug("Adding passive");
              var t = u.indexOf("c=IN");
              if (t !== -1) {
                var y = u.slice(0, t);
                var x = u.slice(t);
                y = y.concat("a=setup:passive\r\n");
                u = y.concat(x);
              }
              t = u.lastIndexOf("c=IN");
              if (t !== -1) {
                var y = u.slice(0, t);
                var x = u.slice(t);
                y = y.concat("a=setup:passive\r\n");
                u = y.concat(x);
              }
            }
          } else {
            if (w === "active-passive") {
              if (u.indexOf("a=setup:") === -1) {
                AWL.console.debug(
                  "Adding active to audio and passive to video"
                );
                var t = u.indexOf("c=IN");
                if (t !== -1) {
                  var y = u.slice(0, t);
                  var x = u.slice(t);
                  y = y.concat("a=setup:active\r\n");
                  u = y.concat(x);
                }
                t = u.lastIndexOf("c=IN");
                if (t !== -1) {
                  var y = u.slice(0, t);
                  var x = u.slice(t);
                  y = y.concat("a=setup:passive\r\n");
                  u = y.concat(x);
                }
              }
            } else {
              if (w === "passive-active") {
                if (u.indexOf("a=setup:") === -1) {
                  AWL.console.debug(
                    "Adding passive to audio and active to video"
                  );
                  var t = u.indexOf("c=IN");
                  if (t !== -1) {
                    var y = u.slice(0, t);
                    var x = u.slice(t);
                    y = y.concat("a=setup:passive\r\n");
                    u = y.concat(x);
                  }
                  t = u.lastIndexOf("c=IN");
                  if (t !== -1) {
                    var y = u.slice(0, t);
                    var x = u.slice(t);
                    y = y.concat("a=setup:active\r\n");
                    u = y.concat(x);
                  }
                }
              }
            }
          }
        }
        return u;
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.webrtc",
  (function () {
    var i = (function () {
      if (window.webkitRTCPeerConnection) {
        return AWL.webrtc.WebKitPC;
      } else {
        if (window.RTCPeerConnection) {
          return AWL.webrtc.MozPC;
        } else {
          return null;
        }
      }
    })();
    function d(l, j, k) {
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (n) {
          var m = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
          if (!m) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          return new Promise(function (p, o) {
            m.call(navigator, n, p, o);
          });
        };
      }
      navigator.mediaDevices
        .getUserMedia(l)
        .then(function (m) {
          j(m);
        })
        ["catch"](function (m) {
          k(m);
        });
    }
    var h = (function () {
      if (
        (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia
      ) {
        if (window.webkitRTCPeerConnection || window.RTCPeerConnection) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })();
    function f(j) {
      if (navigator.webkitGetUserMedia) {
        if (g()) {
          if (j && j.srcObject) {
            webkitURL.revokeObjectURL(j.srcObject);
          }
        } else {
          if (j && j.srcObject) {
            URL.revokeObjectURL(j.srcObject);
          }
        }
      } else {
        URL.revokeObjectURL(j.srcObject);
        j.srcObject = null;
      }
    }
    function b(j, k) {
      if (navigator.webkitGetUserMedia) {
        j.srcObject = k;
      } else {
        j.srcObject = k;
        j.play();
      }
    }
    function c(j) {
      if (j.mozRequestFullScreen) {
        j.mozRequestFullScreen();
      } else {
        if (j.webkitRequestFullscreen) {
          j.webkitRequestFullscreen();
        }
      }
    }
    function a() {
      var j = navigator.userAgent.match(/Firefox\/(.*)$/);
      if (j && j.length > 1) {
        if (j[1] >= 38) {
          return true;
        }
      }
      return false;
    }
    function g() {
      var l = navigator.userAgent.indexOf("Chrome/");
      var k = navigator.userAgent.indexOf(".", l);
      var j = parseInt(navigator.userAgent.substring(l + 7, k));
      AWL.console.debug("webkitURLSupported :: Chrome version: " + j);
      if (j < 47) {
        return true;
      }
      return false;
    }
    function e() {
      var l = navigator.userAgent.indexOf("Chrome/");
      var k = navigator.userAgent.indexOf(".", l);
      var j = parseInt(navigator.userAgent.substring(l + 7, k));
      AWL.console.debug("webkitRenegotationSupport :: Chrome version: " + j);
      if (j > 68) {
        return true;
      }
      return false;
    }
    return {
      PeerConnection: i,
      getUserMedia: d,
      exists: h,
      mediaReset: f,
      mediaSetStream: b,
      launchFullScreen: c,
      mozRenegotiationSupport: a,
      webkitURLSupported: g,
      webkitRenegotationSupport: e,
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.configuration",
  (function () {
    var a;
    var b = function () {
      var h = {
        serviceType: "phone",
        enableVideo: false,
        Gateway: { ip: "", port: "" },
        Stunserver: { ip: "", port: "3478" },
        Turnserver: { ip: "", port: "3478", user: "", pwd: "" },
        AppData: { applicationUA: "", applicationID: "", appInstanceID: "" },
        disableResiliency: false,
      };
      var k = { localVideo: "", remoteVideo: "", relayAudioTagId: "" };
      var i = {
        audioInputID: "",
        videoInputID: "",
        audioOutputID: "",
        defaultId: true,
      };
      var d = "",
        e = "";
      var g = false;
      this.setConfiguration = function (m) {
        AWL.console.info("config.setConfiguration\n");
        AWL.console.info("\nAWL SDK Version : " + CONST.AWL_VERSION);
        var n = CONST.AWL_MSG_SETCONFIG_FAILED;
        var l = "config object literal notation incorrect";
        if (m) {
          if (typeof m.serviceType !== "undefined") {
            if (m.serviceType !== null) {
              if (m.serviceType === "phone") {
                AWL.serviceType = CONST.PHONESERVICE;
                h.serviceType = m.serviceType;
              } else {
                if (m.serviceType === "agent") {
                  AWL.serviceType = CONST.AGENTSERVICE;
                  h.serviceType = m.serviceType;
                } else {
                  if (m.serviceType === "relay") {
                    AWL.serviceType = CONST.RELAYSERVICE;
                    h.serviceType = m.serviceType;
                  } else {
                    AWL.serviceType = CONST.PHONESERVICE;
                    h.serviceType = m.serviceType;
                  }
                }
              }
              AWL.console.info(
                "\nconfig.setConfiguration: serviceType " + m.serviceType
              );
              n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
            }
          }
          if (typeof m.enableVideo !== "undefined") {
            if (m.enableVideo !== null) {
              AWL.console.info(
                "\nconfig.setConfiguration: enableVideo " + m.enableVideo
              );
              h.enableVideo = m.enableVideo;
              n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
            }
          }
          if (typeof m.Gateway !== "undefined") {
            if (m.Gateway.ip !== null) {
              if (j(m.Gateway.ip) || f(m.Gateway.ip) || c(m.Gateway.ip)) {
                AWL.console.info(
                  "\nconfig.setConfiguration: Gateway IP " + m.Gateway.ip
                );
                h.Gateway.ip = m.Gateway.ip;
                if (typeof m.Gateway.port !== "undefined") {
                  if (m.Gateway.port !== null) {
                    AWL.console.info(
                      "\nconfig.setConfiguration: Gateway port " +
                        m.Gateway.port
                    );
                    h.Gateway.port = m.Gateway.port;
                  } else {
                    AWL.console.warn("\nconfig.setConfiguration: port null");
                    h.Gateway.port = "";
                  }
                } else {
                  AWL.console.warn("\nconfig.setConfiguration: port undefined");
                  h.Gateway.port = "";
                }
                n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
              } else {
                AWL.clientAPIConsole.error(
                  "\nClient Api :: setConfiguration - Gateway IP is invalid"
                );
                n = CONST.AWL_MSG_SETCONFIG_FAILED;
              }
            }
          }
          if (typeof m.Stunserver !== "undefined") {
            if (m.Stunserver.ip !== null) {
              AWL.console.info(
                "\nconfig.setConfiguration: Stunserver IP " + m.Stunserver.ip
              );
              if (
                j(m.Stunserver.ip) ||
                f(m.Stunserver.ip) ||
                c(m.Stunserver.ip)
              ) {
                h.Stunserver.ip = m.Stunserver.ip;
                if (m.Stunserver.port !== null) {
                  AWL.console.info(
                    "\nconfig.setConfiguration: Stunserver port " +
                      m.Stunserver.port
                  );
                  h.Stunserver.port = m.Stunserver.port;
                }
                g = true;
                d = {
                  url: "stun:" + h.Stunserver.ip + ":" + h.Stunserver.port,
                };
                AWL.console.info(
                  "\nconfig.setConfiguration: Stunserver url " + d
                );
                n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
              }
            }
          }
          if (typeof m.Turnserver !== "undefined") {
            if (
              m.Turnserver.ip !== null &&
              m.Turnserver.user !== null &&
              m.Turnserver.pwd !== null
            ) {
              AWL.console.info(
                "\nconfig.setConfiguration: Turnserver IP " + m.Turnserver.ip
              );
              if (
                j(m.Turnserver.ip) ||
                f(m.Turnserver.ip) ||
                c(m.Turnserver.ip)
              ) {
                h.Turnserver.ip = m.Turnserver.ip;
                if (m.Turnserver.port !== null) {
                  AWL.console.info(
                    "\nconfig.setConfiguration: Turnserver port " +
                      m.Turnserver.port
                  );
                  h.Turnserver.port = m.Turnserver.port;
                }
                AWL.console.info(
                  "\nconfig.setConfiguration: Turnserver user " +
                    m.Turnserver.user
                );
                h.Turnserver.user = m.Turnserver.user;
                AWL.console.info(
                  "\nconfig.setConfiguration: Turnserver pwd " +
                    m.Turnserver.pwd
                );
                h.Turnserver.pwd = m.Turnserver.pwd;
                e = {
                  url: "turn:" + h.Turnserver.ip + ":" + h.Turnserver.port,
                  credential: h.Turnserver.pwd,
                  username: h.Turnserver.user,
                };
                AWL.console.info(
                  "\nconfig.setConfiguration: Turnserver url " + e
                );
                n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
              }
            }
          }
          if (typeof m.AppData !== "undefined") {
            if (
              m.AppData.appInstanceID === "undefined" ||
              m.AppData.appInstanceID == null
            ) {
              AWL.console.error(
                "\nconfig.setConfiguration: invalid appInstanceID: " +
                  m.AppData.appInstanceID
              );
              n = CONST.AWL_MSG_SETCONFIG_FAILED;
              l = "appInstanceID is invalid";
              AWL.onConfigChange.notify({ result: n, reason: l });
              return n;
            } else {
              AWL.console.info(
                "\nconfig.setConfiguration: appInstanceID: " +
                  m.AppData.appInstanceID
              );
              h.AppData.appInstanceID = m.AppData.appInstanceID;
            }
            if (m.AppData.applicationID !== null) {
              AWL.console.info(
                "\nconfig.setConfiguration: Application ID " +
                  m.AppData.applicationID
              );
              h.AppData.applicationID = m.AppData.applicationID;
            }
            if (m.AppData.applicationUA !== null) {
              AWL.console.info(
                "\nconfig.setConfiguration: Application UA " +
                  m.AppData.applicationUA
              );
              h.AppData.applicationUA = m.AppData.applicationUA;
            }
            n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
          } else {
            AWL.console.error(
              "\nconfig.setConfiguration: appInstanceID not set: "
            );
            n = CONST.AWL_MSG_SETCONFIG_FAILED;
            l = "appInstanceID not set";
            AWL.onConfigChange.notify({ result: n, reason: l });
            return n;
          }
          if (typeof m.disableResiliency !== "undefined") {
            if (m.disableResiliency !== null) {
              AWL.console.info(
                "\nconfig.setConfiguration: disableResiliency " +
                  m.disableResiliency
              );
              h.disableResiliency = m.disableResiliency;
              n = CONST.AWL_MSG_SETCONFIG_SUCCESS;
            }
          }
          if (n === CONST.AWL_MSG_SETCONFIG_SUCCESS) {
            l = "none";
          }
        }
        AWL.onConfigChange.notify({ result: n, reason: l });
        return n;
      };
      this.getConfiguration = function () {
        AWL.console.debug("config.getConfiguration\n");
        return h;
      };
      this.getStunServerURL = function () {
        AWL.console.debug("config._getStunServerURL\n");
        return d;
      };
      this.getTurnServerURL = function () {
        AWL.console.debug("config._getTurnServerURL\n");
        return e;
      };
      this.setDomElements = function (n) {
        var m = CONST.AWL_MSG_SETDOM_FAILED;
        var l = "DOM element missing";
        if (n) {
          if (typeof n.localVideo !== "undefined") {
            if (n.localVideo !== null) {
              k.localVideo = n.localVideo;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (typeof n.remoteVideo !== "undefined") {
            if (n.remoteVideo !== null) {
              k.remoteVideo = n.remoteVideo;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (typeof n.relayAudioTagId !== "undefined") {
            if (n.relayAudioTagId !== null) {
              k.relayAudioTagId = n.relayAudioTagId;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (m === CONST.AWL_MSG_SETDOM_SUCCESS) {
            l = "none";
          }
        }
        AWL.onConfigChange.notify({ result: m, reason: l });
        return m;
      };
      this.getDomElements = function () {
        AWL.console.debug("\ndomElement.getDomElements");
        return k;
      };
      this.setDeviceIds = function (n) {
        var m = CONST.AWL_MSG_SETDOM_FAILED;
        var l = "DOM element missing";
        if (n) {
          if (typeof n.audioInputID !== "undefined") {
            if (n.audioInputID !== null) {
              i.audioInputID = n.audioInputID;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (typeof n.videoInputID !== "undefined") {
            if (n.videoInputID !== null) {
              i.videoInputID = n.videoInputID;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (typeof n.defaultId !== "undefined") {
            if (n.defaultId !== null) {
              i.defaultId = n.defaultId;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (typeof n.audioOutputID !== "undefined") {
            if (n.audioOutputID !== null) {
              i.audioOutputID = n.audioOutputID;
              m = CONST.AWL_MSG_SETDOM_SUCCESS;
            }
          }
          if (m === CONST.AWL_MSG_SETDOM_SUCCESS) {
            l = "none";
          }
        }
        AWL.onConfigChange.notify({ result: m, reason: l });
        return m;
      };
      this.getDeviceIds = function () {
        AWL.console.debug("\ndeviceIds.getDeviceIds");
        return i;
      };
      this.hasClientSetStunCfg = function () {
        return g;
      };
      this.setStunConfig = function (l, m) {
        AWL.console.debug("\nset STUN configuration:");
        if (
          (typeof l !== "undefined" &&
            l !== null &&
            typeof l.ip !== "undefined" &&
            l.ip !== null &&
            j(l.ip)) ||
          f(l.ip) ||
          c(l.ip)
        ) {
          h.Stunserver.ip = l.ip;
          if (typeof l.port !== "undefined" && l.port !== null) {
            h.Stunserver.port = l.port;
          }
          if (m) {
            g = true;
          }
          d = { url: "stun:" + h.Stunserver.ip + ":" + h.Stunserver.port };
          AWL.console.info("Stunserver url " + JSON.stringify(d, null, 2));
          return true;
        } else {
          AWL.console.error("Invalid STUN configurations");
          return false;
        }
      };
      this.getStunConfig = function () {
        AWL.console.debug("\nget STUN configuration:");
        return { ip: h.Stunserver.ip, port: h.Stunserver.port };
      };
      var j = function (n) {
        var m = n.split(".");
        var l = false;
        if (m.length === 4) {
          l = m.every(function (o) {
            return parseInt(o, 10) >= 0 && parseInt(o, 10) <= 255;
          });
          if (l) {
            l = m.every(function (o) {
              return parseInt(o, 10) === 0;
            });
            return !l;
          }
        }
        return false;
      };
      var f = function (m) {
        var l = new RegExp(
          "^([a-z0-9]+\\.)?([a-z0-9][a-z0-9-]*\\.)+[a-z]{2,63}$",
          "i"
        );
        if (l.test(m)) {
          return true;
        }
        return false;
      };
      var c = function (m) {
        var l = new RegExp(
          "^(?:[a-zA-Z0-9]+|[a-zA-Z0-9][-a-zA-Z0-9]+[a-zA-Z0-9])(?:.[a-zA-Z0-9]+|[a-zA-Z0-9][-a-zA-Z0-9]+[a-zA-Z0-9])?$",
          "i"
        );
        if (l.test(m) && m.length <= 255) {
          return true;
        }
        return false;
      };
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.services",
  (function () {
    var a;
    var b = function () {
      this.initJsonRpcServices = function () {
        if (
          AWL.inUse_Version === AWL.SDK_VERSION.v10_0 ||
          AWL.inUse_Version === AWL.SDK_VERSION.v11_0
        ) {
          AWL.jsonRpc = new AWL.io.JsonRpc(AWL.wsConnection);
          if (
            AWL.serviceType === CONST.PHONESERVICE ||
            AWL.serviceType === CONST.AGENTSERVICE
          ) {
            AWL.jsonRpc.setServiceType(AWL.serviceType);
            AWL.jsonRpc.attach(
              "IncomingCall",
              AWL.callmanager.getInstance().incomingCallHandler
            );
            AWL.jsonRpc.attach(
              "makeCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "transferCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "answerCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallProgressing",
              AWL.callmanager.getInstance().callProgressHandler
            );
            AWL.jsonRpc.attach(
              "rejectCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "abortCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "endCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "holdCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "unholdCall",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "updateMedia",
              AWL.callmanager.getInstance().mediaUpdateHandler
            );
            AWL.jsonRpc.attach(
              "acceptMediaUpdateRequest",
              AWL.callmanager.getInstance().mediaUpdateHandler
            );
            AWL.jsonRpc.attach(
              "rejectMediaUpdateRequest",
              AWL.callmanager.getInstance().mediaUpdateHandler
            );
            AWL.jsonRpc.attach(
              "CallDisconnected",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallHeld",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallUnheld",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallConnected",
              AWL.callmanager.getInstance().mediaAnswerHandler
            );
            AWL.jsonRpc.attach(
              "CallTransferSuccessful",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallTransferFailed",
              AWL.callmanager.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              "CallCtiEventReceived",
              AWL.callmanager.getInstance().callControllerHandler
            );
            AWL.jsonRpc.attach(
              "FarEndChanged",
              AWL.callmanager.getInstance().callUpdateHandler
            );
            AWL.jsonRpc.attach(
              "MediaUpdateRequest",
              AWL.callmanager.getInstance().mediaUpdateHandler
            );
            AWL.jsonRpc.attach(
              "answerEarlyMedia",
              AWL.callmanager.getInstance().callStateHandler
            );
          } else {
            if (AWL.serviceType === CONST.RELAYSERVICE) {
              AWL.jsonRpc.setServiceType(AWL.serviceType);
              AWL.jsonRpc.attach(
                "IncomingCall",
                AWL.loopBack.getInstance().incomingCallHandler
              );
              AWL.jsonRpc.attach(
                "CallDisconnected",
                AWL.loopBack.getInstance().callStateHandler
              );
              AWL.jsonRpc.attach(
                "CallProgressing",
                AWL.loopBack.getInstance().callStateHandler
              );
              AWL.jsonRpc.attach(
                "CallConnected",
                AWL.loopBack.getInstance().mediaAnswerHandler
              );
              AWL.jsonRpc.attach(
                "Update",
                AWL.loopBack.getInstance().callUpdateHandler
              );
            } else {
              AWL.console.error("Unknown service type set");
            }
          }
        } else {
          AWL.jsonRpc = new AWL.io.JsonRpc_9_1version(AWL.wsConnection);
          if (
            AWL.serviceType === CONST.PHONESERVICE ||
            AWL.serviceType === CONST.AGENTSERVICE
          ) {
            AWL.jsonRpc.attach(
              AWL.serviceType,
              "incomingCall",
              AWL.callmanager_9_1version.getInstance().incomingCallHandler
            );
            AWL.jsonRpc.attach(
              AWL.serviceType,
              "callState",
              AWL.callmanager_9_1version.getInstance().callStateHandler
            );
            AWL.jsonRpc.attach(
              AWL.serviceType,
              "mediaAnswer",
              AWL.callmanager_9_1version.getInstance().mediaAnswerHandler
            );
            AWL.jsonRpc.attach(
              AWL.serviceType,
              "update",
              AWL.callmanager_9_1version.getInstance().callUpdateHandler
            );
          } else {
            AWL.console.error("Unknown service type set");
          }
          if (AWL.serviceType === CONST.AGENTSERVICE) {
            AWL.jsonRpc.attach(
              AWL.serviceType,
              "callController",
              AWL.callmanager_9_1version.getInstance().callControllerHandler
            );
          }
        }
      };
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.registration",
  (function () {
    var a;
    var b = function () {
      var k,
        i,
        g,
        u = false,
        m = "false",
        x = "false",
        H = null,
        l = null,
        q = null,
        F,
        n = false,
        D;
      var t = "",
        w = "",
        p = "",
        h = "",
        d = false;
      var C = { GW_9_1: "7070", GW_10_0: "9443" };
      var j = this;
      this.init = function () {
        AWL.console.debug("\nAWL.registration :: init Function");
        k = "";
        i = "";
        g = "";
        F = "";
        AWL.localStream = null;
        s();
        y();
        AWL.muteAllStreams = false;
        AWL.videoPaused = false;
        u = false;
      };
      this.logIn = function (N, I, L, J) {
        AWL.console.info("registration._logIn\n");
        if (AWL.serviceType !== CONST.RELAYSERVICE) {
          if (this.isloggedIn()) {
            AWL.clientAPIConsole.error(
              "Client Api : User already logged in, aborting another login request!"
            );
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_DUPLICATE_LOGIN,
              reason: "Already loggedin. Rejecting duplicate login",
            });
            return false;
          }
        }
        var K = "";
        j.init();
        m = L;
        x = J;
        if (N.trim().length === 0) {
          K = CONST.AWL_MSG_LOGIN_EMPTYUSERNAME;
        }
        k = N;
        if (I.trim().length === 0) {
          K = CONST.AWL_MSG_LOGIN_EMPTYPASSWORD;
        }
        i = I;
        var M = AWL.configuration.getInstance().getConfiguration().Gateway.ip;
        D = AWL.configuration.getInstance().getConfiguration().Gateway.port;
        if (D === "") {
          if (n) {
            D = C.GW_9_1;
            n = false;
          } else {
            D = C.GW_10_0;
          }
        }
        if (D === C.GW_9_1) {
          AWL.inUse_Version = AWL.SDK_VERSION.v9_1;
        } else {
          AWL.inUse_Version = AWL.SDK_VERSION.v10_0;
          D = C.GW_10_0;
        }
        if (M.trim().length === 0) {
          K = CONST.AWL_MSG_LOGIN_GW_NOTCONFIGURED;
        }
        if (K != "") {
          AWL.onRegistrationStateChange.notify({
            result: K,
            reason: "Login parameters incorrect",
          });
          return false;
        }
        AWL.connectionmanager
          .getInstance()
          .createWebsocketConnection(M, D, AWL.registration.getInstance());
      };
      this.logOut = function () {
        if (this.isloggedIn()) {
          AWL.console.info("registration.logout");
          if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
            AWL.jsonRpc.call(AWL.serviceType, "logout");
            B();
          } else {
            if (AWL.inUse_Version === AWL.SDK_VERSION.v10_0) {
              AWL.jsonRpc.sendRequest("logout");
              B();
            } else {
              AWL.registration_11_0version.getInstance().logOut();
              u = false;
            }
          }
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: Logout denied as client not logged in yet"
          );
        }
      };
      this.isloggedIn = function () {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
          return AWL.registration_11_0version.getInstance().isloggedIn();
        }
        return u;
      };
      this.playStream = function () {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
          return AWL.registration_11_0version.getInstance().playStream();
        } else {
          l.loop = true;
          var I = document.getElementById(
            AWL.configuration.getInstance().getDomElements().relayAudioTagId
          );
          I.autoplay = true;
          I.play();
          I.load();
        }
      };
      this.stopStream = function () {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
          return AWL.registration_11_0version.getInstance().stopStream();
        } else {
          var I = document.getElementById(
            AWL.configuration.getInstance().getDomElements().relayAudioTagId
          );
          I.pause();
        }
      };
      function B(I) {
        if (AWL.serviceType !== CONST.RELAYSERVICE) {
          if (typeof I === "undefined") {
            AWL.callmanager
              .getInstance()
              .cleanUpCallsIfRequired("manual logout");
          } else {
            if (typeof I.result !== "undefined") {
              if (I.result === CONST.AWL_MSG_LOGIN_WEBSOCKET_FAILURE) {
                AWL.callmanager
                  .getInstance()
                  .cleanUpCallsIfRequired("GW connection lost");
              }
            }
          }
        } else {
          AWL.loopBack.getInstance().endLoopBackConnection();
          AWL.loopBack.getInstance().resetCall();
        }
        s();
        y();
        if (AWL.serviceType === CONST.RELAYSERVICE) {
          j.stopStream();
        }
        u = false;
        AWL.muteAllStreams = false;
        if (typeof I === "undefined") {
          AWL.onRegistrationStateChange.notify({
            result: CONST.AWL_MSG_LOGGEDOUT,
            reason: "Logout successful",
          });
        } else {
          if (
            typeof I.result !== "undefined" &&
            typeof I.reason !== "undefined"
          ) {
            AWL.onRegistrationStateChange.notify({
              result: I.result,
              reason: I.reason,
            });
          }
        }
      }
      function z() {
        B({
          result: CONST.AWL_MSG_DEVICEACCESS_FAILURE,
          reason: "Timeout happened on mediaallow prompt choice",
        });
        setTimeout(function () {
          location.reload(true);
        }, 2000);
      }
      this.evtWebSocketConnectionOpenHandler = function (J, I) {
        AWL.console.info(
          "evtWebSocketConnectionOpenHandler :: Selected subprotocol: " + I
        );
        if (I == "jsonrpc-3.0") {
          AWL.inUse_Version = AWL.SDK_VERSION.v11_0;
          AWL.registration_11_0version.getInstance().initialize(k, i, m, x, D);
          AWL.connectionmanager
            .getInstance()
            .attachListener(AWL.registration_11_0version.getInstance());
          AWL.connectionmanager
            .getInstance()
            .detachListener(AWL.registration.getInstance());
          AWL.registration_11_0version
            .getInstance()
            .evtWebSocketConnectionOpenHandler(J, I);
        } else {
          if (AWL.serviceType === CONST.RELAYSERVICE) {
            if (
              AWL.configuration.getInstance().getDomElements()
                .relayAudioTagId !== ""
            ) {
              r(A());
            } else {
              AWL.console.error("Mandate relay audio tag not set - deny login");
              B({
                result: CONST.AWL_MSG_LOGIN_FAILED,
                reason: "Mandate relay audio tag not set",
              });
            }
          } else {
            r();
          }
        }
      };
      this.evtWebSocketConnectionCloseHandler = function (K, J) {
        AWL.console.debug("evtWebSocketConnectionCloseHandler: " + J.wasClean);
        var I = "";
        if (J.wasClean) {
          AWL.console.error("Connection closed by server: " + J.reason);
        } else {
          AWL.console.error("Unknown connection error: " + J.code);
        }
        if (J.code === 1006) {
          I = "Connection to WebRTC Gateway failed";
        } else {
          if (J.code === 1001) {
            I = "CLOSE_GOING_AWAY";
          } else {
            if (J.code === 1002) {
              I = "CLOSE_PROTOCOL_ERROR";
            } else {
              if (J.code === 1003) {
                I = "CLOSE_UNSUPPORTED";
              } else {
                if (J.code === 1000) {
                  I = "CLOSE_NORMAL";
                } else {
                  if (J.code === 1009) {
                    I = "CLOSE_TOO_LARGE";
                  } else {
                    I = J.code;
                  }
                }
              }
            }
          }
        }
        if (J.code === 1006) {
          if (
            AWL.serviceType !== CONST.RELAYSERVICE &&
            AWL.configuration.getInstance().getConfiguration().Gateway.port ===
              "" &&
            D === C.GW_10_0
          ) {
            G();
          } else {
            B({ result: CONST.AWL_MSG_LOGIN_WEBSOCKET_FAILURE, reason: I });
          }
        } else {
          B({ result: CONST.AWL_MSG_LOGIN_WEBSOCKET_FAILURE, reason: I });
        }
      };
      function r(I) {
        AWL.console.debug("evtMediaDeviceAccessAcquired");
        AWL.services.getInstance().initJsonRpcServices();
        if (AWL.serviceType === CONST.RELAYSERVICE) {
          AWL.loopBack.getInstance().setLocalStream(I);
        }
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          AWL.jsonRpc.attach(AWL.serviceType, "loginStatus", E);
          AWL.jsonRpc.attach(AWL.serviceType, "gatewaySettingsChanged", e);
          AWL.jsonRpc.attach(AWL.serviceType, "gatewaySettingsResponse", f);
          AWL.jsonRpc.call(AWL.serviceType, "getGatewaySettings", "all");
          AWL.jsonRpc.call(AWL.serviceType, "login", k, i);
        } else {
          AWL.jsonRpc.setJsonProtocolVal();
          AWL.jsonRpc.attach("login", E);
          AWL.jsonRpc.attach("logout", v);
          AWL.jsonRpc.attach("LoginStatusChanged", o);
          AWL.jsonRpc.attach("GatewaySettingsChanged", e);
          AWL.jsonRpc.attach("getGatewaySettings", f);
          AWL.jsonRpc.sendRequest("getGatewaySettings", "all");
          AWL.jsonRpc.sendRequest("login", k, i, m, x);
        }
      }
      function E(K, I) {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v10_0) {
          if (I.responseCode === "200") {
            AWL.console.debug(
              "evtLoginStatusHandler - Registration successfull"
            );
            if (AWL.serviceType === CONST.RELAYSERVICE) {
              u = true;
              var J = I.responseString.split(" ")[1];
              console.log("UID for this session : " + J);
              if (J !== "") {
                F = J;
              }
              AWL.onRegistrationStateChange.notify({
                result: CONST.AWL_MSG_LOGIN_SUCCESS,
                reason: "SIP registration success",
                UID: J,
              });
            } else {
              u = true;
              AWL.onRegistrationStateChange.notify({
                result: CONST.AWL_MSG_LOGIN_SUCCESS,
                reason: "SIP registration success",
              });
            }
          } else {
            AWL.console.debug("evtLoginStatusHandler - Registration Failed");
            B({ result: CONST.AWL_MSG_LOGIN_FAILED, reason: I.responseString });
          }
        } else {
          I = K;
          if (I[0]) {
            AWL.console.debug(
              "evtLoginStatusHandler - Registration successfull"
            );
            u = true;
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_LOGIN_SUCCESS,
              reason: "SIP registration success",
            });
          } else {
            AWL.console.debug("evtLoginStatusHandler - Registration Failed");
            B({ result: CONST.AWL_MSG_LOGIN_FAILED, reason: I[1] });
          }
        }
      }
      function o(J, I) {
        if (I.loginState === "LOGGED_OUT") {
          AWL.console.debug(
            "evtLoginStatusEventHandler - Logged out forcefully"
          );
          B({ result: CONST.AWL_MSG_LOGIN_FAILED, reason: I.reasonString });
        } else {
          AWL.console.debug(
            "evtLoginStatusEventHandler - Relogged in automatically"
          );
        }
      }
      function v(J, I) {
        if (I.responseCode === "200") {
          B();
        }
      }
      function f(J, I) {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v10_0) {
          if (I.responseCode === "200") {
            AWL.console.debug("gatewaySettingsResponseHandler: Success");
            c(I);
          } else {
            AWL.console.error(
              "gatewaySettingsResponseHandler: " + I.responseString
            );
          }
        } else {
          I = J;
          if (I[0] != null) {
            AWL.console.debug("gatewaySettingsResponseHandler: Success");
            c(I[0]);
          } else {
            AWL.console.error(
              "gatewaySettingsResponseHandler: Failed to get the requested settings"
            );
          }
        }
      }
      function c(I) {
        if (I.codec != null) {
          AWL.dtmfPayLoadType = I.codec.dtmfPayLoad;
          AWL.console.debug("DTMF Payload:" + AWL.dtmfPayLoadType);
        }
        if (I.nat != null) {
          p = {
            url: "stun:" + I.nat.stun.serverAddr + ":" + I.nat.stun.serverPort,
          };
          AWL.console.debug("Stun details : " + JSON.stringify(p, null, 2));
          h = {
            ip: I.nat.turn.serverAddr,
            port: I.nat.turn.serverPort,
            user: I.nat.turn.username,
          };
          AWL.console.debug("Turn details : " + JSON.stringify(h, null, 2));
          h.pwd = I.nat.turn.password;
          if (I.nat.turn.enforce.toLowerCase() === "true") {
            d = true;
          } else {
            d = false;
          }
          AWL.console.debug("Enforce Turn : " + d);
        }
        if (I.other != null) {
          t = I.other.gatewayVersion;
          AWL.console.debug("Gateway Version :" + t);
          w = I.other.dscp;
          AWL.console.debug("DSCP :" + w);
        }
      }
      function e(J, I) {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v10_0) {
          if (I) {
            AWL.console.debug("gatewaySettingsChangedHandler: Success");
            c(I);
          } else {
            AWL.console.error(
              "gatewaySettingsChangedHandler: Failed to get the gateway settings"
            );
          }
        } else {
          I = J;
          if (I[0] != null) {
            AWL.console.debug("gatewaySettingsChangedHandler: Success");
            c(I[0]);
          } else {
            AWL.console.error(
              "gatewaySettingsChangedHandler: Failed to get the gateway settings"
            );
          }
        }
      }
      function s() {
        if (AWL.jsonRpc) {
          if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
            AWL.jsonRpc.detach(
              AWL.serviceType,
              AWL.callmanager_9_1version.getInstance().incomingCallHandler
            );
            AWL.jsonRpc.detach(
              AWL.serviceType,
              AWL.callmanager_9_1version.getInstance().callStateHandler
            );
            AWL.jsonRpc.detach(
              AWL.serviceType,
              AWL.callmanager_9_1version.getInstance().mediaAnswerHandler
            );
            AWL.jsonRpc.detach(
              AWL.serviceType,
              AWL.callmanager_9_1version.getInstance().callUpdateHandler
            );
            AWL.jsonRpc.detach(AWL.serviceType, E);
            AWL.jsonRpc.detach(AWL.serviceType, e);
            AWL.jsonRpc.detach(AWL.serviceType, f);
            if (AWL.serviceType === CONST.AGENTSERVICE) {
              AWL.jsonRpc.detach(
                AWL.serviceType,
                AWL.callmanager_9_1version.getInstance().callControllerHandler
              );
            }
          } else {
            if (
              AWL.serviceType === CONST.PHONESERVICE ||
              AWL.serviceType === CONST.AGENTSERVICE
            ) {
              AWL.jsonRpc.detach("login");
              AWL.jsonRpc.detach("logout");
              AWL.jsonRpc.detach("LoginStatusChanged");
              AWL.jsonRpc.detach("IncomingCall");
              AWL.jsonRpc.detach("makeCall");
              AWL.jsonRpc.detach("transferCall");
              AWL.jsonRpc.detach("answerCall");
              AWL.jsonRpc.detach("CallProgressing");
              AWL.jsonRpc.detach("rejectCall");
              AWL.jsonRpc.detach("abortCall");
              AWL.jsonRpc.detach("endCall");
              AWL.jsonRpc.detach("holdCall");
              AWL.jsonRpc.detach("unholdCall");
              AWL.jsonRpc.detach("CallDisconnected");
              AWL.jsonRpc.detach("CallHeld");
              AWL.jsonRpc.detach("CallUnheld");
              AWL.jsonRpc.detach("CallConnected");
              AWL.jsonRpc.detach("CallTransferSuccessful");
              AWL.jsonRpc.detach("CallTransferFailed");
              AWL.jsonRpc.detach("CallCtiEventReceived");
              AWL.jsonRpc.detach("FarEndChanged");
              AWL.jsonRpc.detach("getGatewaySettings");
              AWL.jsonRpc.detach("GatewaySettingsChanged");
            }
          }
          AWL.jsonRpc = null;
        }
      }
      function y() {
        AWL.connectionmanager.getInstance().destroyWebsocketConnection();
      }
      function A() {
        if (H === null) {
          window.AudioContext =
            window.AudioContext || window.webkitAudioContext;
          H = new AudioContext();
          var I = document.getElementById(
            AWL.configuration.getInstance().getDomElements().relayAudioTagId
          );
          l = H.createMediaElementSource(I);
          q = H.createMediaStreamDestination();
          l.connect(q);
        }
        return q.stream;
      }
      function G() {
        AWL.callmanager
          .getInstance()
          .cleanUpCallsIfRequired("GW connection lost");
        s();
        y();
        if (
          AWL.configuration.getInstance().getDomElements().localVideo !== ""
        ) {
          var I = document.getElementById(
            AWL.configuration.getInstance().getDomElements().localVideo
          );
          AWL.webrtc.mediaReset(I);
        }
        u = false;
        AWL.muteAllStreams = false;
        n = true;
        j.logIn(k, i);
      }
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.registration_11_0version",
  (function () {
    var a;
    var b = function () {
      var J,
        E,
        h,
        s = false,
        q = "false",
        i = "password",
        c = null,
        ab = null,
        O = null,
        M,
        V = false;
      var e = "",
        m = "",
        ak = "",
        n = "",
        k = false;
      var X = "",
        ai = "";
      var ah = "";
      var r = true;
      var B = null;
      var I = null,
        y = null;
      var Y = { ipAddr: "", type: "" };
      var d = "";
      var j = { type: null, token: null, expiry: 3600 };
      var P = this;
      var A = { PRIMARY: "primary", SECONDARY: "secondary" };
      var af = { PASSIVE: "passive", ACTIVE: "active" };
      var R = { PASSWORD: "password", TOKEN: "token" };
      var f = "9443";
      var D = 180000,
        x = 30000;
      var G = 100000,
        aa = 50000;
      var aj = 0;
      this.initialize = function (aq, al, ap, ao, an, am) {
        AWL.inUse_Version = AWL.SDK_VERSION.v11_0;
        J = aq;
        E = al;
        q = ap;
        if (ao === true) {
          i = R.TOKEN;
          if (
            typeof an !== "undefined" &&
            typeof am !== "undefined" &&
            an !== null &&
            am !== null
          ) {
            j.token = an;
            if (am.toUpperCase() === CONST.RESILIENCY) {
              am = CONST.SESSION.toLowerCase();
            }
            j.type = am.toLowerCase();
          } else {
            j.token = al;
            j.type = CONST.ESNA.toLowerCase();
          }
        } else {
          i = R.PASSWORD;
        }
        X = AWL.configuration.getInstance().getConfiguration()
          .AppData.applicationID;
        if (typeof X === "undefined" || X === "") {
          X = AWL.serviceType + "-" + AWL.SDK_VERSION.v11_0;
        }
        ai = AWL.configuration.getInstance().getConfiguration()
          .AppData.applicationUA;
        if (typeof ai === "undefined" || ai === "") {
          ai = "AWLTestClient-3.0.0";
        }
        ah = AWL.configuration.getInstance().getConfiguration()
          .AppData.appInstanceID;
        Q(AWL.configuration.getInstance().getConfiguration().Gateway.ip, "");
        u(AWL.CLIENT_STATUS.NORMAL);
      };
      this.tokenLogIn = function (aq, an, am, ao) {
        if (AWL.serviceType !== CONST.RELAYSERVICE) {
          if (P.isloggedIn()) {
            AWL.clientAPIConsole.error(
              "Client Api : User already logged in, aborting another login request!"
            );
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_DUPLICATE_LOGIN,
              reason: "Already loggedin. Rejecting duplicate login",
            });
            return false;
          }
        }
        var al = "";
        if (
          typeof aq === "undefined" ||
          aq === null ||
          aq.trim().length === 0
        ) {
          al = CONST.AWL_MSG_LOGIN_EMPTYUSERNAME;
        }
        if (
          typeof an === "undefined" ||
          an === null ||
          an.trim().length === 0
        ) {
          al = CONST.AWL_MSG_LOGIN_EMPTYTOKEN;
        }
        if (
          typeof am === "undefined" ||
          am === null ||
          (am.toUpperCase() !== CONST.RESILIENCY &&
            am.toUpperCase() !== CONST.ESNA)
        ) {
          al = CONST.AWL_MSG_LOGIN_INVALID_TOKENTYPE;
        }
        var ap = AWL.configuration.getInstance().getConfiguration().Gateway.ip;
        if (ap.trim().length === 0) {
          al = CONST.AWL_MSG_LOGIN_GW_NOTCONFIGURED;
        }
        if (al != "") {
          AWL.onRegistrationStateChange.notify({
            result: al,
            reason: "Login parameters incorrect",
          });
          return false;
        }
        P.initialize(aq, " ", ao, true, an, am);
        S();
      };
      this.logOut = function () {
        if (this.isloggedIn()) {
          AWL.console.info("registration_11_0version.logout");
          AWL.jsonRpc.sendRequest("logout");
          U();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: Logout denied as client not logged in yet"
          );
        }
      };
      this.isloggedIn = function () {
        return s;
      };
      this.playStream = function () {
        ab.loop = true;
        var al = document.getElementById(
          AWL.configuration.getInstance().getDomElements().relayAudioTagId
        );
        al.autoplay = true;
        al.play();
        al.load();
      };
      this.stopStream = function () {
        var al = document.getElementById(
          AWL.configuration.getInstance().getDomElements().relayAudioTagId
        );
        al.pause();
      };
      this.getAlternateServerConfig = function () {
        if (B !== null) {
          if (
            B.getPreferredServerConfig().haData.backupGateway.address !== ""
          ) {
            return B.getPreferredServerConfig().haData.backupGateway;
          } else {
            if (!B.isResiliencySupported()) {
              AWL.clientAPIConsole.error(
                "Registration_11_0version: Resiliency data could not be fetched"
              );
            }
            return null;
          }
        } else {
          AWL.clientAPIConsole.debug(
            "Registration_11_0version: Resiliency is either not supported or not enabled"
          );
          return null;
        }
      };
      this.getClientStatus = function () {
        return d;
      };
      this.isServerActive = function () {
        AWL.console.debug(
          "Local network is up. sending message to check if Server is reachable"
        );
        AWL.jsonRpc.sendRequest("getGatewaySettings", "all");
      };
      this.evtWebSocketConnectionOpenHandler = function (am, al) {
        AWL.console.info(
          "Registration_11_0version: evtWebSocketConnectionOpenHandler"
        );
        if (AWL.serviceType === CONST.RELAYSERVICE) {
          if (
            AWL.configuration.getInstance().getDomElements().relayAudioTagId !==
            ""
          ) {
            l(z());
          } else {
            AWL.console.error("Mandate relay audio tag not set - deny login");
            U({
              result: CONST.AWL_MSG_LOGIN_FAILED,
              reason: "Mandate relay audio tag not set",
            });
          }
        } else {
          l();
        }
      };
      this.evtWebSocketConnectionCloseHandler = function (an, am) {
        AWL.console.debug(
          "Registration_11_0version: evtWebSocketConnectionCloseHandler: " +
            am.wasClean
        );
        var al = "";
        if (am.wasClean) {
          AWL.console.error("Connection closed by server: " + am.reason);
        } else {
          AWL.console.error("Unknown connection error: " + am.code);
        }
        if (am.code === 1006) {
          al = "Connection to WebRTC Gateway failed";
        } else {
          if (am.code === 1001) {
            al = "CLOSE_GOING_AWAY";
          } else {
            if (am.code === 1002) {
              al = "CLOSE_PROTOCOL_ERROR";
            } else {
              if (am.code === 1003) {
                al = "CLOSE_UNSUPPORTED";
              } else {
                if (am.code === 1000) {
                  al = "CLOSE_NORMAL";
                } else {
                  if (am.code === 1009) {
                    al = "CLOSE_TOO_LARGE";
                  } else {
                    al = am.code;
                  }
                }
              }
            }
          }
        }
        if (
          B !== null &&
          B.isResiliencySupported() &&
          Y.type === A.PRIMARY &&
          P.getClientStatus() !== AWL.CLIENT_STATUS.FAILING_OVER
        ) {
          T();
        } else {
          aj = 0;
          u(AWL.CLIENT_STATUS.LOGGED_OUT);
          U({ result: CONST.AWL_MSG_LOGIN_WEBSOCKET_FAILURE, reason: al });
        }
      };
      function l(am) {
        AWL.console.debug(
          "Registration_11_0version: evtMediaDeviceAccessAcquired"
        );
        AWL.services.getInstance().initJsonRpcServices();
        AWL.jsonRpc.setJsonProtocolVal();
        if (AWL.serviceType === CONST.RELAYSERVICE) {
          AWL.loopBack.getInstance().setLocalStream(am);
        }
        AWL.jsonRpc.attach("login", g);
        AWL.jsonRpc.attach("logout", ac);
        AWL.jsonRpc.attach("LoginStatusChanged", K);
        AWL.jsonRpc.attach("GatewaySettingsChanged", o);
        AWL.jsonRpc.attach("getGatewaySettings", N);
        AWL.jsonRpc.attach("renewToken", L);
        AWL.jsonRpc.attach("GatewayHAModeChanged", F);
        AWL.jsonRpc.sendRequest("getGatewaySettings", "all");
        AWL.console.debug("***DEBUG*** ApplicationInstanceID: " + ah);
        if (j.token === null) {
          i = R.PASSWORD;
          AWL.jsonRpc.sendRequest("login", X, ai, ah, J, i, E, null, q);
          E = " ";
        } else {
          var al = { type: j.type, token: j.token };
          i = R.TOKEN;
          AWL.jsonRpc.sendRequest("login", X, ai, ah, J, i, E, al, q);
        }
      }
      function S() {
        AWL.connectionmanager
          .getInstance()
          .createWebsocketConnection(
            Y.ipAddr,
            f,
            AWL.registration_11_0version.getInstance()
          );
      }
      function U(al) {
        if (AWL.serviceType !== CONST.RELAYSERVICE) {
          if (typeof al === "undefined") {
            AWL.callmanager
              .getInstance()
              .cleanUpCallsIfRequired("manual logout");
          } else {
            if (typeof al.result !== "undefined") {
              if (al.result === CONST.AWL_MSG_LOGIN_WEBSOCKET_FAILURE) {
                AWL.callmanager
                  .getInstance()
                  .cleanUpCallsIfRequired("GW connection lost");
              } else {
                if (
                  al.result === CONST.AWL_MSG_FAILING_OVER ||
                  al.result === CONST.AWL_MSG_FAILING_BACK
                ) {
                  AWL.callmanager
                    .getInstance()
                    .cleanUpCallsIfRequired(al.reason);
                } else {
                }
              }
            }
          }
        } else {
          AWL.loopBack.getInstance().endLoopBackConnection();
          AWL.loopBack.getInstance().resetCall();
        }
        if (y !== null) {
          clearTimeout(y);
        }
        y = null;
        W();
        Z();
        if (
          typeof al === "undefined" ||
          (P.getClientStatus() !== AWL.CLIENT_STATUS.FAILING_OVER &&
            P.getClientStatus() !== AWL.CLIENT_STATUS.FAILING_BACK)
        ) {
          if (I !== null) {
            clearTimeout(I);
          }
          I = null;
          Y = { ipAddr: "", type: "" };
          j = { type: null, token: null, expiry: 3600 };
          aj = 0;
        }
        if (B !== null) {
          B.resetResiliencyData();
          B = null;
          AWL.resiliencymanager = null;
        }
        if (AWL.serviceType === CONST.RELAYSERVICE) {
          P.stopStream();
        }
        s = false;
        AWL.muteAllStreams = false;
        if (typeof al === "undefined") {
          AWL.onRegistrationStateChange.notify({
            result: CONST.AWL_MSG_LOGGEDOUT,
            reason: "Logout successful",
          });
          X = "";
          ai = "";
        } else {
          if (
            typeof al.result !== "undefined" &&
            typeof al.reason !== "undefined"
          ) {
            AWL.onRegistrationStateChange.notify({
              result: al.result,
              reason: al.reason,
            });
          }
        }
      }
      function g(ar, aq) {
        if (aq.responseCode === "200") {
          AWL.console.debug(
            "Registration_11_0version: evtLoginStatusHandler - Registration successful"
          );
          if (AWL.serviceType === CONST.RELAYSERVICE) {
            s = true;
            var ao = aq.responseString.split(" ")[1];
            console.log("UID for this session : " + ao);
            if (ao !== "") {
              M = ao;
            }
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_LOGIN_SUCCESS,
              reason: "SIP registration success",
              UID: ao,
            });
          } else {
            s = true;
            if (AWL.callMap !== null) {
              AWL.console.debug(
                "Registration_11_0version: evtLoginStatusHandler - Clearout callMap entries"
              );
              while (AWL.callMap.length > 0) {
                AWL.callMap.pop();
              }
            }
            var am = false;
            if (aq.loginSessionData != null) {
              var al = aq.loginSessionData.haData;
              if (al != null) {
                if (
                  al.haSupported != null &&
                  al.haSupported === true &&
                  al.haEnabled != null &&
                  al.haEnabled === true
                ) {
                  if (B === null) {
                    try {
                      AWL.newPackage(
                        "com.avaya.awl.resiliencymanager",
                        resiliencymodule()
                      );
                      B = AWL.resiliencymanager.getInstance();
                    } catch (ap) {}
                  }
                  if (B.isHADataValid(al)) {
                    var au = B.getPreferredServerConfig();
                    if (Y.ipAddr === au.ipAddr) {
                      au.haData = al;
                      B.setPreferredServerConfig(au);
                    } else {
                      au.ipAddr = Y.ipAddr;
                      au.haData = al;
                      B.setAlternateServerConfig(au);
                    }
                    if (H(al.backupGateway.serverType, A.PRIMARY)) {
                      Q(Y.ipAddr, A.SECONDARY);
                    } else {
                      if (H(al.backupGateway.serverType, A.SECONDARY)) {
                        Q(Y.ipAddr, A.PRIMARY);
                      } else {
                      }
                    }
                    B.setResiliencyFlag(true);
                  } else {
                    AWL.console.error(
                      "Registration_11_0version: High Availability data receieved from gateway is invalid. Resiliency support will be disabled"
                    );
                    B = null;
                    AWL.resiliencymanager = null;
                  }
                } else {
                  AWL.clientAPIConsole.debug(
                    "Resiliency is either not supported or is not enabled at the server"
                  );
                }
              } else {
                AWL.clientAPIConsole.error(
                  "Registration_11_0version: Resiliency data is not available"
                );
              }
              if (B != null && B.isResiliencySupported()) {
                if (t(aq.loginSessionData.authToken)) {
                  v(aq.loginSessionData.authToken);
                  am = true;
                } else {
                  B.setResiliencyFlag(false);
                  AWL.clientAPIConsole.error(
                    "Registration_11_0version: Token recieved from server is incorrect.AutoLogin will not be supported"
                  );
                }
              } else {
                AWL.clientAPIConsole.debug(
                  "Registration_11_0version: Resiliency will not be supported"
                );
              }
            } else {
              AWL.clientAPIConsole.debug(
                "Registration_11_0version: LoginSession data received is null.Resiliency will not be supported"
              );
            }
            var an;
            var at;
            aj = 0;
            if (d == AWL.CLIENT_STATUS.FAILING_OVER) {
              u(AWL.CLIENT_STATUS.FAILED_OVER);
              an = CONST.AWL_MSG_FAIL_OVER_SUCCESS;
              at = "Connected to alternate server [ " + Y.ipAddr + " ]";
            } else {
              if (d == AWL.CLIENT_STATUS.FAILING_BACK) {
                u(AWL.CLIENT_STATUS.FAILED_BACK);
                an = CONST.AWL_MSG_FAIL_BACK_SUCCESS;
                at = "Connected to alternate server [ " + Y.ipAddr + " ]";
              } else {
                if (d == AWL.CLIENT_STATUS.RECONNECTING) {
                  u(AWL.CLIENT_STATUS.NORMAL);
                  an = CONST.AWL_MSG_RELOGGED_IN;
                  at = "Reconnection to " + Y.ipAddr + " Successful";
                } else {
                  if (d !== AWL.CLIENT_STATUS.NORMAL) {
                    u(AWL.CLIENT_STATUS.NORMAL);
                  }
                  an = CONST.AWL_MSG_LOGIN_SUCCESS;
                  at = "SIP registration success";
                }
              }
            }
            if (am) {
              AWL.onRegistrationStateChange.notify({
                result: an,
                reason: at,
                authToken: { token: j.token, expiry: j.expiry },
              });
            } else {
              AWL.onRegistrationStateChange.notify({ result: an, reason: at });
            }
          }
        } else {
          AWL.console.debug(
            "Registration_11_0version: evtLoginStatusHandler - Registration Failed"
          );
          var an;
          if (d == AWL.CLIENT_STATUS.FAILING_OVER) {
            an = CONST.AWL_MSG_FAIL_OVER_FAILED;
          } else {
            if (d == AWL.CLIENT_STATUS.FAILING_BACK) {
              an = CONST.AWL_MSG_FAIL_BACK_FAILED;
            } else {
              if (
                d == AWL.CLIENT_STATUS.RECONNECTING &&
                aq.responseCode !== "-3003"
              ) {
                T();
                return;
              } else {
                an = CONST.AWL_MSG_LOGIN_FAILED;
              }
            }
          }
          u(AWL.CLIENT_STATUS.LOGGED_OUT);
          U({ result: an, reason: aq.responseString });
        }
      }
      function K(an, am) {
        if (am.loginState === "LOGGED_OUT") {
          if (
            am.reasonCode === "-3013" &&
            B !== null &&
            B.isResiliencySupported() &&
            Y.type === A.PRIMARY
          ) {
            var al =
              "Lost Connection to Server. Attempting to reconnect [ " +
              Y.ipAddr +
              " ]...";
            AWL.callmanager.getInstance().cleanUpCallsIfRequired(al);
            u(AWL.CLIENT_STATUS.RECONNECTING);
            s = false;
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_RECONNECTING,
              reason: al,
            });
            I = setTimeout(w, D, CONST.AWL_MSG_LOGIN_FAILED, am.reasonString);
          } else {
            AWL.console.debug(
              "Registration_11_0version: evtLoginStatusEventHandler - Logged out forcefully"
            );
            u(AWL.CLIENT_STATUS.LOGGED_OUT);
            U({ result: CONST.AWL_MSG_LOGIN_FAILED, reason: am.reasonString });
          }
        } else {
          AWL.console.debug(
            "Registration_11_0version: evtLoginStatusEventHandler - Relogged in automatically"
          );
          if (B.isResiliencySupported()) {
            u(AWL.CLIENT_STATUS.NORMAL);
            s = true;
            if (I !== null) {
              clearTimeout(I);
            }
            I = null;
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_RELOGGED_IN,
              reason: "Reconnection to " + Y.ipAddr + " Successful",
            });
          }
        }
      }
      function ac(am, al) {
        if (al.responseCode === "200") {
          U();
        }
      }
      function L(am, al) {
        if (al.responseCode === "200") {
          AWL.clientAPIConsole.debug("evtRenewAuthTokHandler");
          if (y !== null) {
            clearTimeout(y);
          }
          if (t(al.authToken)) {
            v(al.authToken);
            AWL.onAuthTokenRenewed.notify({
              result: CONST.AWL_MSG_TOKEN_RENEW_SUCCESS,
              reason: al.responseString,
              authToken: {
                token: al.authToken.token,
                expiry: al.authToken.expiry,
              },
            });
          } else {
            AWL.onAuthTokenRenewed.notify({
              result: CONST.AWL_MSG_TOKEN_RENEW_FAILED,
              reason: "Token received from the server is invalid",
            });
          }
        } else {
          AWL.console.debug("evtNewAuthTokenHandler: - Token renewal failed");
          AWL.onAuthTokenRenewed.notify({
            result: CONST.AWL_MSG_TOKEN_RENEW_FAILED,
            reason: al.responseString,
          });
        }
      }
      function F(ao, am) {
        AWL.console.debug("evtGatewayHAModeChangedHandler:");
        if (am.mode.toLowerCase() === af.PASSIVE.toLowerCase()) {
          if (B.isResiliencySupported()) {
            if (I !== null) {
              clearTimeout(I);
            }
            I = null;
            var an = B.getPreferredServerConfig();
            if (Y.ipAddr !== an.ipAddr) {
              an = B.getAlternateServerConfig();
            }
            if (H(an.haData.backupGateway.serverType, A.PRIMARY)) {
              Q(an.haData.backupGateway.address, A.SECONDARY);
              u(AWL.CLIENT_STATUS.FAILING_BACK);
              var al = null;
              if (an.haData.haFailbackTime) {
                al =
                  JSON.parse(JSON.stringify(an.haData.haFailbackTime)) * 1000;
              }
              if (al === null || isNaN(al)) {
                al = 60000;
              }
              I = setTimeout(p, al);
            } else {
              if (H(an.haData.backupGateway.serverType, A.SECONDARY)) {
                Q(an.haData.backupGateway.address, A.PRIMARY);
                u(AWL.CLIENT_STATUS.FAILING_OVER);
                U({
                  result: CONST.AWL_MSG_FAILING_OVER,
                  reason: "Trying alternate server [ " + Y.ipAddr + " ] ...",
                });
                S();
              } else {
              }
            }
          } else {
            AWL.jsonRpc.sendRequest("logout");
            u(AWL.CLIENT_STATUS.LOGGED_OUT);
            U({
              result: CONST.AWL_MSG_LOGGEDOUT,
              reason:
                "Gateway mode changed. Logging out as resiliency is disabled.",
            });
          }
        }
      }
      function p() {
        if (Object.keys(AWL.callMap).length === 0) {
          console.debug("Failing Back");
          AWL.onCallTerminate.detach(p);
          U({
            result: CONST.AWL_MSG_FAILING_BACK,
            reason: "Trying alternate server [ " + Y.ipAddr + " ] ...",
          });
          S();
        } else {
          console.debug(
            "Failing back: Number of calls: " + Object.keys(AWL.callMap).length
          );
          AWL.onCallTerminate.detach(p);
          AWL.onCallTerminate.attach(p);
        }
      }
      function w(am, al) {
        AWL.console.debug(
          "Registration_11_0version: loginFailedHandler - Logged out forcefully"
        );
        U({ result: am, reason: al });
      }
      function ag() {
        AWL.clientAPIConsole.debug("Registration_11_0version: renewAuthToken");
        if (y !== null) {
          clearTimeout(y);
        }
        AWL.console.debug("***DEBUG*** ApplicationInstanceID: " + ah);
        AWL.jsonRpc.sendRequest("renewToken", J, j.token, ah);
      }
      function Q(am, al) {
        Y.ipAddr = am;
        Y.type = al;
      }
      function u(al) {
        AWL.console.debug("Client status changed from " + d + " to " + al);
        d = al;
      }
      function N(am, al) {
        if (al.responseCode === "200") {
          AWL.console.debug("gatewaySettingsResponseHandler: Success");
          ae(al);
        } else {
          AWL.console.error(
            "gatewaySettingsResponseHandler: " + al.responseString
          );
        }
      }
      function o(am, al) {
        if (al) {
          AWL.console.debug("gatewaySettingsChangedHandler: Success");
          ae(al);
        } else {
          AWL.console.error(
            "gatewaySettingsChangedHandler: Failed to get the gateway settings"
          );
        }
      }
      function ae(al) {
        if (al.codec != null) {
          AWL.dtmfPayLoadType = al.codec.dtmfPayLoad;
          AWL.console.debug("DTMF Payload:" + AWL.dtmfPayLoadType);
        }
        if (al.nat != null) {
          ak = { ip: al.nat.stun.serverAddr, port: al.nat.stun.serverPort };
          AWL.console.debug("Stun details : " + JSON.stringify(ak, null, 2));
          n = {
            ip: al.nat.turn.serverAddr,
            port: al.nat.turn.serverPort,
            user: al.nat.turn.username,
          };
          AWL.console.debug("Turn details : " + JSON.stringify(n, null, 2));
          n.pwd = al.nat.turn.password;
          if (al.nat.turn.enforce.toLowerCase() === "true") {
            k = true;
          } else {
            k = false;
          }
          AWL.console.debug("Enforce Turn : " + k);
        }
        if (al.other != null) {
          e = al.other.gatewayVersion;
          AWL.console.debug("Gateway Version :" + e);
          m = al.other.dscp;
          AWL.console.debug("DSCP :" + m);
        }
        if (!AWL.configuration.getInstance().hasClientSetStunCfg()) {
          AWL.configuration.getInstance().setStunConfig(ak, false);
        }
      }
      function W() {
        if (AWL.jsonRpc) {
          if (
            AWL.serviceType === CONST.PHONESERVICE ||
            AWL.serviceType === CONST.AGENTSERVICE
          ) {
            AWL.jsonRpc.detach("login");
            AWL.jsonRpc.detach("logout");
            AWL.jsonRpc.detach("LoginStatusChanged");
            AWL.jsonRpc.detach("IncomingCall");
            AWL.jsonRpc.detach("makeCall");
            AWL.jsonRpc.detach("transferCall");
            AWL.jsonRpc.detach("answerCall");
            AWL.jsonRpc.detach("CallProgressing");
            AWL.jsonRpc.detach("rejectCall");
            AWL.jsonRpc.detach("abortCall");
            AWL.jsonRpc.detach("endCall");
            AWL.jsonRpc.detach("holdCall");
            AWL.jsonRpc.detach("unholdCall");
            AWL.jsonRpc.detach("CallDisconnected");
            AWL.jsonRpc.detach("CallHeld");
            AWL.jsonRpc.detach("CallUnheld");
            AWL.jsonRpc.detach("CallConnected");
            AWL.jsonRpc.detach("CallTransferSuccessful");
            AWL.jsonRpc.detach("CallTransferFailed");
            AWL.jsonRpc.detach("CallCtiEventReceived");
            AWL.jsonRpc.detach("FarEndChanged");
            AWL.jsonRpc.detach("getGatewaySettings");
            AWL.jsonRpc.detach("GatewaySettingsChanged");
            AWL.jsonRpc.detach("renewToken");
            AWL.jsonRpc.detach("GatewayHAModeChanged");
          }
          AWL.jsonRpc = null;
        }
      }
      function Z() {
        AWL.connectionmanager.getInstance().destroyWebsocketConnection();
      }
      function z() {
        if (c === null) {
          window.AudioContext =
            window.AudioContext || window.webkitAudioContext;
          c = new AudioContext();
          var al = document.getElementById(
            AWL.configuration.getInstance().getDomElements().relayAudioTagId
          );
          ab = c.createMediaElementSource(al);
          O = c.createMediaStreamDestination();
          ab.connect(O);
        }
        return O.stream;
      }
      function H(am, al) {
        if (am.toUpperCase().indexOf(al.toUpperCase()) !== -1) {
          return true;
        }
        return false;
      }
      function v(am) {
        if (am.type !== null) {
          j.type = am.type;
        } else {
          i === R.PASSWORD
            ? (j.type = CONST.SESSION.toLowerCase())
            : (j.type = CONST.ESNA.toLowerCase());
        }
        j.token = am.token;
        j.expiry = am.expiry;
        var ao = j.expiry * 0.6;
        var al = j.expiry * 0.9;
        var an = ad(ao, al);
        if (y !== null) {
          clearTimeout(y);
        }
        y = setTimeout(ag, an * 1000);
        AWL.console.debug(
          "Registration_11_0version: Authentication token will be renewed in " +
            Math.round((an / 60) * 100) / 100 +
            " minutes"
        );
        am = null;
        ao = null;
        al = null;
      }
      function C() {
        var al = B.getPreferredServerConfig();
        if (Y.ipAddr !== al.ipAddr) {
          al = B.getAlternateServerConfig();
        }
        Q(al.haData.backupGateway.address, A.Secondary);
        u(AWL.CLIENT_STATUS.FAILING_OVER);
        U({
          result: CONST.AWL_MSG_FAILING_OVER,
          reason: "Trying alternate server [ " + Y.ipAddr + " ] ...",
        });
        if (I !== null) {
          clearTimeout(I);
        }
        I = setTimeout(S, x);
      }
      function T() {
        AWL.console.debug(
          "Registration_11_0version: Reconnection attempt : " + (aj + 1)
        );
        var al;
        if (aj < 2) {
          if (aj === 0) {
            AWL.callmanager
              .getInstance()
              .cleanUpCallsIfRequired("GW connection lost");
            u(AWL.CLIENT_STATUS.RECONNECTING);
            al = G;
            AWL.onRegistrationStateChange.notify({
              result: CONST.AWL_MSG_RECONNECTING,
              reason:
                "Lost Connection to Server. Attempting to reconnect to " +
                Y.ipAddr +
                " ...",
            });
          } else {
            al = aa;
          }
          W();
          Z();
          s = false;
          if (y !== null) {
            clearTimeout(y);
          }
          y = null;
          aj++;
          if (I !== null) {
            clearTimeout(I);
          }
          I = setTimeout(S, al);
        } else {
          C();
        }
      }
      function t(al) {
        if (typeof al !== "undefined" && al !== null) {
          if (
            al.token !== null &&
            al.token !== "" &&
            al.expiry !== null &&
            al.expiry > 0
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      function ad(am, al) {
        return Math.floor(Math.random() * (al - am + 1) + am);
      }
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
function resiliencymodule() {
  var a;
  var b = function () {
    var c = false;
    var d = {
      ipAddr: AWL.configuration.getInstance().getConfiguration().Gateway.ip,
      haData: {
        haSupported: false,
        haEnabled: false,
        backupGateway: { serverType: "", address: "", domain: "", port: "" },
        haFailoverTime: -99,
        haFailbackTime: -99,
      },
    };
    var e = {
      ipAddr: "",
      haData: {
        haSupported: false,
        haEnabled: false,
        backupGateway: { serverType: "", address: "", domain: "", port: "" },
        haFailoverTime: -99,
        haFailbackTime: -99,
      },
    };
    this.getPreferredServerConfig = function () {
      return d;
    };
    this.setPreferredServerConfig = function (g) {
      if (g.ipAddr != null && g.ipAddr !== "") {
        d.ipAddr = g.ipAddr;
      } else {
        AWL.console.error(
          "Resiliency manager: Gateway IP received for preferred server is null or empty"
        );
      }
      var f = JSON.parse(JSON.stringify(g.haData));
      if (
        f.haSupported != null &&
        f.haSupported == true &&
        f.haEnabled != null &&
        f.haEnabled == true
      ) {
        if (this.isHADataValid(f)) {
          d.haData = f;
        } else {
          AWL.console.error(
            "Resiliency manager: High availability data received for preferred server is incorrect"
          );
        }
      }
      f = null;
    };
    this.getAlternateServerConfig = function () {
      return e;
    };
    this.setAlternateServerConfig = function (g) {
      if (g.ipAddr != null && g.ipAddr !== "") {
        e.ipAddr = g.ipAddr;
      } else {
        AWL.console.error(
          "Resiliency manager: Gateway IP received for alternate server is null or empty"
        );
      }
      var f = JSON.parse(JSON.stringify(g.haData));
      if (
        f.haSupported != null &&
        f.haSupported == true &&
        f.haEnabled != null &&
        f.haEnabled == true
      ) {
        if (this.isHADataValid(f)) {
          e.haData = f;
        } else {
          AWL.console.error(
            "Resiliency manager: High availability data received for alternate server is incorrect"
          );
        }
      }
      f = null;
    };
    this.isHADataValid = function (f) {
      if (f != null) {
        if (
          f.backupGateway != null &&
          f.haFailoverTime != null &&
          f.haFailbackTime != null &&
          f.backupGateway.serverType != null &&
          f.backupGateway.address != null &&
          f.backupGateway.domain != null &&
          f.backupGateway.port != null
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    };
    this.setResiliencyFlag = function (f) {
      c =
        !AWL.configuration.getInstance().getConfiguration().disableResiliency &&
        f;
    };
    this.isResiliencySupported = function () {
      return c;
    };
    this.resetResiliencyData = function () {
      d = {
        ipAddr: "",
        haData: {
          haSupported: false,
          haEnabled: false,
          backupGateway: { serverType: "", address: "", domain: "", port: "" },
          haFailoverTime: -99,
          haFailbackTime: -99,
        },
      };
      e = {
        ipAddr: "",
        haData: {
          haSupported: false,
          haEnabled: false,
          backupGateway: { serverType: "", address: "", domain: "", port: "" },
          haFailoverTime: -99,
          haFailbackTime: -99,
        },
      };
      c = false;
    };
  };
  return {
    getInstance: function () {
      if (!a) {
        a = new b();
      }
      return a;
    },
  };
}
AWL.newPackage(
  "com.avaya.awl.call.utility",
  (function () {
    var a = function (c) {
      var d = Math.floor(Math.random() * 2000 + 1);
      d = CryptoJS.MD5(c + d);
      AWL.console.debug("\nRandom: " + d);
      return "" + d + "@" + location.hostname;
    };
    var b = function (d) {
      var c = document.createElement("audio");
      c.id = d;
      c.autoplay = true;
      document.body.appendChild(c);
    };
    return { getNewCallId: a, createAudioTag: b };
  })()
);
AWL.newPackage("com.avaya.awl.clientCallObj", function (l) {
  var c = l;
  var b = function () {
    return c.getCallID();
  };
  var g = function () {
    return c.getCallState();
  };
  var k = function () {
    return c.getFarEndNumber();
  };
  var d = function () {
    return c.getFarEndName();
  };
  var j = function () {
    return c.getSipUri();
  };
  var h = function () {
    return c.getSubject();
  };
  var i = function () {
    return c.isAutoAnswer();
  };
  var a = function () {
    return c.isVideoCall();
  };
  var e = function () {
    return c.getLocalStream();
  };
  var f = function () {
    return c.getRemoteStream();
  };
  return {
    getCallId: b,
    getCallState: g,
    getFarEndNumber: k,
    getFarEndName: d,
    getSipUri: j,
    getSubject: h,
    isAutoAnswer: i,
    isVideoCall: a,
    getLocalStream: e,
    getRemoteStream: f,
  };
});
AWL.namespace("devicemanager");
AWL.devicemanager = (function () {
  var a;
  var b = function () {
    this.getDeviceInfo = function () {
      AWL.console.debug("devicemanager : getDeviceInfo");
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        AWL.console.error("enumerateDevices() not supported.");
        return;
      }
      var c = [];
      navigator.mediaDevices.enumerateDevices().then(function (d) {
        d.forEach(function (e) {
          c.push([e.kind, e.label, e.deviceId]);
        });
        AWL.onDeviceListRequested.notify(c);
      });
    };
    this.getUserMedia = function (e, f) {
      var d = e;
      AWL.console.debug("devicemanager : getUserMedia :: callType : " + f);
      if (f === "videoOnly") {
        if (AWL.configuration.getInstance().getDeviceIds().videoInputID) {
          AWL.console.debug(
            "devicemanager : getUserMedia :: acquiring video device of Id " +
              AWL.configuration.getInstance().getDeviceIds().videoInputID
          );
          var c = {
            video: {
              optional: [
                { minFrameRate: 15 },
                { maxWidth: 352 },
                { maxHeight: 288 },
                {
                  sourceId: AWL.configuration.getInstance().getDeviceIds()
                    .videoInputID,
                },
              ],
            },
          };
        } else {
          AWL.console.debug(
            "devicemanager : getUserMedia :: acquiring default video device"
          );
          var c = {
            video: {
              optional: [
                { minFrameRate: 15 },
                { maxWidth: 352 },
                { maxHeight: 288 },
              ],
            },
          };
        }
      } else {
        if (AWL.configuration.getInstance().getDeviceIds().audioInputID) {
          AWL.console.debug(
            "devicemanager : getUserMedia :: acquiring audio device of Id " +
              AWL.configuration.getInstance().getDeviceIds().audioInputID
          );
          if (navigator.webkitGetUserMedia) {
            var c = {
              audio: {
                optional: [
                  {
                    sourceId: AWL.configuration.getInstance().getDeviceIds()
                      .audioInputID,
                  },
                ],
              },
            };
          } else {
            var c = {
              audio: {
                deviceId: AWL.configuration.getInstance().getDeviceIds()
                  .audioInputID
                  ? {
                      exact: AWL.configuration.getInstance().getDeviceIds()
                        .audioInputID,
                    }
                  : undefined,
              },
            };
          }
        } else {
          AWL.console.debug(
            "devicemanager : getUserMedia :: acquiring default audio device"
          );
          var c = { audio: true };
        }
        if (
          AWL.configuration.getInstance().getConfiguration().enableVideo &&
          f === "video"
        ) {
          if (AWL.configuration.getInstance().getDeviceIds().videoInputID) {
            AWL.console.debug(
              "devicemanager : getUserMedia :: acquiring video device of Id " +
                AWL.configuration.getInstance().getDeviceIds().videoInputID
            );
            if (navigator.webkitGetUserMedia) {
              c.video = {
                optional: [
                  { minFrameRate: 15 },
                  { maxWidth: 352 },
                  { maxHeight: 288 },
                  {
                    sourceId: AWL.configuration.getInstance().getDeviceIds()
                      .videoInputID,
                  },
                ],
              };
            } else {
              c.video = {
                deviceId: AWL.configuration.getInstance().getDeviceIds()
                  .videoInputID
                  ? {
                      exact: AWL.configuration.getInstance().getDeviceIds()
                        .videoInputID,
                    }
                  : undefined,
              };
            }
          } else {
            AWL.console.debug(
              "devicemanager : getUserMedia :: acquiring default video device"
            );
            c.video = {
              optional: [
                { minFrameRate: 15 },
                { maxWidth: 352 },
                { maxHeight: 288 },
              ],
            };
          }
        }
      }
      AWL.webrtc.getUserMedia(
        c,
        d.evtMediaDeviceAccessAcquired,
        d.evtMediaDeviceAccessFailed
      );
    };
  };
  return {
    getInstance: function () {
      if (!a) {
        a = new b();
      }
      return a;
    },
  };
})();
AWL.namespace("connectionmanager");
AWL.connectionmanager = (function () {
  var a;
  var c = null;
  var b = function () {
    this.createWebsocketConnection = function (g, d, f) {
      if (f !== null) {
        c = f;
        AWL.console.debug("connectionmanager : createWebsocketConnection");
        var e = "wss://" + g + ":" + d + "/SignalGateway/connect";
        AWL.wsConnection = new AWL.io.WebSocketConnection([
          "jsonrpc",
          "jsonrpc-3.0",
        ]);
        AWL.wsConnection.evtConnectionClose.attach(
          c.evtWebSocketConnectionCloseHandler
        );
        AWL.wsConnection.evtConnectionOpen.attach(
          c.evtWebSocketConnectionOpenHandler
        );
        AWL.wsConnection.open(e);
      }
    };
    this.destroyWebsocketConnection = function () {
      AWL.console.debug("connectionmanager : destroyWebsocketConnection");
      if (AWL.wsConnection) {
        AWL.wsConnection.evtConnectionClose.detach(
          c.evtWebSocketConnectionCloseHandler
        );
        AWL.wsConnection.evtConnectionOpen.detach(
          c.evtWebSocketConnectionOpenHandler
        );
        AWL.wsConnection.close();
        AWL.wsConnection = null;
      }
      c = null;
    };
    this.attachListener = function (d) {
      AWL.console.debug("connectionmanager : attachListener");
      c = d;
      AWL.wsConnection.evtConnectionClose.attach(
        c.evtWebSocketConnectionCloseHandler
      );
      AWL.wsConnection.evtConnectionOpen.attach(
        c.evtWebSocketConnectionOpenHandler
      );
    };
    this.detachListener = function (d) {
      AWL.console.debug("connectionmanager : detachListener");
      AWL.wsConnection.evtConnectionClose.detach(
        d.evtWebSocketConnectionCloseHandler
      );
      AWL.wsConnection.evtConnectionOpen.detach(
        d.evtWebSocketConnectionOpenHandler
      );
    };
  };
  return {
    getInstance: function () {
      if (!a) {
        a = new b();
      }
      return a;
    },
  };
})();
AWL.newPackage(
  "com.avaya.awl.loopBack",
  (function () {
    var a;
    var b = function () {
      var C = "";
      var o = "";
      var s = null;
      var h = null;
      var L = {};
      var F = null;
      var q = [];
      var k = null;
      var J = "";
      var e = new Array();
      var B = new Array();
      var I = {};
      var i = 0,
        r = 0,
        d = 0,
        H = 0,
        f = 0,
        E = 0,
        j = 0,
        c = 0,
        m = null;
      var x = false;
      var A = false;
      var t = false;
      var z = false;
      var p = false;
      var G = null;
      var y = this;
      var l = function (M) {
        C = M;
      };
      this.setLocalStream = function (M) {
        G = M;
      };
      this.createLoopBackConnection = function () {
        if (!z) {
          q = new Object();
          AWL.clientAPIConsole.debug("\nloopBack :: createLoopBackConnection");
          AWL.registration.getInstance().playStream();
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0 &&
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Turnserver.ip.trim().length !== 0
          ) {
            L.iceServers = [
              AWL.configuration.getInstance().getStunServerURL(),
              AWL.configuration.getInstance().getTurnServerURL(),
            ];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Stunserver.ip.trim().length !== 0
            ) {
              L.iceServers = [
                AWL.configuration.getInstance().getStunServerURL(),
              ];
            } else {
              if (
                AWL.configuration
                  .getInstance()
                  .getConfiguration()
                  .Turnserver.ip.trim().length !== 0
              ) {
                L.iceServers = [
                  AWL.configuration.getInstance().getTurnServerURL(),
                ];
              } else {
                L.iceServers = [];
              }
            }
          }
          o = "0";
          l(AWL.call.utility.getNewCallId(o));
          s = new AWL.webrtc.PeerConnection();
          s.evtRemoteStream.attach(g);
          s.evtLocalCandidates.attach(n);
          s.evtLocalDescription.attach(w);
          s.init({
            rtcConfiguration: L,
            constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
          });
          s.addStream(G);
          z = true;
          p = false;
          s.createOffer(
            function (M) {
              AWL.console.error("loopBack: createOffer failed: " + M);
            },
            { optional: [{ MozDontOfferDataChannel: true }] }
          );
        } else {
          AWL.console.debug("Duplicate loopback connection request: ignored");
        }
      };
      this.answerCall = function () {
        AWL.clientAPIConsole.debug("\nloopBack :: answerCall");
        if (
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Stunserver.ip.trim().length !== 0 &&
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Turnserver.ip.trim().length !== 0
        ) {
          L.iceServers = [
            AWL.configuration.getInstance().getStunServerURL(),
            AWL.configuration.getInstance().getTurnServerURL(),
          ];
        } else {
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0
          ) {
            L.iceServers = [AWL.configuration.getInstance().getStunServerURL()];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Turnserver.ip.trim().length !== 0
            ) {
              L.iceServers = [
                AWL.configuration.getInstance().getTurnServerURL(),
              ];
            } else {
              L.iceServers = [];
            }
          }
        }
        h = new AWL.webrtc.PeerConnection();
        h.evtRemoteStream.attach(g);
        h.evtICEConnectivity.attach(v);
        h.evtLocalCandidates.attach(n);
        h.evtLocalDescription.attach(w);
        h.init({
          rtcConfiguration: L,
          constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
        });
        h.addStream(G);
        var M = { sdp: F, type: "offer" };
        h.setRemoteDescription(
          M,
          function (N) {
            AWL.console.error("setRemoteDescriptionErrorHandler: " + N);
          },
          { optional: [{ MozDontOfferDataChannel: true }] }
        );
      };
      this.endLoopBackConnection = function () {
        if (z) {
          p = true;
          AWL.clientAPIConsole.debug("loopBack :: endLoopBackConnection");
          if (AWL.jsonRpc !== null) {
            AWL.jsonRpc.sendRequest("endCall", C);
          }
        }
      };
      this.getLoopBackStats = function () {
        AWL.clientAPIConsole.debug("loopBack :: getLoopBackStats");
        if (s !== null) {
          if (navigator.mozGetUserMedia) {
            AWL.console.error(
              "loopBack :: getLoopBackStats not supported in firefox"
            );
          } else {
            k = setInterval(function () {
              s.getStats(function (P) {
                var O = P.result();
                for (var N = 0; N < O.length; N++) {
                  var M = O[N];
                  if (!M.local || M.local == M) {
                    K(M);
                  }
                }
              }, D);
              h.getStats(function (P) {
                var O = P.result();
                for (var N = 0; N < O.length; N++) {
                  var M = O[N];
                  if (!M.local || M.local == M) {
                    u(M);
                  }
                }
              }, D);
            }, 2000);
          }
        }
      };
      this.collectLoopBackStats = function () {
        AWL.clientAPIConsole.debug("loopBack :: collectLoopBackStats");
        if (navigator.mozGetUserMedia) {
          return null;
        } else {
          var M = [];
          M.audio = q;
          return M;
        }
      };
      this.resetCall = function (N) {
        AWL.console.debug("\nloopBack :: resetCall");
        F = null;
        o = "";
        J = "";
        if (s) {
          s.close();
          s = null;
        }
        if (h) {
          h.close();
          h = null;
        }
        AWL.registration.getInstance().stopStream();
        var M = document.getElementById(C);
        if (M != null) {
          AWL.webrtc.mediaReset(M);
          document.body.removeChild(M);
        }
        if (k !== null) {
          clearInterval(k);
          k = null;
          i = 0;
          H = 0;
          f = 0;
          m = null;
          E = 0;
          r = 0;
          d = 0;
          j = 0;
          c = 0;
          A = false;
          t = false;
          x = false;
        }
        if (z) {
          z = false;
          if (p || N === "clean up: tearing down the call forcefully") {
            AWL.onLoopBackNotification.notify({
              notification: CONST.AWL_MSG_LOOPBACK_CONN_CLOSED,
            });
          } else {
            AWL.onLoopBackNotification.notify({
              notification: CONST.AWL_MSG_LOOPBACK_CONN_FAILED,
            });
          }
        }
      };
      this.callStateHandler = function (N, M) {
        AWL.console.debug(
          "loopback: callStateHandler: msg: " + N + " Params: " + M
        );
        if (N === "CallDisconnected") {
          y.resetCall(M.reasonString);
        }
      };
      this.mediaAnswerHandler = function (Q, P) {
        if (Q === "CallConnected" && P) {
          if (P.sdp) {
            var M = P.sdp;
            AWL.console.debug("Answer: \n" + M);
            var N = { sdp: M, type: "answer" };
            s.setRemoteDescription(N, function (R) {
              AWL.console.error("setRemoteDescriptionErrorHandler: " + R);
            });
          }
          G.getAudioTracks().forEach(function (R) {
            I[R.id] = R.kind;
          });
          for (var O in I) {
            if (I[O] === "audio") {
              J = O;
              AWL.console.debug("audioTrackKey = " + J);
            }
          }
        }
      };
      this.incomingCallHandler = function (N, M) {
        AWL.console.debug("loopback :: incomingCallHandler ");
        if (M) {
          o = M.FarEndDn;
          F = M.sdp;
          y.answerCall(C);
        }
      };
      this.callUpdateHandler = function (N, M) {};
      function g(O, N) {
        AWL.console.debug("evtRemoteStreamHandler: " + N.type);
        if (N.type === "audio") {
          AWL.call.utility.createAudioTag(C);
          var M = document.getElementById(C);
          AWL.webrtc.mediaSetStream(M, N.stream);
        }
      }
      function w(N, M) {
        AWL.console.debug("evtLocalDescriptionHandler");
        if (F) {
          AWL.console.debug("Answer: \n" + M.sdp);
          AWL.jsonRpc.sendRequest("answerCall", C, M.sdp);
        } else {
          AWL.console.debug("Offer: \n" + M.sdp);
          AWL.jsonRpc.sendRequest("makeCall", o, C, M.sdp);
        }
      }
      function n(N, M) {
        AWL.console.debug("evtLocalCandidatesHandler: " + M);
      }
      function K(R) {
        if (R.names) {
          var Q = R.names();
          for (var O = 0; O < Q.length; O++) {
            var N = Q[O];
            var P = R.stat(N);
            if (!A) {
              if (N === "googLocalAddress") {
                q.localAddress = P;
                A = true;
              }
            }
            if (!t) {
              if (N === "googRemoteAddress") {
                q.remoteAddress = P;
                t = true;
              }
            }
            if (N === "googTrackId" && P === J) {
              for (var O = 0; O < Q.length; O++) {
                var N = Q[O];
                var P = R.stat(N);
                if (N === "googJitterReceived") {
                  q.totJitter = P;
                }
                if (N === "packetsSent") {
                  q.totPSent = P;
                  AWL.console.debug("_statsArrayChrome[totPSent] = " + P);
                  d = P;
                  f = d - H;
                  AWL.console.debug("_statsArrayChrome[nowPSent] = " + f);
                  H = P;
                }
                if (N === "packetsLost") {
                  q.totPLost = P;
                  r = P;
                  var M = r - i;
                  q.nowPLoss = M;
                  AWL.console.debug("_statsArrayChrome[nowPLoss] = " + M);
                  i = P;
                  if (d > 0) {
                    q.totPLossPercent = ((r / d) * 100).toFixed(2);
                  }
                  if (f > 0) {
                    if (m === 0) {
                      AWL.console.warn("100% packet loss");
                      q.nowPLossPercent = 100;
                      AWL.console.debug("_ignoreCompletePLoss : true ");
                      x = true;
                    } else {
                      if (!x) {
                        if (M > f) {
                          M = 0;
                        }
                        q.nowPLossPercent = (M / f) * 100;
                      } else {
                        if (M !== 0) {
                          q.nowPLossPercent = 0;
                        } else {
                          if (M > f) {
                            M = 0;
                          }
                          q.nowPLossPercent = (M / f) * 100;
                          x = false;
                          AWL.console.debug("_ignoreCompletePLoss : false ");
                        }
                      }
                    }
                  }
                  AWL.console.debug(
                    "_statsArrayChrome[nowPLossPercent] :  " + q.nowPLossPercent
                  );
                }
                if (N === "googRtt") {
                  P = P / 1000;
                  if (P > 0) {
                    if (q.nowPLossPercent !== 100) {
                      q.nowRTT = P;
                    } else {
                      q.nowRTT = null;
                      P = null;
                    }
                  } else {
                    q.nowRTT = null;
                    P = null;
                  }
                  if (P !== null) {
                    E = E + P;
                    B.push(P);
                  }
                  q.minRTT = Math.min.apply(Math, B);
                  q.maxRTT = Math.max.apply(Math, B);
                  q.avgRTT = (E / B.length).toFixed(2);
                  AWL.console.debug("_statsArrayChrome: avgRTT=" + q.avgRTT);
                }
              }
            }
          }
        }
      }
      function u(Q) {
        if (Q.names) {
          var P = Q.names();
          for (var N = 0; N < P.length; N++) {
            var M = P[N];
            var O = Q.stat(M);
            if (M === "packetsReceived") {
              q.totPReceived = O;
              AWL.console.debug("_statsArrayChrome[totPReceived] = " + O);
              j = O;
              m = j - c;
              AWL.console.debug("_statsArrayChrome[nowPRecv] = " + m);
              c = O;
              if (m === 0) {
                AWL.console.warn("No Packets received, possibly packet loss");
              }
            }
          }
        }
      }
      function v(N, M) {
        AWL.console.debug("evtICEConnectivityHandler: " + M.iceStatus);
        if (M.iceStatus === "connected") {
          AWL.onLoopBackNotification.notify({
            notification: CONST.AWL_MSG_LOOPBACK_CONN_SUCCESSFULL,
          });
        } else {
          if (M.iceStatus === "disconnected") {
            if (!p) {
              q.nowPLossPercent = 100;
              q.nowRTT = null;
              AWL.onLoopBackNotification.notify({
                notification: CONST.AWL_MSG_LOOPBACK_CONN_LINK_ISSUE,
              });
            }
          } else {
            if (M.iceStatus === "failed") {
              if (!p) {
                AWL.onLoopBackNotification.notify({
                  notification: CONST.AWL_MSG_LOOPBACK_CONN_FAILED,
                });
              }
            }
          }
        }
      }
      function D() {
        AWL.console.debug("notifyStatsError : stats failure");
        AWL.onLoopBackNotification.notify({
          notification: CONST.AWL_MSG_LOOPBACK_STATS_FAILURE,
        });
      }
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.callmanager",
  (function () {
    var a;
    var b = function () {
      var e = "",
        f = "",
        g = "";
      var i = null;
      this.incomingCallHandler = function (l, k) {
        AWL.console.debug("callmanager : incomingCallHandler");
        if (AWL.totalCalls == CONST.MAX_ALLOWED_CALL_COUNT) {
          AWL.console.debug("callmanager : Max Call Limit Reached");
          e.rejectCall();
        }
        if (k) {
          f = k.callId;
          if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
            var j = AWL.registration_11_0version
              .getInstance()
              .getClientStatus();
            if (
              j === AWL.CLIENT_STATUS.FAILING_OVER ||
              j === AWL.CLIENT_STATUS.FAILING_BACK
            ) {
              AWL.console.debug(
                "callmanager : Rejecting incoming call as client is in " +
                  j.toLowerCase() +
                  "  mode"
              );
              AWL.jsonRpc.sendRequest("rejectCall", f);
              return;
            }
          }
          e = d(f);
          e.inComingCallHandler(k);
        } else {
          AWL.console.error(
            "callmanager : Ignoring incoming call as there is no params"
          );
        }
      };
      this.callStateHandler = function (k, j) {
        AWL.console.debug(
          "callmanager: callStateHandler: msg: " + k + " Params: " + j
        );
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            if (e) {
              e.callStateHandler(k, j);
              if (k == "CallDisconnected") {
                e = null;
              }
            } else {
              AWL.console.error(
                "callmanager : callObj not defined for callId: " + f
              );
            }
          }
        } else {
          AWL.console.error(
            "callmanager : Ignoring callStateHandler events as there is no params"
          );
        }
      };
      this.callProgressHandler = function (k, j) {
        AWL.console.debug("callmanager: callProgressHandler");
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            if (e) {
              e.callProgressHandler(k, j);
            } else {
              AWL.console.error(
                "callmanager: couldn't find the call object for call-id: " + f
              );
            }
          }
        }
      };
      this.mediaAnswerHandler = function (k, j) {
        AWL.console.debug("callmanager : mediaAnswerHandler");
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            if (e) {
              e.mediaAnswerHandler(k, j);
            } else {
              AWL.console.error(
                "callmanager : callObj not defined for callId: " + f
              );
            }
          }
        } else {
          AWL.console.error(
            "callmanager : Ignoring mediaAnswerHandler as there is no params"
          );
        }
      };
      this.callUpdateHandler = function (k, j) {
        AWL.console.debug("callUpdateHandler: msgName: " + k + " Params: " + j);
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            e.callUpdateHandler(k, j);
          }
        } else {
          AWL.console.error(
            "callmanager : Ignoring callUpdateHandler as there is no params"
          );
        }
      };
      this.callControllerHandler = function (k, j) {
        AWL.console.debug("callmanager : callControllerHandler");
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            e.callControllerHandler(k, j);
          }
        } else {
          AWL.console.error(
            "callmanager : Ignoring callControllerHandler as there is no params"
          );
        }
      };
      this.mediaUpdateHandler = function (k, j) {
        AWL.console.debug("callmanager : mediaUpdateHandler");
        if (j) {
          if (j.callId) {
            f = j.callId;
            e = AWL.callMap[f];
            if (e) {
              e.mediaUpdateHandler(k, j);
            } else {
              AWL.console.error(
                "callmanager: Ignoring mediaUpdateHandler as callObj not available for callId: " +
                  f
              );
            }
          }
        } else {
          AWL.console.error(
            "callmanager : Ignoring mediaUpdateHandler as there is no params"
          );
        }
      };
      function d(j) {
        if (AWL.callMap === null) {
          AWL.callMap = {};
        }
        e = new AWL.callsession();
        e.setCallID(j);
        AWL.callMap[e.getCallID()] = e;
        return e;
      }
      this.autoHoldIfRequired = function () {
        for (var j in AWL.callMap) {
          e = AWL.callMap[j];
          if (e.isCallActive() && e.isCallConnected()) {
            e.doHold();
          } else {
            if (e.getCallState() !== CONST.AWL_MSG_CALL_HELD) {
              e.cancelCall();
            }
          }
        }
      };
      this.cleanUpCallsIfRequired = function (k) {
        for (var j in AWL.callMap) {
          e = AWL.callMap[j];
          if (
            e.getCallState() !== CONST.AWL_MSG_CALL_IDLE &&
            e.getCallState() !== CONST.AWL_MSG_CALL_DISCONNECTED
          ) {
            e.resetCall(k);
          }
        }
      };
      this.makeCall = function (j, k) {
        if (
          AWL.callMap !== null &&
          Object.keys(AWL.callMap).length &&
          Object.keys(AWL.callMap).length > 0
        ) {
          this.autoHoldIfRequired();
        } else {
          if (AWL.callMap === null) {
            AWL.callMap = {};
          }
        }
        e = new AWL.callsession();
        e.setCallID(AWL.call.utility.getNewCallId(j));
        e.setFarEndNumber(j);
        g = new AWL.clientCallObj(e);
        AWL.callMap[e.getCallID()] = e;
        h(e, j, k);
        return g;
      };
      var h = function (l, m, n) {
        var j = true;
        for (var k in AWL.callMap) {
          e = AWL.callMap[k];
          if (
            l.getCallID() === k ||
            e.getCallState() === CONST.AWL_MSG_CALL_HELD
          ) {
            j = true;
          } else {
            j = false;
            break;
          }
        }
        if (!j) {
          if (i !== null) {
            clearTimeout(i);
            i = null;
          }
          AWL.console.debug("callmanager :: All calls are not in Held State");
          i = setTimeout(function () {
            h(l, m, n);
          }, 100);
        } else {
          if (i !== null) {
            clearTimeout(i);
            i = null;
          }
          AWL.console.debug("callmanager :: All calls are in Held State");
          AWL.console.debug("\ncallmanager :: makeCall");
          if (typeof m === "undefined") {
            m = 0;
          }
          l.makeCall(m, n, g);
        }
      };
      this.transferCall = function (l, k, j) {
        AWL.console.debug("\ncallmanager :: _transferCall");
        if (typeof AWL.callMap[k] !== "undefined") {
          e = AWL.callMap[k];
          e.transferCall(l, k, j);
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in transferCall API is incorrect! - call not transfered"
          );
        }
      };
      this.answerCall = function (k) {
        AWL.console.debug("\ncallmanager :: answerCall");
        if (typeof AWL.callMap[k] !== "undefined") {
          for (var j in AWL.callMap) {
            if (j !== k) {
              AWL.console.debug("\ncallmanager :: have another call");
              e = AWL.callMap[j];
              if (e.isCallActive() && e.isCallConnected()) {
                e.doHold();
              }
            }
          }
          c(k);
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in answerCall API is incorrect! - call not answered"
          );
        }
      };
      var c = function (l) {
        var j = true;
        for (var k in AWL.callMap) {
          e = AWL.callMap[k];
          if (
            l === k ||
            e.getCallState() === CONST.AWL_MSG_CALL_HELD ||
            e.getCallState() === CONST.AWL_MSG_CALL_INCOMING
          ) {
            j = true;
          } else {
            j = false;
            break;
          }
        }
        if (!j) {
          if (i !== null) {
            clearTimeout(i);
            i = null;
          }
          i = setTimeout(function () {
            c(l);
          }, 100);
        } else {
          if (i !== null) {
            clearTimeout(i);
            i = null;
          }
          e = AWL.callMap[l];
          if (e.getCallState() === CONST.AWL_MSG_CALL_INCOMING) {
            e.answerCall();
          }
        }
      };
      this.rejectCall = function (j) {
        AWL.console.debug("\ncallmanager :: rejectCall");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.rejectCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in rejectCall API is incorrect! - call not rejected"
          );
        }
      };
      this.dropCall = function (j) {
        AWL.console.debug("\ncallmanager :: dropCall");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.dropCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in dropCall API is incorrect! - call not dropped"
          );
        }
      };
      this.cancelCall = function (j) {
        AWL.console.debug("\ncallmanager :: cancelCall");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.cancelCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in cancelCall API is incorrect! - call not cancelled"
          );
        }
      };
      this.doHold = function (j) {
        AWL.console.debug("\ncallmanager :: doHold");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.doHold();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doHold API is incorrect! - call not held"
          );
        }
      };
      this.doUnHold = function (j) {
        AWL.console.debug("\ncallmanager :: doUnHold");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.doUnHold();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doUnHold API is incorrect! - call not unheld"
          );
        }
      };
      this.doMute = function (j) {
        AWL.console.debug("\ncallmanager :: doMute");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          return e.doMute();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doMute API is incorrect! - mic not muted"
          );
          return false;
        }
      };
      this.doUnMute = function (j) {
        AWL.console.debug("\ncallmanager :: doUnMute");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          return e.doUnMute();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doUnMute API is incorrect! - mic not unmuted"
          );
          return false;
        }
      };
      this.pauseVideo = function (j) {
        AWL.console.debug("\ncallmanager :: pauseVideo");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          return e.pauseVideo();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in pauseVideo API is incorrect! - video not paused"
          );
          return false;
        }
      };
      this.playVideo = function (j) {
        AWL.console.debug("\ncallmanager :: playVideo");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          return e.playVideo();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in playVideo API is incorrect! - video not resumed"
          );
          return false;
        }
      };
      this.sendDTMF = function (j, k) {
        AWL.console.debug("\ncallmanager :: sendDTMF");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.sendDTMF(k);
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in sendDTMF API is incorrect! - DTMF not sent"
          );
        }
      };
      this.getStats = function (j) {
        AWL.console.debug("\ncallmanager :: getStats");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.getstats();
          return e.collectStats();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in getStats API is incorrect! - getStats not called"
          );
        }
      };
      this.addVideo = function (j) {
        AWL.console.debug("\ncallmanager :: addVideo");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.addVideo();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in addVideo API is incorrect! - addVideo not done"
          );
        }
      };
      this.removeVideo = function (j) {
        AWL.console.debug("\ncallmanager :: removeVideo");
        if (typeof AWL.callMap[j] !== "undefined") {
          e = AWL.callMap[j];
          e.removeVideo();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in removeVideo API is incorrect! - removeVideo not done"
          );
        }
      };
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.callmanager_9_1version",
  (function () {
    var a;
    var b = function () {
      var d = "",
        e = "",
        f = "";
      this.incomingCallHandler = function (g) {
        AWL.console.debug("callmanager_9_1version : incomingCallHandler");
        if (AWL.totalCalls == 2) {
          AWL.console.debug("callmanager_9_1version : Max Call Limit Reached");
          d.rejectCall();
        }
        e = g[2];
        d = c(e);
        d.inComingCallHandler(g);
      };
      this.callStateHandler = function (g) {
        AWL.console.debug(
          "callmanager_9_1version: callStateHandler: State: " +
            g[0] +
            " Param: " +
            g[1]
        );
        e = g[2];
        d = AWL.callMap[e];
        if (typeof d !== "undefined") {
          d.callStateHandler(g);
          if (
            d != null &&
            d.getCallState() == CONST.AWL_MSG_CALL_DISCONNECTED
          ) {
            d = null;
          }
        } else {
          AWL.console.error(
            "callmanager_9_1version : callObj not available for callId: " + e
          );
        }
      };
      this.mediaAnswerHandler = function (g) {
        AWL.console.debug("callmanager_9_1version : mediaAnswerHandler");
        e = g[1];
        d = AWL.callMap[e];
        if (typeof d !== "undefined") {
          d.mediaAnswerHandler(g);
        } else {
          AWL.console.error(
            "callmanager_9_1version : callObj not available for callId: " + e
          );
        }
      };
      this.callUpdateHandler = function (g) {
        AWL.console.debug(
          "callUpdateHandler: Type: " + g[0] + " Param: " + g[1]
        );
        if (g[0] === "displayupdate") {
          e = g[2];
          d = AWL.callMap[e];
          if (typeof d !== "undefined") {
            d.callUpdateHandler(g);
          } else {
            AWL.console.error(
              "callmanager_9_1version : callObj not available for callId: " + e
            );
          }
        }
      };
      this.callControllerHandler = function (g) {
        AWL.console.debug("callmanager_9_1version : callControllerHandler");
        e = g[0];
        d = AWL.callMap[e];
        if (typeof d !== "undefined") {
          d.callControllerHandler(g);
        } else {
          AWL.console.error(
            "callmanager_9_1version : callObj not available for callId: " + e
          );
        }
      };
      function c(g) {
        if (AWL.callMap === null) {
          AWL.callMap = {};
        }
        d = new AWL.callsession_9_1version();
        d.setCallID(g);
        AWL.callMap[d.getCallID()] = d;
        return d;
      }
      this.autoHoldIfRequired = function () {
        for (var g in AWL.callMap) {
          d = AWL.callMap[g];
          if (d.isCallActive()) {
            d.doHold();
          }
        }
      };
      this.cleanUpCallsIfRequired = function (h) {
        for (var g in AWL.callMap) {
          d = AWL.callMap[g];
          if (
            d.getCallState() !== CONST.AWL_MSG_CALL_IDLE &&
            d.getCallState() !== CONST.AWL_MSG_CALL_DISCONNECTED
          ) {
            d.resetCall(h);
          }
        }
      };
      this.makeCall = function (g, h) {
        AWL.console.debug("\ncallmanager_9_1version :: makeCall");
        if (
          AWL.callMap !== null &&
          Object.keys(AWL.callMap).length &&
          Object.keys(AWL.callMap).length > 0
        ) {
          this.autoHoldIfRequired();
        } else {
          if (AWL.callMap === null) {
            AWL.callMap = {};
          }
        }
        d = new AWL.callsession_9_1version();
        if (typeof g === "undefined") {
          g = 0;
        }
        d.setCallID(AWL.call.utility.getNewCallId(g));
        f = new AWL.clientCallObj(d);
        AWL.callMap[d.getCallID()] = d;
        d.makeCall(g, h, f);
        return f;
      };
      this.answerCall = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: answerCall");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.answerCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in answerCall API is incorrect! - call not answered"
          );
        }
      };
      this.rejectCall = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: rejectCall");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.rejectCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in rejectCall API is incorrect! - call not rejected"
          );
        }
      };
      this.dropCall = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: dropCall");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.dropCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in dropCall API is incorrect! - call not dropped"
          );
        }
      };
      this.cancelCall = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: cancelCall");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.cancelCall();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in cancelCall API is incorrect! - call not cancelled"
          );
        }
      };
      this.doHold = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: doHold");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.doHold();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doHold API is incorrect! - call not held"
          );
        }
      };
      this.doUnHold = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: doUnHold");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.doUnHold();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doUnHold API is incorrect! - call not unheld"
          );
        }
      };
      this.doMute = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: doMute");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          return d.doMute();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doMute API is incorrect! - mic not muted"
          );
          return false;
        }
      };
      this.doUnMute = function (g) {
        AWL.console.debug("\ncallmanager_9_1version :: doUnMute");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          return d.doUnMute();
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in doUnMute API is incorrect! - mic not unmuted"
          );
          return false;
        }
      };
      this.sendDTMF = function (g, h) {
        AWL.console.debug("\ncallmanager_9_1version :: sendDTMF");
        if (typeof AWL.callMap[g] !== "undefined") {
          d = AWL.callMap[g];
          d.sendDTMF(h);
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: CallId passed in sendDTMF API is incorrect! - DTMF not sent"
          );
        }
      };
    };
    return {
      getInstance: function () {
        if (!a) {
          a = new b();
        }
        return a;
      },
    };
  })()
);
AWL.newPackage(
  "com.avaya.awl.callsession",
  (function () {
    var a = function () {
      var S = this;
      var C = "";
      var aj = null;
      var aH = "";
      var au = "";
      var Y = "";
      var U = "";
      var ar = null;
      var v = false;
      var k = null;
      var q = false;
      var at = {};
      var az = false;
      var aE = false;
      var l = null;
      var o = null;
      var ab = null;
      var Q = false;
      var B = "";
      var af = CONST.AWL_MSG_CALL_IDLE;
      var t = "";
      var ag = false;
      var an = new Object();
      var W = new Object();
      var aG = new Object();
      var b = null;
      var aC = "";
      var ac = "";
      var j = {};
      var K = false;
      var N = false;
      var aq = null;
      var aI = null;
      var H = false;
      var am = null;
      var f = false;
      var r = [];
      var O = {
        answerCall: "answerCallResponse",
        holdCall: "holdCallResponse",
        unholdCall: "unholdCallResponse",
        transferCall: "transferCallResponse",
        abortCall: "abortCallResponse",
        endCall: "endCallResponse",
      };
      var av = null;
      var ai = "";
      var i = false;
      var s = false;
      var aA = null;
      var L = null;
      var aJ = null;
      var X = null;
      var ap = false;
      var ad = false;
      var I = false;
      var E = false;
      var m = false;
      var aD = false;
      var R = "";
      var aF = { PASSIVE: "passive", ACTIVE: "active" };
      var n = "";
      var ax = { CONNECTED: "connected", COMPLETED: "completed" };
      at.sdpSemantics = "unified-plan";
      this.setCallID = function (aL) {
        C = aL;
      };
      this.getCallID = function () {
        return C;
      };
      this.getCallState = function () {
        return af;
      };
      this.getFarEndNumber = function () {
        return aH;
      };
      this.setFarEndNumber = function (aL) {
        if (typeof aL !== "undefined" && aL !== null) {
          aH = aL;
        } else {
          AWL.clientAPIConsole.error(
            "Invalid target. Could not set FarEnd's Number."
          );
        }
      };
      this.getFarEndName = function () {
        return au;
      };
      this.getSipUri = function () {
        return U;
      };
      this.getSubject = function () {
        return Y;
      };
      this.isAutoAnswer = function () {
        return ag;
      };
      this.isVideoCall = function () {
        return v;
      };
      this.getLocalStream = function () {
        if (k !== null) {
          return aj;
        } else {
          AWL.clientAPIConsole.debug(
            "\ncallsession :: getLocalStream is null, since it is a Audio Call"
          );
          return null;
        }
      };
      this.getRemoteStream = function () {
        return av;
      };
      this.isCallConnected = function () {
        return ap;
      };
      this.makeCall = function (aL, aN, aM) {
        AWL.clientAPIConsole.debug("\ncallsession :: makeCall");
        t = aM;
        aH = aL;
        ai = aN;
        if (aH.trim().length === 0) {
          return;
        }
        i = true;
        AWL.devicemanager.getInstance().getUserMedia(AWL.callMap[C], ai);
      };
      this.addVideo = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: addVideo");
        if (!Q) {
          AWL.clientAPIConsole.warn(
            "\ncallsession :: addVideo failed - call not active"
          );
          return false;
        }
        if (!v || !u(aI, true)) {
          if (AWL.configuration.getInstance().getConfiguration().enableVideo) {
            v = true;
          } else {
            AWL.clientAPIConsole.warn(
              "\ncallsession :: addVideo failed - Video configuration disabled"
            );
            return false;
          }
        } else {
          AWL.clientAPIConsole.warn(
            "\ncallsession :: addVideo failed - already on video call"
          );
          return false;
        }
        ad = true;
        aB();
        if (!s) {
          D("callUpgrade");
        }
      };
      function aB() {
        if (navigator.webkitGetUserMedia) {
          if (k !== null) {
            if (q) {
              if (k.length !== 0) {
                AWL.console.debug("callsession: Add available videoTracks");
                for (var aL = 0; aL < k.length; aL++) {
                  aj.addTrack(k[aL]);
                  AWL.console.debug("Video Tracks Id: " + k[aL].id);
                }
                q = false;
              }
            } else {
              AWL.clientAPIConsole.error(
                "callsession: Already on a video call"
              );
            }
          } else {
            AWL.devicemanager
              .getInstance()
              .getUserMedia(AWL.callMap[C], "videoOnly");
            s = true;
          }
        } else {
          if (aK()) {
            if (k !== null) {
              if (AWL.remVideo) {
                if (k.length !== 0) {
                  AWL.console.debug("callsession: Add available videoTracks");
                  for (var aL = 0; aL < k.length; aL++) {
                    aj.addTrack(k[aL]);
                    AWL.console.debug("Video Tracks Id: " + k[aL].id);
                  }
                  AWL.remVideo = false;
                }
              } else {
                AWL.clientAPIConsole.error(
                  "callsession: Already on a video call"
                );
              }
            } else {
              AWL.devicemanager
                .getInstance()
                .getUserMedia(AWL.callMap[C], "videoOnly");
              s = true;
            }
          }
        }
      }
      this.removeVideo = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: removeVideo");
        if (!Q) {
          AWL.clientAPIConsole.warn(
            "\ncallsession :: removeVideo failed - call not active"
          );
          return false;
        }
        if (v) {
          v = false;
        } else {
          AWL.clientAPIConsole.warn(
            "\ncallsession :: removeVideo failed - already on audio call"
          );
          return false;
        }
        p();
        D("callDowngrade");
      };
      function p() {
        if (aj !== null && typeof aj !== "undefined") {
          var aL = aj.getVideoTracks();
          for (var aM = 0; aM < aL.length; aM++) {
            aL[aM].stop();
            AWL.console.debug(
              "\ncallsession :: releasing Video Device from this callSession"
            );
          }
          aL = null;
        }
        if (navigator.webkitGetUserMedia) {
          if (k !== null) {
            if (!q) {
              if (k.length !== 0) {
                AWL.console.debug(
                  "callsession: Remove available local videoTracks"
                );
                for (var aM = 0; aM < k.length; aM++) {
                  aj.removeTrack(k[aM]);
                }
                q = true;
              }
            }
          }
          k = null;
        } else {
          if (aK()) {
            if (k !== null) {
              if (!AWL.remVideo) {
                if (k.length !== 0) {
                  AWL.console.debug(
                    "callsession: Remove available local videoTracks"
                  );
                  for (var aM = 0; aM < k.length; aM++) {
                    aj.removeTrack(k[aM]);
                  }
                  AWL.remVideo = true;
                }
              }
            }
          }
        }
      }
      function D(aL) {
        var aM = { mandatory: { iceRestart: false } };
        if (aL === "callUpgrade") {
          K = true;
          ar.createOffer(function (aN) {
            AWL.console.error("callsession: createOffer failed: " + aN);
            K = false;
          }, aM);
        } else {
          if (navigator.webkitGetUserMedia) {
            ar.setCustomLocalDescription("removeVideo", B, aI);
            setTimeout(function () {
              var aN = ar.getCustomLocalDescription("remVideo");
              AWL.jsonRpc.sendRequest("updateMedia", C, aN.sdp);
            }, 500);
            K = true;
          } else {
            if (AWL.webrtc.mozRenegotiationSupport()) {
              ar.createOffer(
                function (aN) {
                  AWL.console.error("callsession: createOffer failed: " + aN);
                  K = false;
                },
                aM,
                function () {
                  ar.setCustomLocalDescription("removeVideo", B, aI);
                  setTimeout(function () {
                    var aN = ar.getCustomLocalDescription("remVideo");
                    AWL.jsonRpc.sendRequest("updateMedia", C, aN.sdp);
                  }, 500);
                  K = true;
                }
              );
            }
          }
        }
      }
      this.isCallActive = function () {
        return Q;
      };
      this.answerCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: answerCall");
        if (!H) {
          if (v) {
            ai = "video";
          } else {
            ai = "audio";
          }
          i = false;
          AWL.devicemanager.getInstance().getUserMedia(AWL.callMap[C], ai);
        } else {
          M();
        }
      };
      this.transferCall = function (aN, aM, aL) {
        AWL.clientAPIConsole.debug(
          "\ncallsession :: transferCall :: target ::" + aN
        );
        if (aa(O.transferCall)) {
          AWL.clientAPIConsole.error(
            "callsession : Duplicate transferCall request - ignored!"
          );
          return;
        }
        r[O.transferCall] = true;
        AWL.jsonRpc.sendRequest("transferCall", aN, aM, aL);
      };
      this.rejectCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: rejectCall");
        AWL.jsonRpc.sendRequest("rejectCall", C);
        S.resetCall("Call Rejected");
      };
      this.dropCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: dropCall");
        if (aa(O.endCall)) {
          AWL.clientAPIConsole.error(
            "callsession : Duplicate dropCall request - ignored!"
          );
          return;
        }
        r[O.endCall] = true;
        AWL.jsonRpc.sendRequest("endCall", C);
        if (
          af !== CONST.AWL_MSG_CALL_CONNECTED &&
          af !== CONST.AWL_MSG_CALL_FAREND_UPDATE &&
          af !== CONST.AWL_MSG_CALL_HELD
        ) {
          S.resetCall("Call Dropped");
        }
      };
      this.cancelCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: cancelCall");
        if (aa(O.abortCall)) {
          AWL.clientAPIConsole.error(
            "callsession : Duplicate cancelCall request - ignored!"
          );
          return;
        }
        r[O.abortCall] = true;
        AWL.jsonRpc.sendRequest("abortCall", C);
        if (
          af !== CONST.AWL_MSG_CALL_CONNECTED &&
          af !== CONST.AWL_MSG_CALL_FAREND_UPDATE &&
          af !== CONST.AWL_MSG_CALL_HELD
        ) {
          S.resetCall("Call Dropped");
        }
      };
      this.doHold = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: doHold");
        if (aa(O.holdCall)) {
          AWL.clientAPIConsole.error(
            "callsession : Duplicate holdCall request - ignored!"
          );
          return;
        }
        d();
      };
      this.doUnHold = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: doUnHold");
        if (aa(O.unholdCall)) {
          AWL.clientAPIConsole.error(
            "callsession : Duplicate unholdCall request - ignored!"
          );
          return;
        }
        al();
      };
      this.doMute = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: doMute");
        return ah();
      };
      this.doUnMute = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: doUnMute");
        return J();
      };
      this.pauseVideo = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: pauseVideo");
        if (navigator.webkitGetUserMedia) {
          if (k !== null) {
            if (k.length !== 0) {
              for (var aL = 0; aL < k.length; aL++) {
                k[aL].enabled = false;
                AWL.console.debug("Video Tracks Id: " + k[aL].id);
              }
              AWL.clientAPIConsole.debug("\ncallsession: local video paused");
              return true;
            }
          }
        } else {
          if (k !== null) {
            if (k.length !== 0) {
              if (!AWL.muteAllStreams) {
                for (var aL = 0; aL < k.length; aL++) {
                  k[aL].enabled = false;
                  AWL.console.debug("Video Tracks Id: " + k[aL].id);
                  AWL.videoPaused = true;
                }
                AWL.clientAPIConsole.debug("\ncallsession: local video paused");
                return true;
              }
            }
          }
        }
        return false;
      };
      this.playVideo = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: playVideo");
        if (navigator.webkitGetUserMedia) {
          if (k !== null) {
            if (k.length !== 0) {
              for (var aL = 0; aL < k.length; aL++) {
                k[aL].enabled = true;
                AWL.console.debug("Video Tracks Id: " + k[aL].id);
              }
              AWL.clientAPIConsole.debug("\ncallsession: local video resumed");
              return true;
            }
          }
        } else {
          if (k !== null) {
            if (k.length !== 0) {
              if (!AWL.muteAllStreams) {
                for (var aL = 0; aL < k.length; aL++) {
                  k[aL].enabled = true;
                  AWL.console.debug("Video Tracks Id: " + k[aL].id);
                  AWL.videoPaused = false;
                }
                AWL.clientAPIConsole.debug(
                  "\ncallsession: local video resumed"
                );
                return true;
              }
            }
          }
        }
        return false;
      };
      this.sendDTMF = function (aN) {
        var aM = 500;
        var aO = 50;
        if (aj !== null) {
          var aL = aj.getAudioTracks()[0];
          o = ar.createDTMFSender(aL);
          if (o) {
            if (o.canInsertDTMF) {
              AWL.clientAPIConsole.debug("Call eligible to do DTMF");
              AWL.console.debug("Call eligible to do DTMF");
              o.insertDTMF(aN, aM, aO);
              o.ontonechange = F;
            } else {
              AWL.console.error(
                "\ncallsession :: Call not eligible to do dtmf"
              );
            }
          }
        }
      };
      this.resetCall = function (aS) {
        AWL.console.debug("\ncallsession :: resetCall");
        aG = null;
        an = null;
        W = null;
        aI = null;
        aq = null;
        clearInterval(b);
        ab = null;
        aH = "";
        au = "";
        U = "";
        Y = "";
        o = null;
        Q = false;
        ag = false;
        K = false;
        N = false;
        H = false;
        f = false;
        am = null;
        B = "";
        AWL.totalCalls--;
        m = false;
        aD = false;
        ap = false;
        R = "";
        ad = false;
        n = "";
        if (aE) {
          J();
        }
        if (
          AWL.configuration.getInstance().getDomElements().remoteVideo !== ""
        ) {
          var aN = document.getElementById(
            AWL.configuration.getInstance().getDomElements().remoteVideo
          );
          AWL.webrtc.mediaReset(aN);
        } else {
          if (aJ !== null) {
            AWL.webrtc.mediaReset(aJ);
          } else {
            AWL.console.debug(
              "resetCall: Application is handling the local stream/this is an audio call"
            );
          }
        }
        if (
          AWL.configuration.getInstance().getDomElements().localVideo !== ""
        ) {
          var aQ = document.getElementById(
            AWL.configuration.getInstance().getDomElements().localVideo
          );
          AWL.webrtc.mediaReset(aQ);
        } else {
          if (L !== null) {
            AWL.webrtc.mediaReset(L);
          } else {
            AWL.console.debug(
              "resetCall: Application is handling the remote stream/this is an audio call"
            );
          }
        }
        var aM = document.getElementById(C);
        if (aM != null) {
          AWL.webrtc.mediaReset(aM);
          document.body.removeChild(aM);
        }
        aM = null;
        if (av !== null && typeof av !== "undefined") {
          var aR = av.getAudioTracks();
          for (var aO = 0; aO < aR.length; aO++) {
            aR[aO].stop();
          }
        }
        av = null;
        if (aj !== null && typeof aj !== "undefined") {
          var aP = aj.getAudioTracks();
          for (var aO = 0; aO < aP.length; aO++) {
            aP[aO].stop();
            AWL.console.debug(
              "\ncallsession :: resetCall :: releasing Audio Device from this callSession"
            );
          }
          var aL = aj.getVideoTracks();
          for (var aO = 0; aO < aL.length; aO++) {
            aL[aO].stop();
            AWL.console.debug(
              "\ncallsession :: resetCall :: releasing Video Device from this callSession"
            );
          }
          l = null;
          k = null;
          aj = null;
          q = false;
        }
        v = false;
        delete AWL.callMap[C];
        r = [];
        if (af !== CONST.AWL_MSG_CALL_DISCONNECTED) {
          AWL.onCallStateChange.notify(C, t, af);
        }
        AWL.onCallTerminate.notify(C, aS);
        if (ar) {
          ar.close();
          ar = null;
        }
      };
      this.callStateHandler = function (aO, aM) {
        AWL.console.debug("callStateHandler: msgName: " + aO + " Param: " + aM);
        if (aa(aO)) {
          AWL.console.debug("Received pending response");
          delete r[aO];
        }
        if (aO === "CallDisconnected") {
          af = CONST.AWL_MSG_CALL_DISCONNECTED;
          ap = false;
          AWL.onCallStateChange.notify(C, t, af);
          S.resetCall(aM.reasonString);
        } else {
          if (aO === "CallTransferSuccessful") {
            AWL.clientAPIConsole.debug("\ncallsession: call is transferred");
            AWL.onCallStateChange.notify(
              C,
              t,
              CONST.AWL_MSG_CALL_TRANSFER_SUCCESS
            );
          } else {
            if (aO === "CallTransferFailed") {
              AWL.clientAPIConsole.debug("\ncallsession: call transfer Failed");
              af = CONST.AWL_MSG_CALL_TRANSFER_FAILED;
              AWL.onCallStateChange.notify(C, t, af);
              af = CONST.AWL_MSG_CALL_CONNECTED;
            } else {
              if (aO === "CallProgressing") {
                af = CONST.AWL_MSG_CALL_RINGING;
                AWL.onCallStateChange.notify(C, t, af);
              } else {
                if (aO === "CallUnheld") {
                  Q = true;
                  az = !az;
                  if (navigator.mozGetUserMedia) {
                    if (!AWL.webrtc.mozRenegotiationSupport()) {
                      ak();
                    }
                  }
                  if (navigator.webkitGetUserMedia) {
                    if (R !== "" && ai === "audio") {
                      var aN = A();
                      ar.setCustomRemoteDescription("unhold", aN, aq);
                    } else {
                      ar.setCustomRemoteDescription("unhold", B, aq);
                    }
                  } else {
                    if (AWL.webrtc.mozRenegotiationSupport()) {
                      ar.setCustomRemoteDescription("unhold", B, aq, v);
                    }
                  }
                  if (v) {
                    var aL = document.getElementById(
                      AWL.configuration.getInstance().getDomElements()
                        .remoteVideo
                    );
                    if (aL !== null) {
                      AWL.webrtc.mediaSetStream(aL, av);
                    } else {
                      if (aJ !== null) {
                        AWL.webrtc.mediaSetStream(aJ, av);
                      } else {
                        AWL.console.debug(
                          "callStateHandler: Not Attaching the remoteStreams since application is handling the Stream"
                        );
                      }
                    }
                  }
                  AWL.clientAPIConsole.debug("\ncallsession: call is unheld");
                  af = CONST.AWL_MSG_CALL_CONNECTED;
                  AWL.onCallStateChange.notify(C, t, af);
                } else {
                  if (aO === "CallHeld") {
                    Q = false;
                    az = !az;
                    if (navigator.mozGetUserMedia) {
                      if (!AWL.webrtc.mozRenegotiationSupport()) {
                        ak();
                      }
                    }
                    if (navigator.webkitGetUserMedia) {
                      if (R !== "" && ai === "audio") {
                        var aN = A();
                        ar.setCustomRemoteDescription("hold", aN, aq);
                      } else {
                        ar.setCustomRemoteDescription("hold", B, aq);
                      }
                    } else {
                      if (AWL.webrtc.mozRenegotiationSupport()) {
                        ar.setCustomRemoteDescription("hold", B, aq);
                      }
                    }
                    AWL.clientAPIConsole.debug("\ncallsession: call is held");
                    af = CONST.AWL_MSG_CALL_HELD;
                    AWL.onCallStateChange.notify(C, t, af);
                  }
                }
              }
            }
          }
        }
      };
      this.callProgressHandler = function (aM, aP) {
        AWL.console.debug("callProgressHandler: " + aM);
        if (aP) {
          if (aP.sdp) {
            AWL.console.debug(
              "CallProgressHandler: Early media received from gw"
            );
            var aL = aP.sdp;
            AWL.console.debug("CallProgressHandler: Early media sdp: \n" + aL);
            var aN = { sdp: aL, type: "answer" };
            aq = aN.sdp;
            ar.setRemoteDescription(aN, function (aQ) {
              AWL.console.error("setRemoteDescriptionErrorHandler: " + aQ);
            });
            I = true;
            af = CONST.AWL_MSG_CALL_PROGRESSING;
            aj.getAudioTracks()
              .concat(aj.getVideoTracks())
              .forEach(function (aQ) {
                j[aQ.id] = aQ.kind;
              });
            for (var aO in j) {
              if (j[aO] === "audio") {
                aC = aO;
              } else {
                ac = aO;
              }
            }
          } else {
            AWL.console.debug("no early media from gw");
            af = CONST.AWL_MSG_CALL_RINGING;
          }
          if (aP.FarEndDn) {
            z(aP.FarEndDn);
          }
          if (aP.sipUri) {
            U = aP.sipUri;
          }
          AWL.onCallStateChange.notify(C, t, af);
        }
      };
      this.mediaAnswerHandler = function (aP, aO) {
        if (aP === "CallConnected" && aO) {
          if (aO.sdp) {
            var aL = aO.sdp;
            AWL.console.debug("Answer: \n" + aL);
            if (I == false) {
              var aM = { sdp: aL, type: "answer" };
              aq = aM.sdp;
              ar.setRemoteDescription(aM, function (aQ) {
                AWL.console.error("setRemoteDescriptionErrorHandler: " + aQ);
              });
            } else {
              AWL.console.debug(
                "AWL-CallSession: Earley media answer already applied"
              );
            }
          }
          af = CONST.AWL_MSG_CALL_CONNECTED;
          ap = true;
          aj.getAudioTracks()
            .concat(aj.getVideoTracks())
            .forEach(function (aQ) {
              j[aQ.id] = aQ.kind;
            });
          for (var aN in j) {
            if (j[aN] === "audio") {
              aC = aN;
            } else {
              ac = aN;
            }
          }
          AWL.onCallStateChange.notify(C, t, af);
          if (
            ((v && !m && AWL.onVideoStreamsAvailable._listeners.length != 0) ||
              (!v &&
                !aD &&
                AWL.onAudioStreamsAvailable._listeners.length != 0)) &&
            (n == ax.CONNECTED || n == ax.COMPLETED)
          ) {
            g();
          }
        }
      };
      this.mediaUpdateHandler = function (aP, aN) {
        AWL.console.debug("callsession:mediaUpdateHandler - msgName: " + aP);
        switch (aP) {
          case "updateMediaResponse":
            AWL.console.debug(
              "callsession:UpdateMediaResponse - responseCode: " +
                aN.responseCode
            );
            if (aN.responseCode === "200") {
              if (K) {
                AWL.console.debug(
                  "callsession:Renegotiation - incoming Answer SDP received"
                );
                var aL = { sdp: aN.sdp, type: "answer" };
                aq = aN.sdp;
                if (ai === "audio" && v && R === "") {
                  R = aF.ACTIVE;
                  AWL.clientAPIConsole.debug(
                    "Remote Video DTLS role set to " + R
                  );
                }
                N = false;
                K = false;
                var aO = A();
                ar.setCustomRemoteDescription("update", aO, aN.sdp);
              }
            } else {
              AWL.console.warn("callsession:Renegotiation - UpdateMediaFailed");
              N = false;
              K = false;
              ar.setCustomLocalDescription("prevNegotiatedSDP", B, aI);
              setTimeout(function () {
                ar.setCustomRemoteDescription("prevNegotiatedSDP", B, aq);
              }, 100);
            }
            break;
          case "MediaUpdateRequest":
            if (!K && !N) {
              AWL.console.debug(
                "callsession:Renegotiation incoming Offer SDP received"
              );
              var aM = u(aq);
              aq = aN.sdp;
              v = c(aN.sdp);
              if (
                !AWL.configuration.getInstance().getConfiguration().enableVideo
              ) {
                if (v) {
                  aN.sdp = Z(aN.sdp);
                  aq = aN.sdp;
                  v = false;
                }
              } else {
                if (v) {
                  if (!aM) {
                    aB();
                  }
                } else {
                  p();
                }
              }
              if (!s) {
                ay(aN.sdp);
              }
            }
            break;
          case "AcceptMediaUpdateResponse":
          case "RejectMediaUpdateResponse":
            AWL.console.debug(
              "callsession:Renegotiation - response received msgName: " + aP
            );
            break;
          default:
            AWL.console.warn(
              "callsession:Renegotiation - unhandled msgName: " + aP
            );
        }
      };
      this.getstats = function () {
        if (ar !== null) {
          if (navigator.mozGetUserMedia) {
            b = setInterval(function () {
              ar.getStats(
                null,
                function (aO) {
                  var aL = "";
                  for (var aN in aO) {
                    if (aO.hasOwnProperty(aN)) {
                      var aM = aO[aN];
                      aL += "<h3>" + aN + "</h3>" + P(aM);
                    }
                  }
                },
                function () {}
              );
            }, 2000);
          } else {
            b = setInterval(function () {
              ar.getStats(function (aO) {
                var aN = aO.result();
                for (var aM = 0; aM < aN.length; aM++) {
                  var aL = aN[aM];
                  if (!aL.local || aL.local == aL) {
                    h(aL);
                  } else {
                    if (aL.local) {
                      h("local", aL.local);
                    } else {
                      if (aL.remote) {
                        h("remote", aL.remote);
                      }
                    }
                  }
                }
              });
            }, 2000);
          }
        }
      };
      this.collectStats = function () {
        if (navigator.mozGetUserMedia) {
          return aG;
        } else {
          var aL = [];
          aL.audio = an;
          aL.video = W;
          return aL;
        }
      };
      this.inComingCallHandler = function (aN) {
        if (aN) {
          z(aN.FarEndDn);
          ab = aN.sdp;
          aq = aN.sdp;
          U = aN.sipUri;
          if (U !== null) {
            var aM = U.indexOf(":");
            var aL = U.indexOf("@");
            aH = U.slice(aM + 1, aL);
          }
          if (aN.autoAnswer === "true") {
            ag = true;
          } else {
            ag = false;
          }
        }
        if (ab) {
          v = c(ab);
        }
        if (
          v &&
          !AWL.configuration.getInstance().getConfiguration().enableVideo
        ) {
          ab = Z(ab);
          aq = ab;
          v = false;
        }
        AWL.totalCalls++;
        af = CONST.AWL_MSG_CALL_INCOMING;
        t = new AWL.clientCallObj(S);
        AWL.onNewIncomingCall.notify(C, t, ag);
        if (ag) {
          AWL.console.debug("inComingCallHandler: autoAnswer - TRUE");
          AWL.callmanager.getInstance().answerCall(C);
        } else {
          if (!H && AWL.serviceType === CONST.AGENTSERVICE) {
            AWL.callmanager.getInstance().answerCall(C);
          } else {
            if (AWL.serviceType === CONST.AGENTSERVICE) {
              AWL.console.warn(
                "inComingCallHandler: _earlyMediaAnswer - TRUE ALREADY!"
              );
            } else {
              AWL.console.debug("inComingCallHandler: autoAnswer - FALSE");
            }
          }
        }
      };
      this.callUpdateHandler = function (aO, aN) {
        AWL.console.debug("callUpdateHandler: Type: " + aO + " Param: " + aN);
        if (aO === "FarEndChanged") {
          z(aN.FarEndDn);
          U = aN.sipUri;
          if (U !== null) {
            var aM = U.indexOf(":");
            var aL = U.indexOf("@");
            aH = U.slice(aM + 1, aL);
          }
          af = CONST.AWL_MSG_CALL_FAREND_UPDATE;
          AWL.onCallStateChange.notify(C, t, af);
        }
      };
      this.callControllerHandler = function (aM, aL) {
        AWL.console.debug(
          "callControllerHandler: Event: " + aM + " params: " + aL
        );
        if (aL.ctiEvent === "talk") {
          if (af === CONST.AWL_MSG_CALL_INCOMING) {
            AWL.console.debug(
              "callControllerHandler - TALK Event : answerCall triggered"
            );
            E = true;
            AWL.callmanager.getInstance().answerCall(C);
          } else {
            if (az) {
              AWL.console.debug(
                "callControllerHandler - TALK Event: call is in held state, unhold triggered"
              );
              S.doUnHold();
            } else {
              AWL.console.error(
                "callControllerHandler - TALK Event: invalid state:" + af
              );
            }
          }
        }
        if (aL.ctiEvent === "hold" && Q) {
          AWL.console.debug(
            "callControllerHandler - HOLD Event: call is in active state, hold triggered"
          );
          S.doHold();
        }
      };
      this.evtMediaDeviceAccessAcquired = function (aN) {
        AWL.console.debug("Callsession :: evtMediaDeviceAccessAcquired");
        if (s) {
          s = false;
          aA = aN;
          k = aA.getVideoTracks();
          if (k.length !== 0) {
            AWL.console.debug("callsession: Add available videoTracks");
            for (var aL = 0; aL < k.length; aL++) {
              aj.addTrack(k[aL]);
              AWL.console.debug("Video Tracks Id: " + k[aL].id);
            }
            q = false;
          }
          if (AWL.configuration.getInstance().getConfiguration().enableVideo) {
            if (AWL.inUse_Version !== AWL.SDK_VERSION.v9_1) {
              if (
                AWL.configuration.getInstance().getDomElements().localVideo !==
                ""
              ) {
                var aM = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().localVideo
                );
                AWL.webrtc.mediaSetStream(aM, aA);
              } else {
                if (L !== null) {
                  AWL.webrtc.mediaSetStream(L, aj);
                } else {
                  AWL.clientAPIConsole.debug(
                    "callmanager : Local video tag not set, application is responsible for attaching the localStream"
                  );
                }
              }
            }
            AWL.remVideo = false;
          }
          if (navigator.webkitGetUserMedia) {
            ar.addStream(aj);
          } else {
            ar.addTrack(k[0], aj);
          }
          if (!ad) {
            ay(aq);
            return;
          }
          ad = false;
          var aO = { mandatory: { iceRestart: false } };
          K = true;
          ar.createOffer(function (aP) {
            AWL.console.error("callsession: createOffer failed: " + aP);
            K = false;
          }, aO);
          return;
        } else {
          aj = aN;
          l = aj.getAudioTracks();
        }
        if (
          AWL.configuration.getInstance().getConfiguration().enableVideo &&
          ai === "video"
        ) {
          if (AWL.inUse_Version !== AWL.SDK_VERSION.v9_1) {
            k = aj.getVideoTracks();
            if (
              AWL.configuration.getInstance().getDomElements().localVideo !== ""
            ) {
              var aM = document.getElementById(
                AWL.configuration.getInstance().getDomElements().localVideo
              );
              AWL.webrtc.mediaSetStream(aM, aj);
            } else {
              if (L !== null) {
                AWL.webrtc.mediaSetStream(L, aj);
              } else {
                AWL.clientAPIConsole.debug(
                  "callmanager : Local video tag not set, application is responsible for attaching the localStream"
                );
              }
            }
          }
          AWL.remVideo = false;
        }
        if (i) {
          ao();
        } else {
          M();
        }
      };
      this.evtMediaDeviceAccessFailed = function (aL) {
        var aM = "";
        if (aL != null) {
          aM = aL.name;
          if (aL.message != "") {
            aM += " : " + aL.message;
          }
        }
        AWL.console.error(
          "callsession :: evtMediaDeviceAccessFailed [ " + aM + " ]"
        );
        if (s) {
          s = false;
          if (!ad) {
            ay(aq);
          }
          ad = false;
          return;
        }
        af = CONST.AWL_MSG_CALL_FAILED;
        S.resetCall("Could not get access to audio device");
      };
      this.setDomElementForMedia = function (aM, aL) {
        AWL.console.debug(
          "callSession :: setDomElementForMedia : setting domElement " +
            aL +
            " for " +
            C
        );
        if (aL === "localVideo") {
          L = aM;
        } else {
          aJ = aM;
          ae();
        }
      };
      this.isDomElementSet = function () {
        AWL.console.debug("callSession :: isDomElementSet ");
        if (
          AWL.configuration.getInstance().getDomElements().remoteVideo !== "" ||
          aJ !== null
        ) {
          if (
            AWL.configuration.getInstance().getDomElements().localVideo !==
              "" ||
            L !== null
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
      function u(aN, aL) {
        var aP = false;
        var aQ = aN.indexOf("m=audio");
        var aM = aN.indexOf("m=video");
        if (aM === -1) {
          aP = false;
        } else {
          var aO = null;
          if (aQ > aM) {
            aO = aN.slice(aM, aQ);
          } else {
            if (aM > aQ) {
              aO = aN.slice(aM);
            }
          }
          if (aO !== null) {
            if (aO.includes("a=inactive")) {
              aP = false;
            } else {
              if (
                typeof aL != "undefined" &&
                aL != null &&
                aL === true &&
                aO.includes("a=recvonly")
              ) {
                aP = false;
              } else {
                aP = true;
              }
            }
          }
        }
        return aP;
      }
      function ao() {
        AWL.console.debug("Callsession :: outGoingCall");
        B = aF.ACTIVE;
        if (!AWL.registration.getInstance().isloggedIn()) {
          AWL.clientAPIConsole.error(
            "callmanager : Call not allowed as user is not logged in"
          );
          return;
        }
        AWL.totalCalls++;
        if (AWL.totalCalls > CONST.MAX_ALLOWED_CALL_COUNT) {
          AWL.clientAPIConsole.error(
            "callmanager : MAX ALLOWED CALL LIMIT REACHED"
          );
          af = CONST.AWL_MSG_CALL_FAILED;
          AWL.onCallStateChange.notify(C, t, af);
          AWL.onCallTerminate.notify(C, "Max call limit reached");
          AWL.totalCalls--;
          delete AWL.callMap[C];
          return;
        }
        if (AWL.configuration.getInstance().getConfiguration().enableVideo) {
          if (typeof ai === "undefined") {
            v = false;
          } else {
            if (ai === "video") {
              v = true;
              if (
                AWL.configuration.getInstance().getDomElements().localVideo !==
                ""
              ) {
                var aL = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().localVideo
                );
                AWL.webrtc.mediaSetStream(aL, aj);
              } else {
                if (L !== null) {
                  AWL.webrtc.mediaSetStream(L, aj);
                } else {
                  AWL.clientAPIConsole.debug(
                    "outGoingCall : Local video tag not set, application is responsible for attaching the localStream"
                  );
                }
              }
            } else {
              v = false;
            }
          }
        }
        if (
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Stunserver.ip.trim().length !== 0 &&
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Turnserver.ip.trim().length !== 0
        ) {
          at.iceServers = [
            AWL.configuration.getInstance().getStunServerURL(),
            AWL.configuration.getInstance().getTurnServerURL(),
          ];
        } else {
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0
          ) {
            at.iceServers = [
              AWL.configuration.getInstance().getStunServerURL(),
            ];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Turnserver.ip.trim().length !== 0
            ) {
              at.iceServers = [
                AWL.configuration.getInstance().getTurnServerURL(),
              ];
            } else {
              at.iceServers = [];
            }
          }
        }
        Q = true;
        ar = new AWL.webrtc.PeerConnection();
        ar.evtRemoteStream.attach(y);
        ar.evtLocalCandidates.attach(G);
        ar.evtLocalDescription.attach(x);
        if (navigator.webkitGetUserMedia) {
          ar.evtReattachingStream.attach(e);
        }
        ar.evtICEConnectivity.attach(aw);
        ar.init({
          rtcConfiguration: at,
          constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
        });
        ar.addStream(aj);
        ar.createOffer(
          function (aM) {
            AWL.console.error("callsession: createOffer failed: " + aM);
          },
          { optional: [{ MozDontOfferDataChannel: true }] }
        );
      }
      function M() {
        AWL.clientAPIConsole.debug("\ncallsession :: incomingCall");
        B = aF.PASSIVE;
        if (!H) {
          if (AWL.serviceType === CONST.AGENTSERVICE && !ag) {
            H = true;
            AWL.clientAPIConsole.debug(
              "incomingCall ::  _earlyMediaAnswer set to TRUE"
            );
            if (E) {
              f = true;
              AWL.console.debug(
                "Received answerCall but earlyMediaAnswer is not yet sent\n"
              );
            }
          }
          if (!AWL.registration.getInstance().isloggedIn()) {
            AWL.clientAPIConsole.error(
              "callmanager : Call not allowed as user is not logged in"
            );
            return;
          }
          if (aa(O.answerCall)) {
            AWL.clientAPIConsole.error(
              "callsession : Duplicate answer request - ignored!"
            );
            return;
          }
          if (AWL.totalCalls > CONST.MAX_ALLOWED_CALL_COUNT) {
            AWL.clientAPIConsole.error(
              "callsession : MAX ALLOWED CALL LIMIT REACHED"
            );
            af = CONST.AWL_MSG_CALL_FAILED;
            AWL.onCallStateChange.notify(C, t, af);
            AWL.onCallTerminate.notify(C, "Max call limit reached");
            return;
          }
          Q = true;
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0 &&
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Turnserver.ip.trim().length !== 0
          ) {
            at.iceServers = [
              AWL.configuration.getInstance().getStunServerURL(),
              AWL.configuration.getInstance().getTurnServerURL(),
            ];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Stunserver.ip.trim().length !== 0
            ) {
              at.iceServers = [
                AWL.configuration.getInstance().getStunServerURL(),
              ];
            } else {
              if (
                AWL.configuration
                  .getInstance()
                  .getConfiguration()
                  .Turnserver.ip.trim().length !== 0
              ) {
                at.iceServers = [
                  AWL.configuration.getInstance().getTurnServerURL(),
                ];
              } else {
                at.iceServers = [];
              }
            }
          }
          ar = new AWL.webrtc.PeerConnection();
          ar.evtRemoteStream.attach(y);
          ar.evtLocalCandidates.attach(G);
          ar.evtLocalDescription.attach(x);
          if (navigator.webkitGetUserMedia) {
            ar.evtReattachingStream.attach(e);
          }
          ar.evtICEConnectivity.attach(aw);
          ar.init({
            rtcConfiguration: at,
            constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
          });
          ar.addStream(aj);
          var aL = { sdp: ab, type: "offer" };
          if (navigator.mozGetUserMedia && V()) {
            aL = ar.addSetUpAttribute(aL);
          }
          ar.setRemoteDescription(
            aL,
            function (aM) {
              AWL.console.error("setRemoteDescriptionErrorHandler: " + aM);
            },
            { optional: [{ MozDontOfferDataChannel: true }] }
          );
        } else {
          if (am !== null) {
            AWL.console.debug(
              "Early Media Answer sent already! Resend same SDP again in answer: \n" +
                am
            );
            AWL.jsonRpc.sendRequest("answerCall", C, am);
          } else {
            f = true;
            AWL.console.debug(
              "Received answerCall but earlyMediaAnswer is not yet sent\n"
            );
          }
        }
      }
      function aK() {
        AWL.console.debug("removeTrackAPIFirefox");
        if (navigator.mozGetUserMedia) {
          var aL = navigator.userAgent.match(/Firefox\/(.*)$/);
          if (aL && aL.length > 1) {
            if (aL[1] >= 44) {
              return true;
            }
          }
          return false;
        }
      }
      function h(aP) {
        if (aP.names) {
          var aO = aP.names();
          for (var aM = 0; aM < aO.length; aM++) {
            var aL = aO[aM];
            var aN = aP.stat(aL);
            if (aL === "googChannelId") {
              if (aN === "Channel-audio-1") {
                for (var aM = 0; aM < aO.length; aM++) {
                  var aL = aO[aM];
                  var aN = aP.stat(aL);
                  if (aL === "bytesReceived") {
                    an[aL] = aN;
                  }
                }
              } else {
                if (aN === "Channel-video-1") {
                  for (var aM = 0; aM < aO.length; aM++) {
                    var aL = aO[aM];
                    var aN = aP.stat(aL);
                    if (aL === "bytesReceived") {
                      W[aL] = aN;
                    }
                  }
                }
              }
            }
          }
          for (var aM = 0; aM < aO.length; aM++) {
            var aL = aO[aM];
            var aN = aP.stat(aL);
            if (aL === "googTrackId" && aN === aC) {
              for (var aM = 0; aM < aO.length; aM++) {
                var aL = aO[aM];
                var aN = aP.stat(aL);
                if (
                  aL === "audioInputLevel" ||
                  aL === "googCodecName" ||
                  aL === "googJitterReceived" ||
                  aL === "packetsSent" ||
                  aL === "bytesSent" ||
                  aL === "bytesReceived" ||
                  aL === "packetsLost" ||
                  aL === "packetsReceived" ||
                  aL === "audioOutputLevel" ||
                  aL === "googJitterReceived"
                ) {
                  an[aL] = aN;
                }
              }
            } else {
              if (aL === "googTrackId" && aN === ac) {
                for (var aM = 0; aM < aO.length; aM++) {
                  var aL = aO[aM];
                  var aN = aP.stat(aL);
                  if (
                    aL === "googCodecName" ||
                    aL === "googJitterReceived" ||
                    aL === "packetsSent" ||
                    aL === "bytesSent" ||
                    aL === "bytesReceived" ||
                    aL === "packetsLost" ||
                    aL === "packetsReceived" ||
                    aL === "audioOutputLevel" ||
                    aL === "googJitterReceived"
                  ) {
                    W[aL] = aN;
                  }
                }
              }
            }
          }
        } else {
          if (aP.stat("audioOutputLevel")) {
            AWL.console.debug(
              " : audioOutputLevel and " + aP.stat("audioOutputLevel")
            );
          }
        }
      }
      function P(aL) {
        if (aL.type == "inboundrtp") {
          if (aL.isRemote) {
            var aM = [];
            aM.bytesReceived = aL.bytesReceived;
            aM.packetsReceived = aL.packetsReceived;
            aM.jitter = aL.jitter;
            aM.packetsLost = aL.packetsLost;
            aM.ssrc = aL.ssrc;
            if (aL.mediaType === "audio") {
              aG.remoteInboundAudio = aM;
            } else {
              aG.remoteInboundVideo = aM;
            }
          } else {
            var aM = [];
            aM.bytesReceived = aL.bytesReceived;
            aM.packetsReceived = aL.packetsReceived;
            aM.jitter = aL.jitter;
            aM.packetsLost = aL.packetsLost;
            aM.ssrc = aL.ssrc;
            if (aL.mediaType === "audio") {
              aG.localInboundAudio = aM;
            } else {
              aG.localInboundVideo = aM;
            }
          }
        } else {
          if (aL.type == "outboundrtp") {
            if (aL.isRemote) {
              var aM = [];
              aM.bytesSent = aL.bytesSent;
              aM.packetsSent = aL.packetsSent;
              aM.ssrc = aL.ssrc;
              if (aL.mediaType === "audio") {
                aG.remoteOutboundAudio = aM;
              } else {
                aG.remoteOutboundVideo = aM;
              }
            } else {
              var aM = [];
              aM.bytesSent = aL.bytesSent;
              aM.packetsSent = aL.packetsSent;
              aM.ssrc = aL.ssrc;
              if (aL.mediaType === "audio") {
                aG.localOutboundAudio = aM;
              } else {
                aG.localOutboundVideo = aM;
              }
            }
          }
        }
      }
      function y(aP, aN) {
        AWL.console.debug("evtRemoteStreamHandler: " + aN.type);
        if (typeof aN.stream !== "undefined" && aN.stream !== null) {
          if (aN.type === "audio") {
            AWL.call.utility.createAudioTag(C);
            var aL = document.getElementById(C);
            AWL.webrtc.mediaSetStream(aL, aN.stream);
            v = false;
            av = aN.stream;
            ae();
          } else {
            if (aN.type === "video" || aN.type === "audiovideo") {
              v = true;
              if (
                AWL.configuration.getInstance().getConfiguration().enableVideo
              ) {
                if (
                  AWL.configuration.getInstance().getDomElements()
                    .localVideo !== ""
                ) {
                  var aO = document.getElementById(
                    AWL.configuration.getInstance().getDomElements().localVideo
                  );
                  AWL.webrtc.mediaSetStream(aO, aj);
                } else {
                  if (L !== null) {
                    AWL.webrtc.mediaSetStream(L, aj);
                  } else {
                    AWL.console.debug(
                      "evtRemoteStreamHandler: Not Attaching the localStreams since application is handling the Stream"
                    );
                  }
                }
              }
              if (
                AWL.configuration.getInstance().getDomElements().remoteVideo !==
                ""
              ) {
                var aM = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().remoteVideo
                );
                AWL.webrtc.mediaSetStream(aM, aN.stream);
              } else {
                if (aJ !== null) {
                  AWL.webrtc.mediaSetStream(aJ, aN.stream);
                } else {
                  AWL.console.debug(
                    "evtRemoteStreamHandler: Not Attaching the remoteStreams since application is handling the Stream"
                  );
                }
              }
              av = aN.stream;
              ae();
            }
          }
        } else {
          if (typeof aN.track !== "undefined" && aN.track !== null) {
            AWL.console.debug(
              "evtRemoteStreamHandler: Track ID: " + aN.track.id
            );
            if (aN.type === "video") {
              v = true;
            }
            av.addTrack(aN.track);
          } else {
            AWL.console.error("evtRemoteStreamHandler: Track is null");
          }
        }
      }
      function ae() {
        var aL = AWL.configuration.getInstance().getDeviceIds().audioOutputID;
        if (aL) {
          if (aL !== null && typeof aL !== "undefined" && aL != "") {
            S.routeAudioOutput(aL);
          }
        }
      }
      function T(aM, aL) {
        aM.srcObject = aL.srcObject;
      }
      function e() {
        AWL.console.debug("callSession :: evtReattachingStreamHandler");
        if (
          AWL.configuration.getInstance().getDomElements().remoteVideo !== ""
        ) {
          var aL = document.getElementById(
            AWL.configuration.getInstance().getDomElements().remoteVideo
          );
          if (
            typeof aL.srcObject !== "undefined" ||
            aL.srcObject !== null ||
            aL.srcObject != ""
          ) {
            AWL.webrtc.mediaSetStream(aL, av);
          } else {
            T(aL, aL);
          }
        } else {
          if (aJ !== null) {
            if (
              typeof aJ.srcObject !== "undefined" ||
              aJ.srcObject !== null ||
              aJ.srcObject != ""
            ) {
              AWL.webrtc.mediaSetStream(aJ, av);
            } else {
              T(aJ, aJ);
            }
          } else {
            AWL.console.debug(
              "evtReattachingStreamHandler: Not Attaching the remoteStreams since application is handling the Stream"
            );
          }
        }
      }
      this.routeAudioOutput = function (aM) {
        AWL.console.debug("routeAudioOutput: " + aM);
        var aL = "";
        if (v) {
          aL = document.getElementById(
            AWL.configuration.getInstance().getDomElements().remoteVideo
          );
          if (aL == null) {
            aL = aJ;
          }
        } else {
          aL = document.getElementById(C);
        }
        if (aL == null) {
          AWL.console.error("routeAudioOutput: streamElement is null");
          return;
        }
        if (typeof aL.sinkId !== "undefined") {
          aL.setSinkId(aM);
        } else {
          AWL.console.warn("Browser does not support output device selection.");
        }
      };
      function x(aM, aL) {
        AWL.console.debug("evtLocalDescriptionHandler");
        if (!K && !N) {
          if (ab) {
            if (H) {
              if (navigator.mozGetUserMedia) {
                aL.sdp = w(aL.sdp);
              }
              am = aL.sdp;
              if (f) {
                r[O.answerCall] = true;
                if (C in AWL.callMap) {
                  AWL.console.debug(
                    "Send answer instead of earlyMediaAnswer: \n" + aL.sdp
                  );
                  AWL.jsonRpc.sendRequest("answerCall", C, aL.sdp);
                } else {
                  AWL.clientAPIConsole.error(
                    "Ignore sending answerCall as the callObject does not exist"
                  );
                }
              } else {
                if (C in AWL.callMap) {
                  AWL.console.debug("Answer EarlyMedia: \n" + aL.sdp);
                  AWL.jsonRpc.sendRequest("answerEarlyMedia", C, aL.sdp);
                } else {
                  AWL.clientAPIConsole.error(
                    "Ignore sending answerEarlyMedia as the callObject does not exist"
                  );
                }
              }
            } else {
              AWL.console.debug("Answer: \n" + aL.sdp);
              r[O.answerCall] = true;
              if (navigator.mozGetUserMedia) {
                aL.sdp = w(aL.sdp);
              }
              AWL.jsonRpc.sendRequest("answerCall", C, aL.sdp);
            }
          } else {
            if (navigator.mozGetUserMedia) {
              if (
                !v &&
                AWL.configuration.getInstance().getConfiguration().enableVideo
              ) {
                AWL.console.debug("Audio OnlyCall - mark video SDP inactive\n");
                aL = ar.getCustomLocalDescription("remVideo");
              }
            }
            AWL.callMap[C] = S;
            AWL.console.debug("Offer: \n" + aL.sdp);
            if (navigator.mozGetUserMedia) {
              aL.sdp = w(aL.sdp);
            }
            AWL.jsonRpc.sendRequest("makeCall", aH, C, aL.sdp);
          }
          aI = aL.sdp;
        } else {
          if (K && !N) {
            if (navigator.mozGetUserMedia) {
              if (
                !v &&
                AWL.configuration.getInstance().getConfiguration().enableVideo
              ) {
                AWL.console.debug("Audio OnlyCall - mark video SDP inactive\n");
                aL = ar.getCustomLocalDescription("remVideo");
              }
            }
            AWL.console.debug("Re Offered SDP: \n" + aL.sdp);
            if (navigator.mozGetUserMedia) {
              aL.sdp = w(aL.sdp);
            }
            aI = aL.sdp;
            AWL.jsonRpc.sendRequest("updateMedia", C, aL.sdp);
          } else {
            if (!K && N) {
              AWL.console.debug("Re Answered SDP: \n" + aL.sdp);
              if (navigator.mozGetUserMedia) {
                aL.sdp = w(aL.sdp);
              }
              aI = aL.sdp;
              if (ai === "audio" && v && R === "") {
                R = aF.PASSIVE;
                AWL.clientAPIConsole.debug(
                  "Remote Video DTLS role set to " + R
                );
              }
              AWL.jsonRpc.sendRequest("acceptMediaUpdateRequest", C, aL.sdp);
              N = false;
            } else {
              AWL.console.error(
                "Renegotiation error: reOfferState: " +
                  K +
                  " reAnsweState: " +
                  N
              );
              return;
            }
          }
        }
      }
      function w(aM) {
        if (aM.indexOf("a=candidate:") !== -1) {
          var aN = aM.indexOf("a=candidate:");
          var aL = aM.slice(0, aN);
          var aP = aM.slice(aN).split("\n");
          var aQ = "";
          for (var aO = 0; aO < aP.length; aO++) {
            if (
              aP[aO].indexOf("a=candidate:") !== -1 &&
              (aP[aO].match(/:/g) || []).length >= 3
            ) {
              aP[aO] = "";
            } else {
              aQ += aP[aO] + "\n";
            }
          }
          var aR = aL + aQ;
          AWL.console.debug("removed IPv6 candidates ::\n" + aR);
          return aR;
        } else {
          AWL.console.error("Candidates are missing in the generated SDP");
          return aM;
        }
      }
      function ay(aL) {
        AWL.console.debug("set Remote Description and create answer");
        N = true;
        K = false;
        var aM = { sdp: aL, type: "offer" };
        if (navigator.mozGetUserMedia && V()) {
          aM = ar.addSetUpAttribute(aM);
        }
        ar.setRemoteDescription(
          aM,
          function (aN) {
            AWL.console.error("setRemoteDescriptionErrorHandler: " + aN);
            N = false;
            AWL.jsonRpc.sendRequest("rejectMediaUpdateRequest", C);
          },
          { optional: [{ MozDontOfferDataChannel: true }] }
        );
      }
      function A() {
        AWL.console.debug("getDtlsRole:");
        if (B === aF.ACTIVE) {
          if (R === aF.PASSIVE) {
            return "active-passive";
          }
          return aF.ACTIVE;
        } else {
          if (B === aF.PASSIVE) {
            if (R === aF.ACTIVE) {
              return "passive-active";
            }
            return aF.PASSIVE;
          }
        }
        return B;
      }
      function G(aM, aL) {
        AWL.console.debug("evtLocalCandidatesHandler: " + aL);
      }
      function d() {
        if (
          !az &&
          (af === CONST.AWL_MSG_CALL_CONNECTED ||
            af === CONST.AWL_MSG_CALL_FAREND_UPDATE) &&
          Q
        ) {
          if (
            AWL.webrtc.webkitRenegotationSupport() ||
            AWL.webrtc.mozRenegotiationSupport()
          ) {
            ar.createOffer(
              function (aL) {
                AWL.console.error("callsession: createOffer failed: " + aL);
              },
              {},
              function (aL) {
                ar.setCustomLocalDescription("hold", B, aL.sdp);
              }
            );
          } else {
            ar.setCustomLocalDescription("hold", B);
          }
          r[O.holdCall] = true;
          AWL.jsonRpc.sendRequest("holdCall", C);
          AWL.clientAPIConsole.debug("\ncallsession: holdCall request sent");
        } else {
          if (
            AWL.serviceType === CONST.AGENTSERVICE &&
            af === CONST.AWL_MSG_CALL_INCOMING
          ) {
            AWL.clientAPIConsole.debug(
              "\ncallsession: Ignore sending holdCall request as call is in incoming state"
            );
          } else {
            AWL.clientAPIConsole.error(
              "\ncallsession: call is already in held state"
            );
          }
        }
      }
      function al() {
        if (
          az &&
          (af === CONST.AWL_MSG_CALL_HELD ||
            af === CONST.AWL_MSG_CALL_FAREND_UPDATE) &&
          !Q
        ) {
          AWL.callmanager.getInstance().autoHoldIfRequired();
          if (
            AWL.webrtc.webkitRenegotationSupport() ||
            AWL.webrtc.mozRenegotiationSupport()
          ) {
            ar.createOffer(
              function (aL) {
                AWL.console.error("callsession: createOffer failed: " + aL);
              },
              {},
              function (aL) {
                ar.setCustomLocalDescription("unhold", B, aL.sdp);
              }
            );
          } else {
            ar.setCustomLocalDescription("unhold", B);
          }
          r[O.unholdCall] = true;
          AWL.jsonRpc.sendRequest("unholdCall", C);
          AWL.clientAPIConsole.debug("\ncallsession: unholdCall request sent");
        } else {
          AWL.clientAPIConsole.error(
            "\ncallsession: call is already in unheld state"
          );
        }
      }
      function ah() {
        if (
          navigator.webkitGetUserMedia ||
          (navigator.mozGetUserMedia && !AWL.muteAllStreams)
        ) {
          l = aj.getAudioTracks();
          if (l.length === 0) {
            AWL.console.debug("No local audio available.");
            return false;
          }
          if (!aE) {
            for (var aL = 0; aL < l.length; aL++) {
              l[aL].enabled = false;
              AWL.console.debug("Audio Tracks Id: " + l[aL].id);
            }
            AWL.clientAPIConsole.debug("Audio muted.");
            aE = !aE;
            return true;
          }
        }
        return false;
      }
      function J() {
        if (
          navigator.webkitGetUserMedia ||
          (navigator.mozGetUserMedia && !AWL.muteAllStreams)
        ) {
          l = aj.getAudioTracks();
          if (l.length === 0) {
            AWL.console.debug("No local audio available.");
            return false;
          }
          if (aE) {
            for (var aL = 0; aL < l.length; aL++) {
              AWL.console.debug("Audio Tracks Id: " + l[aL].id);
              l[aL].enabled = true;
            }
            AWL.clientAPIConsole.debug("Audio unmuted.");
            aE = !aE;
            return true;
          }
        }
        return false;
      }
      function ak() {
        l = aj.getAudioTracks();
        if (l.length === 0) {
          AWL.clientAPIConsole.debug("No local audio available.");
          return;
        }
        if (!AWL.muteAllStreams) {
          if (!aE) {
            for (var aM = 0; aM < l.length; aM++) {
              l[aM].enabled = false;
            }
          }
          AWL.clientAPIConsole.debug("toggleHoldControlMoz: Audio stopped");
          if (k !== null) {
            if (k.length !== 0) {
              for (var aM = 0; aM < k.length; aM++) {
                if (!AWL.videoPaused) {
                  k[aM].enabled = false;
                }
                var aL = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().remoteVideo
                );
                aL.pause();
              }
              AWL.clientAPIConsole.debug("toggleHoldControlMoz: Video stopped");
            }
          }
        } else {
          if (!aE) {
            for (var aM = 0; aM < l.length; aM++) {
              l[aM].enabled = true;
            }
          }
          AWL.clientAPIConsole.debug("toggleHoldControlMoz: Audio resumed");
          if (k !== null) {
            if (k.length !== 0) {
              for (var aM = 0; aM < k.length; aM++) {
                if (!AWL.videoPaused) {
                  k[aM].enabled = true;
                }
                var aL = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().remoteVideo
                );
                aL.play();
              }
              AWL.clientAPIConsole.debug("toggleHoldControlMoz: Video resumed");
            }
          }
        }
        AWL.muteAllStreams = !AWL.muteAllStreams;
      }
      function F(aL) {
        if (aL) {
          AWL.console.debug("Sent Dtmf tone: \t" + aL.tone);
        }
      }
      function c(aM) {
        if (typeof aM !== "undefined") {
          var aL = aM.indexOf("m=video");
          if (aL === -1) {
            return false;
          }
          return true;
        }
        AWL.console.error("checkIfVideoCall: argument missing");
        return false;
      }
      function aa(aL) {
        if (typeof r[aL] !== "undefined") {
          if (r[aL]) {
            return true;
          }
        }
        return false;
      }
      function Z(aN) {
        var aR = aN.indexOf("m=audio");
        var aM = aN.indexOf("m=video");
        var aQ = aN.indexOf("a=sendrecv");
        var aP = aN.lastIndexOf("a=sendrecv");
        AWL.console.debug(
          "\n idxAud = " +
            aR +
            "\nidxVid = " +
            aM +
            "\nidxFirst = " +
            aQ +
            "\nidxLast = " +
            aP
        );
        if (aM === -1) {
        } else {
          if (aR > aM) {
            if (aQ != aP && aQ > aM && aQ < aR) {
              aN = aN.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
            } else {
              if (aQ === aP && aQ > aM && aQ < aR) {
                aN = aN.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                var aL = aN.slice(0, aR);
                var aO = aN.slice(aR);
                aL = aL.concat("a=inactive\r\n");
                aN = aL.concat(aO);
              }
            }
          } else {
            if (aQ != aP && aQ > aR && aQ < aM) {
              var aO = aN.slice(0, aM);
              var aL = aN.slice(aM);
              aL = aL.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              aN = aO.concat(aL);
            } else {
              if (aQ === aP && aQ > aR && aQ > aM) {
                aN = aN.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                var aO = aN.slice(0, aM);
                var aL = aN.slice(aM);
                aL = aL.concat("a=inactive\r\n");
                aN = aO.concat(aL);
              }
            }
          }
        }
        AWL.console.debug("Modified Audio Only SDP \n " + aN);
        return aN;
      }
      function aw(aM, aL) {
        AWL.console.debug(
          "callsession :: evtICEConnectivityHandler:: iceStatus: " +
            aL.iceStatus
        );
        n = aL.iceStatus;
        if (
          aL.iceStatus === ax.CONNECTED &&
          af === CONST.AWL_MSG_CALL_CONNECTED
        ) {
          if (v && !m && AWL.onVideoStreamsAvailable._listeners.length != 0) {
            if (
              AWL.configuration.getInstance().getDomElements().remoteVideo !==
                "" &&
              AWL.configuration.getInstance().getDomElements().localVideo !== ""
            ) {
              AWL.console.debug(
                "evtICEConnectivityHandler:VideoStream available event not sent as Dom Elements are initally set"
              );
            } else {
              g();
            }
            return;
          }
          if (!v && !aD && AWL.onAudioStreamsAvailable._listeners.length != 0) {
            g();
            return;
          }
        }
      }
      function g() {
        AWL.console.debug("callsession :: notifyAfterRmtStrmAvbl");
        if (av !== null) {
          if (X !== null) {
            clearTimeout(X);
            X = null;
          }
          if (v && !m && af === CONST.AWL_MSG_CALL_CONNECTED) {
            AWL.console.debug(
              "callsession :: notifyAfterRmtStrmAvbl : onVideoStreamsAvailable event notified"
            );
            AWL.onVideoStreamsAvailable.notify(C, aj, av);
            m = true;
          } else {
            if (!v && !aD && af === CONST.AWL_MSG_CALL_CONNECTED) {
              AWL.console.debug(
                "callsession :: notifyAfterRmtStrmAvbl : onAudioStreamsAvailable event notified"
              );
              AWL.onAudioStreamsAvailable.notify(C, aj, av);
              aD = true;
            } else {
              AWL.console.debug(
                "callsession :: notifyAfterRmtStrmAvbl : No notification sent"
              );
            }
          }
        } else {
          if (X !== null) {
            clearTimeout(X);
            X = null;
          }
          AWL.console.debug(
            "callsession :: notifyAfterRmtStrmAvbl : remote stream is not yet available"
          );
          X = setTimeout(function () {
            g();
          }, 100);
        }
      }
      function V() {
        var aL = navigator.userAgent.match(/Firefox\/(.*)$/);
        if (aL && aL.length > 1) {
          if (aL[1] >= 55) {
            return true;
          }
        }
        return false;
      }
      function z(aN) {
        if (aN) {
          var aL = aN.indexOf("[");
          var aM = aN.indexOf("]");
          if (aL !== -1 && aM !== -1) {
            au = aN.slice(0, aL);
            Y = aN.slice(aL + 1, aM);
            AWL.console.debug(
              "callsession :: farEndName: " + au + "\tsubject: " + Y
            );
          } else {
            au = aN;
          }
        }
      }
    };
    return a;
  })()
);
AWL.newPackage(
  "com.avaya.awl.callsession_9_1version",
  (function () {
    var a = function () {
      var J = this;
      var M = "";
      var i = null;
      var q = "";
      var G = "";
      var B = "";
      var c = null;
      var g = false;
      var I = null;
      var R = {};
      var j = false;
      var A = false;
      var o = "";
      var e = null;
      var P = null;
      var H = false;
      var f = CONST.AWL_MSG_CALL_IDLE;
      var v = "";
      var y = false;
      var K = false;
      var r = null;
      var Q = false;
      var d = null;
      var s = "";
      var N = "";
      var w = "";
      var m = false;
      this.setCallID = function (S) {
        M = S;
      };
      this.getCallID = function () {
        return M;
      };
      this.getCallState = function () {
        return f;
      };
      this.getFarEndNumber = function () {
        return q;
      };
      this.getFarEndName = function () {
        return G;
      };
      this.getSubject = function () {
        return B;
      };
      this.isAutoAnswer = function () {
        return y;
      };
      this.isVideoCall = function () {
        return g;
      };
      this.makeCall = function (S, U, T) {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: makeCall");
        s = "active";
        v = T;
        q = S;
        G = S;
        w = U;
        if (!AWL.registration.getInstance().isloggedIn()) {
          AWL.clientAPIConsole.error(
            "callmanager : Call not allowed as user is not logged in"
          );
          return;
        }
        AWL.totalCalls++;
        if (AWL.totalCalls === CONST.MAX_ALLOWED_CALL_COUNT) {
          AWL.clientAPIConsole.error(
            "callmanager : MAX ALLOWED CALL LIMIT REACHED"
          );
          AWL.totalCalls--;
          f = CONST.AWL_MSG_CALL_FAILED;
          setTimeout(function () {
            AWL.onCallStateChange.notify(M, v, f);
            AWL.onCallTerminate.notify(M, "Max call limit reached");
          }, 200);
          return;
        }
        if (q.trim().length === 0) {
          return;
        }
        m = true;
        AWL.devicemanager.getInstance().getUserMedia(AWL.callMap[M], w);
      };
      this.isCallActive = function () {
        return H;
      };
      this.answerCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession :: answerCall");
        if (!K) {
          if (g) {
            w = "video";
          } else {
            w = "audio";
          }
          m = false;
          AWL.devicemanager.getInstance().getUserMedia(AWL.callMap[M], w);
        } else {
          L();
        }
      };
      this.rejectCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: rejectCall");
        AWL.jsonRpc.call(AWL.serviceType, "dropCall", M);
        J.resetCall("Call Rejected");
      };
      this.dropCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: dropCall");
        AWL.jsonRpc.call(AWL.serviceType, "dropCall", M);
        J.resetCall("Call Dropped");
      };
      this.cancelCall = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: cancelCall");
        AWL.jsonRpc.call(AWL.serviceType, "dropCall", M);
        J.resetCall("Call Cancelled");
      };
      this.doHold = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: doHold");
        D();
      };
      this.doUnHold = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: doUnHold");
        n();
      };
      this.doMute = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: doMute");
        return u();
      };
      this.doUnMute = function () {
        AWL.clientAPIConsole.debug("\ncallsession_9_1version :: doUnMute");
        return b();
      };
      this.sendDTMF = function (U) {
        var T = 500;
        var V = 50;
        if (i !== null) {
          var S = i.getAudioTracks()[0];
          e = c.createDTMFSender(S);
          if (e) {
            if (e.canInsertDTMF) {
              AWL.clientAPIConsole.debug("Call eligible to do DTMF");
              AWL.console.debug("Call eligible to do DTMF");
              e.insertDTMF(U, T, V);
              e.ontonechange = O;
            } else {
              AWL.console.error(
                "\ncallsession_9_1version :: Call not eligible to do dtmf"
              );
            }
          }
        }
      };
      this.resetCall = function (Y) {
        AWL.console.debug("\ncallsession_9_1version :: resetCall");
        P = null;
        q = "";
        G = "";
        B = "";
        e = null;
        H = false;
        y = false;
        K = false;
        Q = false;
        r = null;
        d = null;
        s = "";
        AWL.totalCalls--;
        if (A) {
          b();
        }
        if (c) {
          c.close();
          c = null;
        }
        if (i !== null && typeof i !== "undefined") {
          var W = i.getAudioTracks();
          for (var V = 0; V < W.length; V++) {
            W[V].stop();
            AWL.console.debug(
              "\ncallsession_9_1version :: resetCall :: releasing Audio Device from this callSession"
            );
          }
          var S = i.getVideoTracks();
          for (var V = 0; V < S.length; V++) {
            S[V].stop();
            AWL.console.debug(
              "\ncallsession_9_1version :: resetCall :: releasing Video Device from this callSession"
            );
          }
          i = null;
        }
        if (
          AWL.configuration.getInstance().getDomElements().remoteVideo != "" &&
          g
        ) {
          var U = document.getElementById(
            AWL.configuration.getInstance().getDomElements().remoteVideo
          );
          AWL.webrtc.mediaReset(U);
        }
        if (
          AWL.configuration.getInstance().getDomElements().localVideo != "" &&
          g
        ) {
          var X = document.getElementById(
            AWL.configuration.getInstance().getDomElements().localVideo
          );
          AWL.webrtc.mediaReset(X);
        }
        g = false;
        var T = document.getElementById(M);
        if (T != null) {
          AWL.webrtc.mediaReset(T);
          document.body.removeChild(T);
        }
        delete AWL.callMap[M];
        if (f !== CONST.AWL_MSG_CALL_DISCONNECTED) {
          AWL.onCallStateChange.notify(M, v, f);
        }
        AWL.onCallTerminate.notify(M, Y);
      };
      this.callStateHandler = function (T) {
        AWL.console.debug(
          "callStateHandler: State: " + T[0] + " Param: " + T[1]
        );
        if (T[0] === "TERMINATED") {
          f = CONST.AWL_MSG_CALL_DISCONNECTED;
          AWL.onCallStateChange.notify(M, v, f);
          J.resetCall(T[1]);
        } else {
          if (T[0] === "PROGRESS") {
            if (!T[1]) {
              var S = "Trying";
            } else {
              f = CONST.AWL_MSG_CALL_RINGING;
            }
          } else {
            if (T[0] === "ACTIVE") {
              f = CONST.AWL_MSG_CALL_CONNECTED;
            }
          }
          AWL.onCallStateChange.notify(M, v, f);
        }
      };
      this.mediaAnswerHandler = function (U) {
        var S = U[0];
        d = S;
        AWL.console.debug("Answer: \n" + S);
        var T = { sdp: S, type: "answer" };
        c.setRemoteDescription(T, function (V) {
          AWL.console.error("setRemoteDescriptionErrorHandler: " + V);
        });
      };
      this.inComingCallHandler = function (S) {
        q = S[0];
        C(S[0]);
        P = S[1];
        AWL.totalCalls++;
        f = CONST.AWL_MSG_CALL_INCOMING;
        v = new AWL.clientCallObj(J);
        if (P) {
          g = l(P);
        }
        if (
          g &&
          !AWL.configuration.getInstance().getConfiguration().enableVideo
        ) {
          P = x(P);
          g = false;
        }
        d = P;
        if (AWL.serviceType === CONST.AGENTSERVICE) {
          y = S[3];
        }
        AWL.onNewIncomingCall.notify(M, v, y);
        if (AWL.serviceType === CONST.AGENTSERVICE) {
          if (y) {
            AWL.console.debug("inComingCallHandler: autoAnswer - TRUE");
            J.answerCall(M);
          } else {
            if (!K) {
              J.answerCall(M);
            } else {
              AWL.console.warn(
                "inComingCallHandler: _earlyMediaAnswer - TRUE ALREADY!"
              );
            }
          }
        }
      };
      this.callUpdateHandler = function (S) {
        AWL.console.debug(
          "callUpdateHandler: Type: " + S[0] + " Param: " + S[1]
        );
        if (S[0] === "displayupdate") {
          q = S[1];
          C(S[1]);
          f = CONST.AWL_MSG_CALL_FAREND_UPDATE;
          AWL.onCallStateChange.notify(M, v, f);
        }
      };
      this.callControllerHandler = function (S) {
        AWL.console.debug(
          "callControllerHandler: Event: " + S[1] + " CallId: " + S[0]
        );
        if (S[1] === "talk") {
          if (f === CONST.AWL_MSG_CALL_INCOMING) {
            AWL.console.debug(
              "callControllerHandler - TALK Event : answerCall triggered"
            );
            J.answerCall();
          } else {
            if (j) {
              AWL.console.debug(
                "callControllerHandler - TALK Event: call is in held state, unhold triggered"
              );
              J.doUnHold();
            } else {
              AWL.console.error(
                "callControllerHandler - TALK Event: invalid state:" + f
              );
            }
          }
        }
        if (S[1] === "hold" && H) {
          AWL.console.debug(
            "callControllerHandler - HOLD Event: call is in active state, hold triggered"
          );
          J.doHold();
        }
      };
      this.evtMediaDeviceAccessAcquired = function (T) {
        AWL.console.debug("Callsession :: evtMediaDeviceAccessAcquired");
        i = T;
        I = i.getVideoTracks();
        o = i.getAudioTracks();
        if (AWL.configuration.getInstance().getConfiguration().enableVideo) {
          if (
            AWL.configuration.getInstance().getDomElements().localVideo !== ""
          ) {
            var S = document.getElementById(
              AWL.configuration.getInstance().getDomElements().localVideo
            );
            AWL.webrtc.mediaSetStream(S, i);
          } else {
            AWL.console.error(
              "\ncallsession_9_1version :: LocalVideo DOM element not set to make video call"
            );
          }
          AWL.console.debug("Audio Tracks Id: " + o[0].id);
          AWL.remVideo = false;
        }
        if (m) {
          E();
        } else {
          L();
        }
      };
      this.evtMediaDeviceAccessFailed = function (S) {
        AWL.console.error(
          "\ncallsession_9_1version :: evtMediaDeviceAccessFailed"
        );
        f = CONST.AWL_MSG_CALL_FAILED;
        J.resetCall("Could not get access to audio device");
      };
      function k(W, U) {
        AWL.console.debug("evtRemoteStreamHandler: " + U.type);
        if (U.type === "audio") {
          AWL.call.utility.createAudioTag(M);
          var S = document.getElementById(M);
          AWL.webrtc.mediaSetStream(S, U.stream);
        } else {
          if (U.type === "video" || U.type === "audiovideo") {
            g = true;
            if (
              AWL.configuration.getInstance().getConfiguration().enableVideo
            ) {
              if (
                AWL.configuration.getInstance().getDomElements().localVideo !==
                ""
              ) {
                var V = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().localVideo
                );
                AWL.webrtc.mediaSetStream(V, i);
              }
            }
            if (
              AWL.configuration.getInstance().getDomElements().remoteVideo !==
              ""
            ) {
              var T = document.getElementById(
                AWL.configuration.getInstance().getDomElements().remoteVideo
              );
              AWL.webrtc.mediaSetStream(T, U.stream);
            }
          }
        }
      }
      function z(T, S) {
        AWL.console.debug("evtLocalDescriptionHandler");
        if (P) {
          if (K) {
            r = S.sdp;
            if (Q) {
              AWL.console.debug(
                "Send answer instead of earlyMediaAnswer: \n" + S.sdp
              );
              AWL.jsonRpc.call(AWL.serviceType, "answerCall", S.sdp, M);
            } else {
              AWL.console.debug("Answer EarlyMedia: \n" + S.sdp);
              AWL.jsonRpc.call(AWL.serviceType, "answerEarlyMedia", S.sdp, M);
            }
          } else {
            AWL.console.debug("Answer: \n" + S.sdp);
            AWL.jsonRpc.call(AWL.serviceType, "answerCall", S.sdp, M);
          }
        } else {
          if (navigator.mozGetUserMedia) {
            if (
              !g &&
              AWL.configuration.getInstance().getConfiguration().enableVideo
            ) {
              AWL.console.debug("Audio OnlyCall - mark video SDP inactive\n");
              S = c.getCustomLocalDescription("remVideo");
            }
          }
          AWL.callMap[M] = J;
          AWL.console.debug("Offer: \n" + S.sdp);
          AWL.jsonRpc.call(AWL.serviceType, "makeCall", q, S.sdp, M);
        }
      }
      function p(T, S) {
        AWL.console.debug("evtLocalCandidatesHandler: " + S);
      }
      function h(T, S) {
        T.srcObject = S.srcObject;
      }
      function t() {
        AWL.console.debug("callSession :: evtReattachingStreamHandler");
        if (
          AWL.configuration.getInstance().getDomElements().remoteVideo !== ""
        ) {
          var S = document.getElementById(
            AWL.configuration.getInstance().getDomElements().remoteVideo
          );
          h(S, S);
        }
      }
      function D() {
        if (
          !j &&
          (f === CONST.AWL_MSG_CALL_CONNECTED ||
            f === CONST.AWL_MSG_CALL_FAREND_UPDATE) &&
          H
        ) {
          H = false;
          j = !j;
          if (navigator.mozGetUserMedia) {
            F();
          } else {
            c.setCustomLocalDescription("hold", s);
            setTimeout(function () {
              c.setCustomRemoteDescription("hold", s, d);
            }, 100);
          }
          f = CONST.AWL_MSG_CALL_HELD;
          AWL.clientAPIConsole.debug("\ncallsession_9_1version: call is held");
          AWL.jsonRpc.call(AWL.serviceType, "hold", M);
          AWL.onCallStateChange.notify(M, v, f);
        } else {
          AWL.clientAPIConsole.error(
            "\ncallsession_9_1version: call is already in held state"
          );
        }
      }
      function n() {
        if (
          j &&
          (f === CONST.AWL_MSG_CALL_HELD ||
            f === CONST.AWL_MSG_CALL_FAREND_UPDATE) &&
          !H
        ) {
          AWL.callmanager_9_1version.getInstance().autoHoldIfRequired();
          H = true;
          j = !j;
          if (navigator.mozGetUserMedia) {
            F();
          } else {
            c.setCustomLocalDescription("unhold", s);
            setTimeout(function () {
              c.setCustomRemoteDescription("unhold", s, d);
            }, 100);
          }
          f = CONST.AWL_MSG_CALL_CONNECTED;
          AWL.clientAPIConsole.debug(
            "\ncallsession_9_1version: call is unheld"
          );
          AWL.jsonRpc.call(AWL.serviceType, "unhold", M);
          AWL.onCallStateChange.notify(M, v, f);
        } else {
          AWL.clientAPIConsole.error(
            "\ncallsession_9_1version: call is already in unheld state"
          );
        }
      }
      function u() {
        if (
          navigator.webkitGetUserMedia ||
          (navigator.mozGetUserMedia && !AWL.muteAllStreams)
        ) {
          o = i.getAudioTracks();
          if (o.length === 0) {
            AWL.console.debug("No local audio available.");
            return false;
          }
          if (!A) {
            for (var S = 0; S < o.length; S++) {
              o[S].enabled = false;
            }
            AWL.clientAPIConsole.debug("Audio muted.");
            A = !A;
            return true;
          }
        }
        return false;
      }
      function b() {
        if (
          navigator.webkitGetUserMedia ||
          (navigator.mozGetUserMedia && !AWL.muteAllStreams)
        ) {
          o = i.getAudioTracks();
          if (o.length === 0) {
            AWL.console.debug("No local audio available.");
            return false;
          }
          if (A) {
            for (var S = 0; S < o.length; S++) {
              o[S].enabled = true;
            }
            AWL.clientAPIConsole.debug("Audio unmuted.");
            A = !A;
            return true;
          }
        }
        return false;
      }
      function F() {
        o = i.getAudioTracks();
        if (o.length === 0) {
          AWL.clientAPIConsole.debug("No local audio available.");
          return;
        }
        if (!AWL.muteAllStreams) {
          if (!A) {
            for (var T = 0; T < o.length; T++) {
              o[T].enabled = false;
            }
          }
          AWL.clientAPIConsole.debug("toggleHoldControlMoz: Audio stopped");
          if (I !== null) {
            if (I.length !== 0) {
              for (var T = 0; T < I.length; T++) {
                I[T].enabled = false;
                var S = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().remoteVideo
                );
                S.pause();
              }
              AWL.clientAPIConsole.debug("toggleHoldControlMoz: Video stopped");
            }
          }
        } else {
          if (!A) {
            for (var T = 0; T < o.length; T++) {
              o[T].enabled = true;
            }
          }
          AWL.clientAPIConsole.debug("toggleHoldControlMoz: Audio resumed");
          if (I !== null) {
            if (I.length !== 0) {
              for (var T = 0; T < I.length; T++) {
                I[T].enabled = true;
                var S = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().remoteVideo
                );
                S.play();
              }
              AWL.clientAPIConsole.debug("toggleHoldControlMoz: Video resumed");
            }
          }
        }
        AWL.muteAllStreams = !AWL.muteAllStreams;
      }
      function l(T) {
        if (typeof T !== "undefined") {
          var S = T.indexOf("m=video");
          if (S === -1) {
            return false;
          }
          return true;
        }
        AWL.console.error("checkIfVideoCall: argument missing");
        return false;
      }
      function O(S) {
        if (S) {
          AWL.console.debug("Sent Dtmf tone: \t" + S.tone);
        }
      }
      function x(U) {
        var Y = U.indexOf("m=audio");
        var T = U.indexOf("m=video");
        var X = U.indexOf("a=sendrecv");
        var W = U.lastIndexOf("a=sendrecv");
        AWL.console.debug(
          "\n idxAud = " +
            Y +
            "\nidxVid = " +
            T +
            "\nidxFirst = " +
            X +
            "\nidxLast = " +
            W
        );
        if (T === -1) {
        } else {
          if (Y > T) {
            if (X != W && X > T && X < Y) {
              U = U.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
            } else {
              if (X === W && X > T && X < Y) {
                U = U.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                var S = U.slice(0, Y);
                var V = U.slice(Y);
                S = S.concat("a=inactive\r\n");
                U = S.concat(V);
              }
            }
          } else {
            if (X != W && X > Y && X < T) {
              var V = U.slice(0, T);
              var S = U.slice(T);
              S = S.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              U = V.concat(S);
            } else {
              if (X === W && X > Y && X > T) {
                U = U.replace(/a=sendrecv\r\n/, "a=inactive\r\n");
              } else {
                var V = U.slice(0, T);
                var S = U.slice(T);
                S = S.concat("a=inactive\r\n");
                U = V.concat(S);
              }
            }
          }
        }
        AWL.console.debug("Modified Audio Only SDP \n " + U);
        return U;
      }
      function E() {
        AWL.callmanager_9_1version.getInstance().autoHoldIfRequired();
        if (AWL.configuration.getInstance().getConfiguration().enableVideo) {
          if (typeof w === "undefined") {
            g = false;
          } else {
            if (w === "video") {
              g = true;
              if (
                AWL.configuration.getInstance().getDomElements().localVideo !=
                ""
              ) {
                var S = document.getElementById(
                  AWL.configuration.getInstance().getDomElements().localVideo
                );
                AWL.webrtc.mediaSetStream(S, i);
              } else {
                AWL.console.error(
                  "\ncallsession_9_1version :: LocalVideo DOM element not set to make video call"
                );
              }
            } else {
              g = false;
            }
          }
        }
        if (
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Stunserver.ip.trim().length !== 0 &&
          AWL.configuration
            .getInstance()
            .getConfiguration()
            .Turnserver.ip.trim().length !== 0
        ) {
          R.iceServers = [
            AWL.configuration.getInstance().getStunServerURL(),
            AWL.configuration.getInstance().getTurnServerURL(),
          ];
        } else {
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0
          ) {
            R.iceServers = [AWL.configuration.getInstance().getStunServerURL()];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Turnserver.ip.trim().length !== 0
            ) {
              R.iceServers = [
                AWL.configuration.getInstance().getTurnServerURL(),
              ];
            } else {
              R.iceServers = [];
            }
          }
        }
        H = true;
        c = new AWL.webrtc.PeerConnection();
        c.evtRemoteStream.attach(k);
        c.evtLocalCandidates.attach(p);
        c.evtLocalDescription.attach(z);
        if (navigator.webkitGetUserMedia) {
          c.evtReattachingStream.attach(t);
        }
        c.init({
          rtcConfiguration: R,
          constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
        });
        c.addStream(i);
        c.createOffer(
          function (T) {
            AWL.console.error(
              "callsession_9_1version: createOffer failed: " + T
            );
          },
          { optional: [{ MozDontOfferDataChannel: true }] }
        );
      }
      function L() {
        s = "passive";
        if (!K) {
          if (AWL.serviceType === CONST.AGENTSERVICE && !y) {
            K = true;
            AWL.clientAPIConsole.debug(
              "incomingCall ::  _earlyMediaAnswer set to TRUE"
            );
          }
          AWL.clientAPIConsole.debug(
            "\ncallsession_9_1version :: incomingcall()"
          );
          if (!AWL.registration.getInstance().isloggedIn()) {
            AWL.clientAPIConsole.error(
              "callmanager : Call not allowed as user is not logged in"
            );
            return;
          }
          if (AWL.totalCalls === CONST.MAX_ALLOWED_CALL_COUNT) {
            AWL.clientAPIConsole.error(
              "callmanager : MAX ALLOWED CALL LIMIT REACHED"
            );
            AWL.totalCalls--;
            f = CONST.AWL_MSG_CALL_FAILED;
            AWL.onCallStateChange.notify(M, v, f);
            AWL.onCallTerminate.notify(M, "Max call limit reached");
            return;
          }
          AWL.callmanager_9_1version.getInstance().autoHoldIfRequired();
          H = true;
          if (
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Stunserver.ip.trim().length !== 0 &&
            AWL.configuration
              .getInstance()
              .getConfiguration()
              .Turnserver.ip.trim().length !== 0
          ) {
            R.iceServers = [
              AWL.configuration.getInstance().getStunServerURL(),
              AWL.configuration.getInstance().getTurnServerURL(),
            ];
          } else {
            if (
              AWL.configuration
                .getInstance()
                .getConfiguration()
                .Stunserver.ip.trim().length !== 0
            ) {
              R.iceServers = [
                AWL.configuration.getInstance().getStunServerURL(),
              ];
            } else {
              if (
                AWL.configuration
                  .getInstance()
                  .getConfiguration()
                  .Turnserver.ip.trim().length !== 0
              ) {
                R.iceServers = [
                  AWL.configuration.getInstance().getTurnServerURL(),
                ];
              } else {
                R.iceServers = [];
              }
            }
          }
          c = new AWL.webrtc.PeerConnection();
          c.evtRemoteStream.attach(k);
          c.evtLocalCandidates.attach(p);
          c.evtLocalDescription.attach(z);
          if (navigator.webkitGetUserMedia) {
            c.evtReattachingStream.attach(t);
          }
          c.init({
            rtcConfiguration: R,
            constraints: { optional: [{ DtlsSrtpKeyAgreement: true }] },
          });
          c.addStream(i);
          var S = { sdp: P, type: "offer" };
          c.setRemoteDescription(
            S,
            function (T) {
              AWL.console.error("setRemoteDescriptionErrorHandler: " + T);
            },
            { optional: [{ MozDontOfferDataChannel: true }] }
          );
        } else {
          if (r !== null) {
            AWL.console.debug(
              "Early Media Answer sent already! Resend same SDP again in answer: \n" +
                r
            );
            AWL.jsonRpc.call(AWL.serviceType, "answerCall", r, M);
          } else {
            Q = true;
            AWL.console.debug(
              "Received answerCall but earlyMediaAnswer is not yet sent\n"
            );
          }
        }
      }
      function C(U) {
        if (U) {
          var S = U.indexOf("[");
          var T = U.indexOf("]");
          if (S !== -1 && T !== -1) {
            G = U.slice(0, S);
            B = U.slice(S + 1, T);
            AWL.console.debug(
              "callsession_9_1version: farEndName: " + G + "\tsubject: " + B
            );
          } else {
            G = U;
          }
        }
      }
    };
    return a;
  })()
);
var CONST = {
  AWL_VERSION: "11.1.1000-8",
  AWL_MSG_WEBRTC_NOTSUPPORTED: "AWL_MSG_WEBRTC_NOTSUPPORTED",
  AWL_MSG_WEBRTC_SUPPORTED: "AWL_MSG_WEBRTC_SUPPORTED",
  PHONESERVICE: "phoneservice",
  AGENTSERVICE: "agentservice",
  RELAYSERVICE: "relayservice",
  MAX_ALLOWED_CALL_COUNT: 3,
  AWL_MSG_SETCONFIG_SUCCESS: "AWL_MSG_SETCONFIG_SUCCESS",
  AWL_MSG_SETCONFIG_FAILED: "AWL_MSG_SETCONFIG_FAILED",
  AWL_MSG_SETDOM_SUCCESS: "AWL_MSG_SETDOM_SUCCESS",
  AWL_MSG_SETDOM_FAILED: "AWL_MSG_SETDOM_FAILED",
  AWL_MSG_LOGIN_EMPTYUSERNAME: "AWL_MSG_LOGIN_EMPTYUSERNAME",
  AWL_MSG_LOGIN_EMPTYPASSWORD: "AWL_MSG_LOGIN_EMPTYPASSWORD",
  AWL_MSG_LOGIN_EMPTYTOKEN: "AWL_MSG_LOGIN_EMPTYTOKEN",
  AWL_MSG_LOGIN_GW_NOTCONFIGURED: "AWL_MSG_LOGIN_GW_NOTCONFIGURED",
  AWL_MSG_LOGIN_SUCCESS: "AWL_MSG_LOGIN_SUCCESS",
  AWL_MSG_LOGIN_FAILED: "AWL_MSG_LOGIN_FAILED",
  AWL_MSG_LINK_ISSUE_DETECTED: "AWL_MSG_LINK_ISSUE_DETECTED",
  AWL_MSG_DUPLICATE_LOGIN: "AWL_MSG_DUPLICATE_LOGIN",
  AWL_MSG_LOGGEDOUT: "AWL_MSG_LOGGEDOUT",
  AWL_MSG_LOGIN_WEBSOCKET_FAILURE: "AWL_MSG_LOGIN_WEBSOCKET_FAILURE",
  AWL_MSG_DEVICEACCESS_FAILURE: "AWL_MSG_DEVICEACCESS_FAILURE",
  AWL_MSG_CALL_IDLE: "AWL_MSG_CALL_IDLE",
  AWL_MSG_CALL_PROGRESSING: "AWL_MSG_CALL_PROGRESSING",
  AWL_MSG_CALL_CONNECTED: "AWL_MSG_CALL_CONNECTED",
  AWL_MSG_CALL_DISCONNECTED: "AWL_MSG_CALL_DISCONNECTED",
  AWL_MSG_CALL_FAILED: "AWL_MSG_CALL_FAILED",
  AWL_MSG_CALL_INCOMING: "AWL_MSG_CALL_INCOMING",
  AWL_MSG_CALL_RINGING: "AWL_MSG_CALL_RINGING",
  AWL_MSG_CALL_HELD: "AWL_MSG_CALL_HELD",
  AWL_MSG_CALL_FAREND_UPDATE: "AWL_MSG_CALL_FAREND_UPDATE",
  AWL_MSG_CALL_MAXCAP_REACHED: "AWL_MSG_CALL_MAXCAP_REACHED",
  AWL_MSG_CALL_TRANSFER_FAILED: "AWL_MSG_CALL_TRANSFER_FAILED",
  AWL_MSG_LOOPBACK_CONN_SUCCESSFULL: "AWL_MSG_LOOPBACK_CONN_SUCCESSFULL",
  AWL_MSG_LOOPBACK_CONN_FAILED: "AWL_MSG_LOOPBACK_CONN_FAILED",
  AWL_MSG_LOOPBACK_CONN_LINK_ISSUE: "AWL_MSG_LOOPBACK_CONN_LINK_ISSUE",
  AWL_MSG_LOOPBACK_CONN_CLOSED: "AWL_MSG_LOOPBACK_CONN_CLOSED",
  AWL_MSG_LOOPBACK_STATS_FAILURE: "AWL_MSG_LOOPBACK_STATS_FAILURE",
  AWL_MSG_TOKEN_RENEW_SUCCESS: "AWL_MSG_TOKEN_RENEW_SUCCESS",
  AWL_MSG_TOKEN_RENEW_FAILED: "AWL_MSG_TOKEN_RENEW_FAILED",
  AWL_MSG_FAILING_OVER: "AWL_MSG_FAILING_OVER",
  AWL_MSG_FAILING_BACK: "AWL_MSG_FAILING_BACK",
  AWL_MSG_FAIL_OVER_SUCCESS: "AWL_MSG_FAIL_OVER_SUCCESS",
  AWL_MSG_FAIL_OVER_FAILED: "AWL_MSG_FAIL_OVER_FAILED",
  AWL_MSG_FAIL_BACK_SUCCESS: "AWL_MSG_FAIL_BACK_SUCCESS",
  AWL_MSG_FAIL_BACK_FAILED: "AWL_MSG_FAIL_BACK_FAILED",
  AWL_MSG_RECONNECTING: "AWL_MSG_RECONNECTING",
  AWL_MSG_RELOGGED_IN: "AWL_MSG_RELOGGED_IN",
  AWL_MSG_LOGIN_INVALID_TOKENTYPE: "AWL_MSG_LOGIN_INVALID_TOKENTYPE",
  AWL_MSG_SET_STUN_CONFIG_SUCCESS: "AWL_MSG_SET_STUN_CONFIG_SUCCESS",
  AWL_MSG_SET_STUN_CONFIG_FAILED: "AWL_MSG_SET_STUN_CONFIG_FAILED",
  RESILIENCY: "RESILIENCY",
  ESNA: "ESNA",
  SESSION: "SESSION",
};
AWL.newPackage(
  "com.avaya.awl.client",
  (function () {
    var a;
    var b = function () {
      var F = this;
      var I = AWL.configuration.getInstance();
      var J = AWL.registration.getInstance();
      var p = AWL.callmanager.getInstance();
      var M = AWL.loopBack.getInstance();
      var i = AWL.callmanager_9_1version.getInstance();
      var z = AWL.registration_11_0version.getInstance();
      AWL.sdkLog.disableLogging();
      AWL.clientLog.disableLogging();
      this.init = function () {
        AWL.serviceType = CONST.PHONESERVICE;
        AWL.onConfigChange = new AWL.callBack();
        AWL.onRegistrationStateChange = new AWL.callBack();
        AWL.onNewIncomingCall = new AWL.callBack();
        AWL.onCallStateChange = new AWL.callBack();
        AWL.onCallTerminate = new AWL.callBack();
        AWL.onLoopBackNotification = new AWL.callBack();
        AWL.onDeviceListRequested = new AWL.callBack();
        AWL.onVideoStreamsAvailable = new AWL.callBack();
        AWL.onAudioStreamsAvailable = new AWL.callBack();
        AWL.onAuthTokenRenewed = new AWL.callBack();
      };
      var N = function () {
        AWL.clientAPIConsole.debug("\nClient Api :: isWebRTCSupported");
        if (!AWL.webrtc.exists) {
          return CONST.AWL_MSG_WEBRTC_NOTSUPPORTED;
        }
        return CONST.AWL_MSG_WEBRTC_SUPPORTED;
      };
      var y = function () {
        AWL.clientAPIConsole.debug(
          "\nClient Api :: sdkVersion" + CONST.AWL_VERSION
        );
        return CONST.AWL_VERSION;
      };
      var v = function () {
        AWL.clientAPIConsole.debug("\nClient Api :: _generateAppInstanceID");
        var V;
        var U = new Uint32Array(1);
        window.crypto.getRandomValues(U);
        V = U[0];
        AWL.clientAPIConsole.info("\n**** Generated AppInstanceID: " + V);
        return V;
      };
      var q = function () {
        AWL.clientAPIConsole.debug("\nClient Api :: Logging Enabled");
        AWL.sdkLog.enableLogging();
        AWL.clientLog.enableLogging();
      };
      var D = function () {
        AWL.clientAPIConsole.debug("\nClient Api :: Logging Disabled");
        AWL.sdkLog.disableLogging();
        AWL.clientLog.disableLogging();
      };
      var l = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: Setting Log Object");
        AWL.console = U;
        AWL.clientAPIConsole = U;
      };
      var j = function (V, Y, X, U, W) {
        AWL.clientAPIConsole.debug("\nClient Api :: setConfiguration");
        F.init();
        if (
          typeof Y === "undefined" ||
          typeof X === "undefined" ||
          typeof U === "undefined" ||
          typeof W === "undefined"
        ) {
          if (typeof Y === "undefined") {
            AWL.clientAPIConsole.error(
              "\nClient Api :: setConfiguration - Mandatory config change callback missing"
            );
            AWL.onConfigChange.attach(onconfigStateChange);
          } else {
            AWL.onConfigChange.attach(Y);
          }
          if (typeof X === "undefined") {
            AWL.clientAPIConsole.error(
              "\nClient Api :: setConfiguration - Mandatory registration state change callback missing"
            );
            AWL.onRegistrationStateChange.attach(onRegistrationStateChange);
          } else {
            AWL.onRegistrationStateChange.attach(X);
          }
          if (typeof U === "undefined") {
            AWL.clientAPIConsole.error(
              "\nClient Api :: setConfiguration - Mandatory call state change callback missing"
            );
            AWL.onNewIncomingCall.attach(onCallListener);
            AWL.onCallStateChange.attach(onCallListener);
            AWL.onCallTerminate.attach(onCallListener);
            AWL.onLoopBackNotification.attach(onCallListener);
            if (AWL.inUse_Version !== AWL.SDK_VERSION.v9_1) {
              AWL.onVideoStreamsAvailable.attach(onCallListener);
              AWL.onAudioStreamsAvailable.attach(onCallListener);
            }
          } else {
            AWL.onNewIncomingCall.attach(U.onNewIncomingCall);
            AWL.onCallStateChange.attach(U.onCallStateChange);
            AWL.onCallTerminate.attach(U.onCallTerminate);
            AWL.onLoopBackNotification.attach(U.onLoopBackNotification);
            if (typeof U.onVideoStreamsAvailable !== "undefined") {
              if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
                AWL.clientAPIConsole.error(
                  "\nClient Api :: SDK Support for Video Stream Available Event Notifications is not available in 9.1 version"
                );
              } else {
                AWL.onVideoStreamsAvailable.attach(U.onVideoStreamsAvailable);
              }
            }
            if (typeof U.onAudioStreamsAvailable !== "undefined") {
              if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
                AWL.clientAPIConsole.error(
                  "\nClient Api :: SDK Support for Audio Stream Available Event Notifications is not available in 9.1 version"
                );
              } else {
                AWL.onAudioStreamsAvailable.attach(U.onAudioStreamsAvailable);
              }
            }
          }
          if (AWL.inUse_Version === AWL.SDK_VERSION.v11_0) {
            if (typeof W === "undefined") {
              AWL.clientAPIConsole.error(
                "\nClient Api :: setConfiguration - authentication token renewed callback missing"
              );
              AWL.onAuthTokenRenewed.attach(onAuthTokenRenewed);
            } else {
              AWL.onAuthTokenRenewed.attach(W);
            }
          }
        } else {
          AWL.onConfigChange.attach(Y);
          AWL.onRegistrationStateChange.attach(X);
          AWL.onNewIncomingCall.attach(U.onNewIncomingCall);
          AWL.onCallStateChange.attach(U.onCallStateChange);
          AWL.onCallTerminate.attach(U.onCallTerminate);
          AWL.onLoopBackNotification.attach(U.onLoopBackNotification);
          if (typeof U.onVideoStreamsAvailable !== "undefined") {
            if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
              AWL.clientAPIConsole.error(
                "\nClient Api :: SDK Support for Video Stream Available Event Notifications is not available in 9.1 version"
              );
            } else {
              AWL.onVideoStreamsAvailable.attach(U.onVideoStreamsAvailable);
            }
          }
          if (typeof U.onAudioStreamsAvailable !== "undefined") {
            if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
              AWL.clientAPIConsole.error(
                "\nClient Api :: SDK Support for Audio Stream Available Event Notifications is not available in 9.1 version"
              );
            } else {
              AWL.onAudioStreamsAvailable.attach(U.onAudioStreamsAvailable);
            }
          }
          if (typeof W !== "undefined") {
            if (
              AWL.inUse_Version === AWL.SDK_VERSION.v9_1 ||
              AWL.inUse_Version === AWL.SDK_VERSION.v10_0
            ) {
              AWL.clientAPIConsole.error(
                "\nClient Api :: Authentication Token support is available for version 11.0 and above"
              );
            } else {
              AWL.onAuthTokenRenewed.attach(W);
            }
          }
          AWL.clientAPIConsole.debug(
            "\nClient Api :: client callbacks registered - successfully"
          );
        }
        if (I.setConfiguration(V) === false) {
          AWL.clientAPIConsole.error("\nClient Api :: setConfiguration failed");
        } else {
          AWL.clientAPIConsole.debug(
            "\nClient Api :: setConfiguration success"
          );
        }
      };
      var d = function (U) {
        if (I.setDomElements(U) === false) {
          AWL.clientAPIConsole.error("\nClient Api :: setDomElements - FAILED");
        } else {
          AWL.clientAPIConsole.debug(
            "\nClient Api :: setDomElements - SUCCESS"
          );
        }
      };
      var R = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: getDeviceList");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          AWL.clientAPIConsole.error(
            "\nClient Api :: getDeviceList - Device enumeration is not supported in 9.1 version"
          );
          return;
        }
        if (typeof U === "undefined") {
          AWL.clientAPIConsole.error(
            "\nClient Api :: getDeviceList - Mandatory deviceListRequested callback missing"
          );
          AWL.onDeviceListRequested.attach(onDeviceListRequested);
        } else {
          AWL.onDeviceListRequested.attach(U);
        }
        AWL.devicemanager.getInstance().getDeviceInfo();
      };
      var h = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: setDeviceIds ");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          AWL.clientAPIConsole.error(
            "\nClient Api :: getDeviceList - Device enumeration is not supported in 9.1 version"
          );
          return;
        }
        if (I.setDeviceIds(U) === false) {
          AWL.clientAPIConsole.error("\nClient Api :: setDeviceIds - FAILED");
        } else {
          AWL.clientAPIConsole.debug("\nClient Api :: setDeviceIds - SUCCESS");
        }
      };
      var g = function (X, U, W, V) {
        AWL.clientAPIConsole.info("\nClient Api :: logIn" + W);
        if (N() === CONST.AWL_MSG_WEBRTC_SUPPORTED) {
          AWL.totalCalls = 0;
          if (typeof W === "undefined") {
            W = false;
          }
          if (typeof V === "undefined") {
            V = false;
          }
          if (J.logIn(X, U, W, V)) {
            AWL.clientAPIConsole.error(
              "\nClient Api :: logIn failed - invalid userName or password or GW IP set"
            );
          }
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: logIn failed - as Web RTC is not supported in this browser"
          );
        }
      };
      var m = function () {
        AWL.clientAPIConsole.info("\nClient Api :: logOut");
        J.logOut();
      };
      var Q = function () {
        var U = J.isloggedIn();
        AWL.clientAPIConsole.debug("\nClient Api :: _isloggedIn = " + U);
        return U;
      };
      var H = function (V, W) {
        AWL.clientAPIConsole.debug("\nClient Api :: makeCall");
        if (I.getConfiguration().serviceType !== CONST.RELAYSERVICE) {
          if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
            return i.makeCall(V, W);
          } else {
            if (AWL.inUse_Version === AWL.SDK_VERSION.v10_0) {
              return p.makeCall(V, W);
            } else {
              var U = z.getClientStatus();
              if (
                U === AWL.CLIENT_STATUS.NORMAL ||
                U === AWL.CLIENT_STATUS.FAILED_OVER ||
                U === AWL.CLIENT_STATUS.FAILED_BACK
              ) {
                return p.makeCall(V, W);
              } else {
                AWL.clientAPIConsole.error(
                  "\nClient Api :: makeCall denied as client is in " +
                    U.toLowerCase() +
                    " mode"
                );
                return null;
              }
            }
          }
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: makeCall denied in relay service"
          );
        }
      };
      var S = function (W, U, V) {
        AWL.clientAPIConsole.debug("\nClient Api :: transferCall");
        p.transferCall(W, U, V);
      };
      var A = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: answerCall");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.answerCall(U);
        } else {
          p.answerCall(U);
        }
      };
      var T = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: rejectCall");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.rejectCall(U);
        } else {
          p.rejectCall(U);
        }
      };
      var e = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: dropCall");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.dropCall(U);
        } else {
          p.dropCall(U);
        }
      };
      var E = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: cancelCall");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.cancelCall(U);
        } else {
          p.cancelCall(U);
        }
      };
      var P = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: doHold");
        if (AWL.inUse_Version === "9.1") {
          i.doHold(U);
        } else {
          p.doHold(U);
        }
      };
      var K = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: doUnHold");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.doUnHold(U);
        } else {
          p.doUnHold(U);
        }
      };
      var B = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: doMute");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          return i.doMute(U);
        } else {
          return p.doMute(U);
        }
      };
      var t = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: doUnMute");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          return i.doUnMute(U);
        } else {
          return p.doUnMute(U);
        }
      };
      var u = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: pauseVideo");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          return i.pauseVideo();
        } else {
          return p.pauseVideo(U);
        }
      };
      var r = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: playVideo");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          return i.playVideo();
        } else {
          return p.playVideo(U);
        }
      };
      var s = function (U, V) {
        AWL.clientAPIConsole.debug("\nClient Api :: sendDTMF");
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          i.sendDTMF(U, V);
        } else {
          p.sendDTMF(U, V);
        }
      };
      var k = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: getStats");
        return p.getStats(U);
      };
      var L = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: addVideo");
        p.addVideo(U);
      };
      var o = function (U) {
        AWL.clientAPIConsole.debug("\nClient Api :: removeVideo");
        p.removeVideo(U);
      };
      var w = function () {
        AWL.clientAPIConsole.debug("Client Api :: createLoopBackConnection");
        if (I.getConfiguration().serviceType === "relay") {
          var U = false;
          if (I.getDomElements().relayAudioTagId !== "") {
            if (
              document.getElementById(I.getDomElements().relayAudioTagId) ===
              null
            ) {
              AWL.clientAPIConsole.error(
                "Client Api :: createLoopBackConnection - invalid audio tag id"
              );
              return;
            }
          } else {
            AWL.clientAPIConsole.error(
              "Client Api :: createLoopBackConnection - Mandate audio tag id missing"
            );
            return;
          }
          if (J.isloggedIn()) {
            AWL.clientAPIConsole.debug(
              "Client Api :: creating loop back connection"
            );
            M.createLoopBackConnection();
          } else {
            AWL.clientAPIConsole.debug(
              "Client Api :: createLoopBackConnection not allowed as user is not logged in yet"
            );
          }
        } else {
          AWL.clientAPIConsole.error(
            "Client Api :: createLoopBackConnection not allowed as service type used is not relay"
          );
        }
      };
      var x = function () {
        AWL.clientAPIConsole.debug("Client Api :: endLoopBackConnection");
        M.endLoopBackConnection();
      };
      var n = function (Z, Y, W, V) {
        if (AWL.inUse_Version === AWL.SDK_VERSION.v9_1) {
          AWL.clientAPIConsole.error(
            "\nClient Api :: setMediaStream : No support in 9.1 version"
          );
          return;
        }
        if (
          typeof Z !== "undefined" &&
          typeof Y !== "undefined" &&
          typeof W !== "undefined" &&
          typeof V !== "undefined"
        ) {
          if (
            typeof AWL.callMap[W] !== "undefined" &&
            AWL.callMap[W].getCallState() === "AWL_MSG_CALL_CONNECTED"
          ) {
            AWL.clientAPIConsole.debug("Client Api :: setMediaStream");
            var X = AWL.callMap[W];
            if (!X.isDomElementSet()) {
              AWL.clientAPIConsole.debug(
                "Client Api :: setMediaStream : Configuring the Dom Elements"
              );
              var U = document.getElementById(Z) || Z;
              AWL.webrtc.mediaSetStream(U, Y);
              X.setDomElementForMedia(U, V);
            } else {
              AWL.clientAPIConsole.debug(
                "Client Api :: setMediaStream : Dom Elements are Configured Previously"
              );
            }
          }
        } else {
          AWL.clientAPIConsole.error(
            "Client Api :: setMediaStream : Invalid arguments"
          );
        }
      };
      var O = function () {
        AWL.clientAPIConsole.debug("Client Api :: getLoopBackStats");
        M.getLoopBackStats();
        return M.collectLoopBackStats();
      };
      var C = function () {
        AWL.clientAPIConsole.debug("Client Api :: _getAlternateServerConfig");
        if (AWL.inUse_Version !== AWL.SDK_VERSION.v11_0) {
          if (!J.isloggedIn()) {
            AWL.clientAPIConsole.warn(
              "Cannot fetch alternate gateway details as client is not logged in"
            );
          } else {
            AWL.clientAPIConsole.error(
              "Resiliency is not supported in versions earlier to 11.0"
            );
          }
          return null;
        }
        return z.getAlternateServerConfig();
      };
      var f = function (W, X, V, U) {
        AWL.clientAPIConsole.info("\nClient Api :: tokenLogIn : " + U);
        if (N() === CONST.AWL_MSG_WEBRTC_SUPPORTED) {
          AWL.totalCalls = 0;
          if (typeof U === "undefined") {
            U = false;
          }
          if (z.tokenLogIn(W, X, V, U)) {
            AWL.clientAPIConsole.error(
              "\nClient Api :: tokenLogIn failed - invalid userName or token or GW IP set"
            );
          }
        } else {
          AWL.clientAPIConsole.error(
            "\nClient Api :: tokenLogIn failed - as Web RTC is not supported in this browser"
          );
        }
      };
      var G = function (U) {
        AWL.clientAPIConsole.info(
          "\nClient Api :: setStunConfiguration: stun IP: " +
            U.ip +
            "\t stun port: " +
            U.port
        );
        if (I.setStunConfig(U, true) === true) {
          return CONST.AWL_MSG_SET_STUN_CONFIG_SUCCESS;
        } else {
          return CONST.AWL_MSG_SET_STUN_CONFIG_FAILED;
        }
      };
      var c = function () {
        AWL.clientAPIConsole.info("\nClient Api :: getStunConfiguration:");
        return I.getStunConfig();
      };
      return {
        isWebRTCSupported: N,
        getSdkVersion: y,
        generateAppInstanceID: v,
        setConfiguration: j,
        setLogObject: l,
        enableLogging: q,
        disableLogging: D,
        setDomElements: d,
        logIn: g,
        logOut: m,
        isloggedIn: Q,
        makeCall: H,
        answerCall: A,
        rejectCall: T,
        dropCall: e,
        cancelCall: E,
        doHold: P,
        doUnHold: K,
        doMute: B,
        doUnMute: t,
        pauseVideo: u,
        playVideo: r,
        sendDTMF: s,
        transferCall: S,
        getStats: k,
        addVideo: L,
        removeVideo: o,
        createLoopBackConnection: w,
        endLoopBackConnection: x,
        getLoopBackStats: O,
        setDeviceIds: h,
        getDeviceList: R,
        setMediaStream: n,
        getAlternateServerConfig: C,
        tokenLogIn: f,
        getStunConfiguration: c,
        setStunConfiguration: G,
      };
    };
    return b;
  })()
);
